var _k;
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _regeneratorRuntime() {
  "use strict";

  var r = _regenerator(),
    e = r.m(_regeneratorRuntime),
    t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
  function n(r) {
    var e = "function" == typeof r && r.constructor;
    return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
  }
  var o = {
    throw: 1,
    return: 2,
    break: 3,
    continue: 3
  };
  function a(r) {
    var e, t;
    return function (n) {
      e || (e = {
        stop: function stop() {
          return t(n.a, 2);
        },
        catch: function _catch() {
          return n.v;
        },
        abrupt: function abrupt(r, e) {
          return t(n.a, o[r], e);
        },
        delegateYield: function delegateYield(r, o, a) {
          return e.resultName = o, t(n.d, _regeneratorValues(r), a);
        },
        finish: function finish(r) {
          return t(n.f, r);
        }
      }, t = function t(r, _t2, o) {
        n.p = e.prev, n.n = e.next;
        try {
          return r(_t2, o);
        } finally {
          e.next = n.n;
        }
      }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
      try {
        return r.call(this, e);
      } finally {
        n.p = e.prev, n.n = e.next;
      }
    };
  }
  return (_regeneratorRuntime = function _regeneratorRuntime() {
    return {
      wrap: function wrap(e, t, n, o) {
        return r.w(a(e), t, n, o && o.reverse());
      },
      isGeneratorFunction: n,
      mark: r.m,
      awrap: function awrap(r, e) {
        return new _OverloadYield(r, e);
      },
      AsyncIterator: _regeneratorAsyncIterator,
      async: function async(r, e, t, o, u) {
        return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u);
      },
      keys: _regeneratorKeys,
      values: _regeneratorValues
    };
  })();
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
function _regeneratorAsync(n, e, r, t, o) {
  var a = _regeneratorAsyncGen(n, e, r, t, o);
  return a.next().then(function (n) {
    return n.done ? n.value : a.next();
  });
}
function _regeneratorAsyncGen(r, e, t, o, n) {
  return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise);
}
function _regeneratorAsyncIterator(t, e) {
  function n(r, o, i, f) {
    try {
      var c = t[r](o),
        u = c.value;
      return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) {
        n("next", t, i, f);
      }, function (t) {
        n("throw", t, i, f);
      }) : e.resolve(u).then(function (t) {
        c.value = t, i(c);
      }, function (t) {
        return n("throw", t, i, f);
      });
    } catch (t) {
      f(t);
    }
  }
  var r;
  this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
    return this;
  })), _regeneratorDefine2(this, "_invoke", function (t, o, i) {
    function f() {
      return new e(function (e, r) {
        n(t, i, e, r);
      });
    }
    return r = r ? r.then(f, f) : f();
  }, !0);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };
      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2(e, r, n, t);
}
function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n4 = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n4 >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n4++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { getEnvKeystrokeText as Y, uid as Q, env as A, delay as Lt, createElement as x, KeystrokeHandler as E, FocusTracker as b, toUnit as te, global as d, Rect as T, DomEmitterMixin as ie, ObservableMixin as se, Collection as pe, isIterable as xe, CKEditorError as v, getOptimalPosition as me, logWarning as C, EmitterMixin as Ze, getVisualViewportOffset as K, isVisible as O, isNode as Je, priorities as Ft, isText as At, ResizeObserver as et, toArray as oe, first as Dt, parseBase64EncodedObject as tt, isRange as St } from "../../../../../@ckeditor_ckeditor5-utils@45.2.1/node_modules/@ckeditor/ckeditor5-utils/dist/index.js";
import { Plugin as we, ContextPlugin as Mt } from "../../../../../@ckeditor_ckeditor5-core@45.2.1/node_modules/@ckeditor/ckeditor5-core/dist/index.js";
import { IconAccessibility as Ee, IconCancel as it, IconDropdownArrow as ne, IconDragIndicator as Nt, IconPilcrow as Wt, IconThreeVerticalDots as be, IconText as Gt, IconPlus as Rt, IconParagraph as Ht, IconImportExport as zt, IconBold as Ut, IconAlignLeft as $t, IconCheck as st, IconPreviousArrow as Kt, IconNextArrow as jt, IconColorPalette as Xt, IconEraser as qt, IconProjectLogo as Yt, IconColorTileCheck as Qt } from "../../../../../@ckeditor_ckeditor5-icons@45.2.1/node_modules/@ckeditor/ckeditor5-icons/dist/index.js";
import Ie from "../../../../../color-parse@1.4.2/node_modules/color-parse/index.js";
import * as ot from "../../../../../../../_virtual/index.js";
import { HexBase as Zt } from "../../../../../vanilla-colorful@0.7.2/node_modules/vanilla-colorful/lib/entrypoints/hex.js";
import "../../../../../@ckeditor_ckeditor5-engine@45.2.1/node_modules/@ckeditor/ckeditor5-engine/dist/index.js";
import { assignIn as Jt } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/object/assignIn.js";
import { isObject as Z } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/predicate/isObject.js";
import { cloneDeep as ge } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/object/cloneDeep.js";
import { debounce as fe } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/function/debounce.js";
import { isElement as _e } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/predicate/isElement.js";
import { cloneDeepWith as ei } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/object/cloneDeepWith.js";
import { throttle as ti } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/function/throttle.js"; /**
                                                                                                                            * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
                                                                                                                            * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
                                                                                                                            */
var B = /*#__PURE__*/function (_pe) {
  function B() {
    var _this;
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    _classCallCheck(this, B);
    _this = _callSuper(this, B, [e, {
      idProperty: "viewUid"
    }]), _defineProperty(_assertThisInitialized(_this), "_parentElement", void 0), _this.on("add", function (t, i, o) {
      _this._renderViewIntoCollectionParent(i, o);
    }), _this.on("remove", function (t, i) {
      i.element && _this._parentElement && i.element.remove();
    }), _this._parentElement = null;
    return _this;
  }
  _inherits(B, _pe);
  return _createClass(B, [{
    key: "destroy",
    value: function destroy() {
      this.map(function (e) {
        return e.destroy();
      });
    }
  }, {
    key: "setParent",
    value: function setParent(e) {
      this._parentElement = e;
      var _iterator = _createForOfIteratorHelper(this),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var t = _step.value;
          this._renderViewIntoCollectionParent(t);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "delegate",
    value: function delegate() {
      var _this2 = this;
      for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
        e[_key] = arguments[_key];
      }
      if (!e.length || !ii(e)) throw new v("ui-viewcollection-delegate-wrong-events", this);
      return {
        to: function to(t) {
          var _iterator2 = _createForOfIteratorHelper(_this2),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var i = _step2.value;
              for (var _i4 = 0, _e4 = e; _i4 < _e4.length; _i4++) {
                var o = _e4[_i4];
                i.delegate(o).to(t);
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          _this2.on("add", function (i, o) {
            for (var _i2 = 0, _e2 = e; _i2 < _e2.length; _i2++) {
              var n = _e2[_i2];
              o.delegate(n).to(t);
            }
          }), _this2.on("remove", function (i, o) {
            for (var _i3 = 0, _e3 = e; _i3 < _e3.length; _i3++) {
              var n = _e3[_i3];
              o.stopDelegating(n, t);
            }
          });
        }
      };
    }
  }, {
    key: "_renderViewIntoCollectionParent",
    value: function _renderViewIntoCollectionParent(e, t) {
      e.isRendered || e.render(), e.element && this._parentElement && this._parentElement.insertBefore(e.element, this._parentElement.children[t]);
    }
  }, {
    key: "remove",
    value: function remove(e) {
      return _superPropGet(B, "remove", this, 3)([e]);
    }
  }]);
}(pe);
function ii(s) {
  return s.every(function (e) {
    return typeof e == "string";
  });
}
var si = "http://www.w3.org/1999/xhtml";
var V = /*#__PURE__*/function (_Ze) {
  function V(e) {
    var _this3;
    _classCallCheck(this, V);
    _this3 = _callSuper(this, V), _defineProperty(_assertThisInitialized(_this3), "ns", void 0), _defineProperty(_assertThisInitialized(_this3), "tag", void 0), _defineProperty(_assertThisInitialized(_this3), "text", void 0), _defineProperty(_assertThisInitialized(_this3), "attributes", void 0), _defineProperty(_assertThisInitialized(_this3), "children", void 0), _defineProperty(_assertThisInitialized(_this3), "eventListeners", void 0), _defineProperty(_assertThisInitialized(_this3), "_isRendered", void 0), _defineProperty(_assertThisInitialized(_this3), "_revertData", void 0), Object.assign(_assertThisInitialized(_this3), Pe(Oe(e))), _this3._isRendered = !1, _this3._revertData = null;
    return _this3;
  }
  _inherits(V, _Ze);
  return _createClass(V, [{
    key: "render",
    value: function render() {
      var e = this._renderNode({
        intoFragment: !0
      });
      return this._isRendered = !0, e;
    }
  }, {
    key: "apply",
    value: function apply(e) {
      return this._revertData = Fe(), this._renderNode({
        node: e,
        intoFragment: !1,
        isApplying: !0,
        revertData: this._revertData
      }), e;
    }
  }, {
    key: "revert",
    value: function revert(e) {
      if (!this._revertData) throw new v("ui-template-revert-not-applied", [this, e]);
      this._revertTemplateFromNode(e, this._revertData);
    }
  }, {
    key: "getViews",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function getViews() {
      var _marked, e;
      return _regeneratorRuntime().wrap(function getViews$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            e = function _e5(t) {
              var _iterator3, _step3, i;
              return _regeneratorRuntime().wrap(function e$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (!t.children) {
                      _context.next = 24;
                      break;
                    }
                    _iterator3 = _createForOfIteratorHelper(t.children);
                    _context.prev = 2;
                    _iterator3.s();
                  case 4:
                    if ((_step3 = _iterator3.n()).done) {
                      _context.next = 16;
                      break;
                    }
                    i = _step3.value;
                    if (!J(i)) {
                      _context.next = 11;
                      break;
                    }
                    _context.next = 9;
                    return i;
                  case 9:
                    _context.next = 14;
                    break;
                  case 11:
                    _context.t0 = ke(i);
                    if (!_context.t0) {
                      _context.next = 14;
                      break;
                    }
                    return _context.delegateYield(e(i), "t1", 14);
                  case 14:
                    _context.next = 4;
                    break;
                  case 16:
                    _context.next = 21;
                    break;
                  case 18:
                    _context.prev = 18;
                    _context.t2 = _context["catch"](2);
                    _iterator3.e(_context.t2);
                  case 21:
                    _context.prev = 21;
                    _iterator3.f();
                    return _context.finish(21);
                  case 24:
                  case "end":
                    return _context.stop();
                }
              }, _marked, null, [[2, 18, 21, 24]]);
            };
            _marked = /*#__PURE__*/_regeneratorRuntime().mark(e);
            return _context2.delegateYield(e(this), "t0", 3);
          case 3:
          case "end":
            return _context2.stop();
        }
      }, getViews, this);
    })
  }, {
    key: "_renderNode",
    value: function _renderNode(e) {
      var t;
      if (e.node ? t = this.tag && this.text : t = this.tag ? this.text : !this.text, t) throw new v("ui-template-wrong-syntax", this);
      return this.text ? this._renderText(e) : this._renderElement(e);
    }
  }, {
    key: "_renderElement",
    value: function _renderElement(e) {
      var t = e.node;
      return t || (t = e.node = document.createElementNS(this.ns || si, this.tag)), this._renderAttributes(e), this._renderElementChildren(e), this._setUpListeners(e), t;
    }
  }, {
    key: "_renderText",
    value: function _renderText(e) {
      var t = e.node;
      return t ? e.revertData.text = t.textContent : t = e.node = document.createTextNode(""), j(this.text) ? this._bindToObservable({
        schema: this.text,
        updater: ri(t),
        data: e
      }) : t.textContent = this.text.join(""), t;
    }
  }, {
    key: "_renderAttributes",
    value: function _renderAttributes(e) {
      if (!this.attributes) return;
      var t = e.node,
        i = e.revertData;
      for (var o in this.attributes) {
        var n = t.getAttribute(o),
          r = this.attributes[o];
        i && (i.attributes[o] = n);
        var a = Le(r) ? r[0].ns : null;
        if (j(r)) {
          var l = Le(r) ? r[0].value : r;
          i && Ae(o) && l.unshift(n), this._bindToObservable({
            schema: l,
            updater: li(t, o, a),
            data: e
          });
        } else if (o == "style" && typeof r[0] != "string") this._renderStyleAttribute(r[0], e);else {
          i && n && Ae(o) && r.unshift(n);
          var _l = r.map(function (c) {
            return c && (c.value || c);
          }).reduce(function (c, u) {
            return c.concat(u);
          }, []).reduce(at, "");
          M(_l) || t.setAttributeNS(a, o, _l);
        }
      }
    }
  }, {
    key: "_renderStyleAttribute",
    value: function _renderStyleAttribute(e, t) {
      var i = t.node;
      for (var o in e) {
        var n = e[o];
        j(n) ? this._bindToObservable({
          schema: [n],
          updater: ai(i, o),
          data: t
        }) : i.style[o] = n;
      }
    }
  }, {
    key: "_renderElementChildren",
    value: function _renderElementChildren(e) {
      var t = e.node,
        i = e.intoFragment ? document.createDocumentFragment() : t,
        o = e.isApplying;
      var n = 0;
      var _iterator4 = _createForOfIteratorHelper(this.children),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var r = _step4.value;
          if (Te(r)) {
            if (!o) {
              r.setParent(t);
              var _iterator5 = _createForOfIteratorHelper(r),
                _step5;
              try {
                for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                  var a = _step5.value;
                  i.appendChild(a.element);
                }
              } catch (err) {
                _iterator5.e(err);
              } finally {
                _iterator5.f();
              }
            }
          } else if (J(r)) o || (r.isRendered || r.render(), i.appendChild(r.element));else if (Je(r)) i.appendChild(r);else if (o) {
            var _a = e.revertData,
              l = Fe();
            _a.children.push(l), r._renderNode({
              intoFragment: !1,
              node: i.childNodes[n++],
              isApplying: !0,
              revertData: l
            });
          } else i.appendChild(r.render());
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      e.intoFragment && t.appendChild(i);
    }
  }, {
    key: "_setUpListeners",
    value: function _setUpListeners(e) {
      var _this4 = this;
      if (this.eventListeners) {
        var _loop = function _loop(t) {
          var i = _this4.eventListeners[t].map(function (o) {
            var _t$split = t.split("@"),
              _t$split2 = _slicedToArray(_t$split, 2),
              n = _t$split2[0],
              r = _t$split2[1];
            return o.activateDomEventListener(n, r, e);
          });
          e.revertData && e.revertData.bindings.push(i);
        };
        for (var t in this.eventListeners) {
          _loop(t);
        }
      }
    }
  }, {
    key: "_bindToObservable",
    value: function _bindToObservable(_ref) {
      var e = _ref.schema,
        t = _ref.updater,
        i = _ref.data;
      var o = i.revertData;
      rt(e, t, i);
      var n = e.filter(function (r) {
        return !M(r);
      }).filter(function (r) {
        return r.observable;
      }).map(function (r) {
        return r.activateAttributeListener(e, t, i);
      });
      o && o.bindings.push(n);
    }
  }, {
    key: "_revertTemplateFromNode",
    value: function _revertTemplateFromNode(e, t) {
      var _iterator6 = _createForOfIteratorHelper(t.bindings),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _o3 = _step6.value;
          var _iterator7 = _createForOfIteratorHelper(_o3),
            _step7;
          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var _n = _step7.value;
              _n();
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      if (t.text) {
        e.textContent = t.text;
        return;
      }
      var i = e;
      for (var o in t.attributes) {
        var n = t.attributes[o];
        n === null ? i.removeAttribute(o) : i.setAttribute(o, n);
      }
      for (var _o2 = 0; _o2 < t.children.length; ++_o2) this._revertTemplateFromNode(i.childNodes[_o2], t.children[_o2]);
    }
  }], [{
    key: "bind",
    value: function bind(e, t) {
      return {
        to: function to(i, o) {
          return new oi({
            eventNameOrFunction: i,
            attribute: i,
            observable: e,
            emitter: t,
            callback: o
          });
        },
        if: function _if(i, o, n) {
          return new nt({
            observable: e,
            emitter: t,
            attribute: i,
            valueIfTrue: o,
            callback: n
          });
        }
      };
    }
  }, {
    key: "extend",
    value: function extend(e, t) {
      if (e._isRendered) throw new v("template-extend-render", [this, e]);
      ct(e, Pe(Oe(t)));
    }
  }]);
}(Ze());
var H = /*#__PURE__*/function () {
  function H(e) {
    _classCallCheck(this, H);
    _defineProperty(this, "attribute", void 0);
    _defineProperty(this, "observable", void 0);
    _defineProperty(this, "emitter", void 0);
    _defineProperty(this, "callback", void 0);
    this.attribute = e.attribute, this.observable = e.observable, this.emitter = e.emitter, this.callback = e.callback;
  }
  return _createClass(H, [{
    key: "getValue",
    value: function getValue(e) {
      var t = this.observable[this.attribute];
      return this.callback ? this.callback(t, e) : t;
    }
  }, {
    key: "activateAttributeListener",
    value: function activateAttributeListener(e, t, i) {
      var _this5 = this;
      var o = function o() {
        return rt(e, t, i);
      };
      return this.emitter.listenTo(this.observable, "change:".concat(this.attribute), o), function () {
        _this5.emitter.stopListening(_this5.observable, "change:".concat(_this5.attribute), o);
      };
    }
  }]);
}();
var oi = /*#__PURE__*/function (_H2) {
  function oi(e) {
    var _this6;
    _classCallCheck(this, oi);
    _this6 = _callSuper(this, oi, [e]), _defineProperty(_assertThisInitialized(_this6), "eventNameOrFunction", void 0), _this6.eventNameOrFunction = e.eventNameOrFunction;
    return _this6;
  }
  _inherits(oi, _H2);
  return _createClass(oi, [{
    key: "activateDomEventListener",
    value: function activateDomEventListener(e, t, i) {
      var _this7 = this;
      var o = function o(n, r) {
        (!t || r.target.matches(t)) && (typeof _this7.eventNameOrFunction == "function" ? _this7.eventNameOrFunction(r) : _this7.observable.fire(_this7.eventNameOrFunction, r));
      };
      return this.emitter.listenTo(i.node, e, o), function () {
        _this7.emitter.stopListening(i.node, e, o);
      };
    }
  }]);
}(H);
var nt = /*#__PURE__*/function (_H3) {
  function nt(e) {
    var _this8;
    _classCallCheck(this, nt);
    _this8 = _callSuper(this, nt, [e]), _defineProperty(_assertThisInitialized(_this8), "valueIfTrue", void 0), _this8.valueIfTrue = e.valueIfTrue;
    return _this8;
  }
  _inherits(nt, _H3);
  return _createClass(nt, [{
    key: "getValue",
    value: function getValue(e) {
      var t = _superPropGet(nt, "getValue", this, 3)([e]);
      return M(t) ? !1 : this.valueIfTrue || !0;
    }
  }]);
}(H);
function j(s) {
  return s ? (s.value && (s = s.value), Array.isArray(s) ? s.some(j) : s instanceof H) : !1;
}
function ni(s, e) {
  return s.map(function (t) {
    return t instanceof H ? t.getValue(e) : t;
  });
}
function rt(s, e, _ref2) {
  var t = _ref2.node;
  var i = ni(s, t);
  var o;
  s.length == 1 && s[0] instanceof nt ? o = i[0] : o = i.reduce(at, ""), M(o) ? e.remove() : e.set(o);
}
function ri(s) {
  return {
    set: function set(e) {
      s.textContent = e;
    },
    remove: function remove() {
      s.textContent = "";
    }
  };
}
function li(s, e, t) {
  return {
    set: function set(i) {
      s.setAttributeNS(t, e, i);
    },
    remove: function remove() {
      s.removeAttributeNS(t, e);
    }
  };
}
function ai(s, e) {
  return {
    set: function set(t) {
      s.style[e] = t;
    },
    remove: function remove() {
      s.style[e] = null;
    }
  };
}
function Oe(s) {
  return ei(s, function (t) {
    if (t && (t instanceof H || ke(t) || J(t) || Te(t))) return t;
  });
}
function Pe(s) {
  if (typeof s == "string" ? s = ui(s) : s.text && di(s), s.on && (s.eventListeners = hi(s.on), delete s.on), !s.text) {
    s.attributes && ci(s.attributes);
    var _e6 = [];
    if (s.children) if (Te(s.children)) _e6.push(s.children);else {
      var _iterator8 = _createForOfIteratorHelper(s.children),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var t = _step8.value;
          ke(t) || J(t) || Je(t) ? _e6.push(t) : _e6.push(new V(t));
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
    s.children = _e6;
  }
  return s;
}
function ci(s) {
  for (var _e7 in s) s[_e7].value && (s[_e7].value = oe(s[_e7].value)), lt(s, _e7);
}
function hi(s) {
  for (var _e8 in s) lt(s, _e8);
  return s;
}
function ui(s) {
  return {
    text: [s]
  };
}
function di(s) {
  s.text = oe(s.text);
}
function lt(s, e) {
  s[e] = oe(s[e]);
}
function at(s, e) {
  return M(e) ? s : M(s) ? e : "".concat(s, " ").concat(e);
}
function Be(s, e) {
  for (var t in e) {
    var _s$t;
    s[t] ? (_s$t = s[t]).push.apply(_s$t, _toConsumableArray(e[t])) : s[t] = e[t];
  }
}
function ct(s, e) {
  var _s$text;
  if (e.attributes && (s.attributes || (s.attributes = {}), Be(s.attributes, e.attributes)), e.eventListeners && (s.eventListeners || (s.eventListeners = {}), Be(s.eventListeners, e.eventListeners)), e.text && (_s$text = s.text).push.apply(_s$text, _toConsumableArray(e.text)), e.children && e.children.length) {
    if (s.children.length != e.children.length) throw new v("ui-template-extend-children-mismatch", s);
    var t = 0;
    var _iterator9 = _createForOfIteratorHelper(e.children),
      _step9;
    try {
      for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
        var i = _step9.value;
        ct(s.children[t++], i);
      }
    } catch (err) {
      _iterator9.e(err);
    } finally {
      _iterator9.f();
    }
  }
}
function M(s) {
  return !s && s !== 0;
}
function J(s) {
  return s instanceof h;
}
function ke(s) {
  return s instanceof V;
}
function Te(s) {
  return s instanceof B;
}
function Le(s) {
  return Z(s[0]) && s[0].ns;
}
function Fe() {
  return {
    children: [],
    bindings: [],
    attributes: {}
  };
}
function Ae(s) {
  return s == "class" || s == "style";
}
var h = /*#__PURE__*/function (_ie) {
  function h(e) {
    var _this9;
    _classCallCheck(this, h);
    _this9 = _callSuper(this, h), _defineProperty(_assertThisInitialized(_this9), "element", void 0), _defineProperty(_assertThisInitialized(_this9), "isRendered", void 0), _defineProperty(_assertThisInitialized(_this9), "locale", void 0), _defineProperty(_assertThisInitialized(_this9), "t", void 0), _defineProperty(_assertThisInitialized(_this9), "template", void 0), _defineProperty(_assertThisInitialized(_this9), "_viewCollections", void 0), _defineProperty(_assertThisInitialized(_this9), "_unboundChildren", void 0), _defineProperty(_assertThisInitialized(_this9), "_bindTemplate", void 0), _this9.element = null, _this9.isRendered = !1, _this9.locale = e, _this9.t = e && e.t, _this9._viewCollections = new pe(), _this9._unboundChildren = _this9.createCollection(), _this9._viewCollections.on("add", function (t, i) {
      i.locale = e, i.t = e && e.t;
    }), _this9.decorate("render");
    return _this9;
  }
  _inherits(h, _ie);
  return _createClass(h, [{
    key: "bindTemplate",
    get: function get() {
      return this._bindTemplate ? this._bindTemplate : this._bindTemplate = V.bind(this, this);
    }
  }, {
    key: "createCollection",
    value: function createCollection(e) {
      var t = new B(e);
      return this._viewCollections.add(t), t;
    }
  }, {
    key: "registerChild",
    value: function registerChild(e) {
      xe(e) || (e = [e]);
      var _iterator0 = _createForOfIteratorHelper(e),
        _step0;
      try {
        for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
          var t = _step0.value;
          this._unboundChildren.add(t);
        }
      } catch (err) {
        _iterator0.e(err);
      } finally {
        _iterator0.f();
      }
    }
  }, {
    key: "deregisterChild",
    value: function deregisterChild(e) {
      xe(e) || (e = [e]);
      var _iterator1 = _createForOfIteratorHelper(e),
        _step1;
      try {
        for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
          var t = _step1.value;
          this._unboundChildren.remove(t);
        }
      } catch (err) {
        _iterator1.e(err);
      } finally {
        _iterator1.f();
      }
    }
  }, {
    key: "setTemplate",
    value: function setTemplate(e) {
      this.template = new V(e);
    }
  }, {
    key: "extendTemplate",
    value: function extendTemplate(e) {
      V.extend(this.template, e);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.isRendered) throw new v("ui-view-render-already-rendered", this);
      this.template && (this.element = this.template.render(), this.registerChild(this.template.getViews())), this.isRendered = !0;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.stopListening(), this._viewCollections.map(function (e) {
        return e.destroy();
      }), this.template && this.template._revertData && this.template.revert(this.element);
    }
  }]);
}(ie(se()));
/**
* @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/
function ht(_ref3) {
  var s = _ref3.emitter,
    e = _ref3.activator,
    t = _ref3.callback,
    i = _ref3.contextElements,
    o = _ref3.listenerOptions;
  s.listenTo(document, "mousedown", function (n, r) {
    if (!e()) return;
    var a = typeof r.composedPath == "function" ? r.composedPath() : [],
      l = typeof i == "function" ? i() : i;
    var _iterator10 = _createForOfIteratorHelper(l),
      _step10;
    try {
      for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
        var c = _step10.value;
        if (c.contains(r.target) || a.includes(c)) return;
      }
    } catch (err) {
      _iterator10.e(err);
    } finally {
      _iterator10.f();
    }
    t();
  }, o);
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function eo(s) {
  var e = /*#__PURE__*/function (_s2) {
    function e() {
      var _this0;
      _classCallCheck(this, e);
      for (var _len2 = arguments.length, i = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        i[_key2] = arguments[_key2];
      }
      _this0 = _callSuper(this, e, [].concat(i)), _this0.set("_isCssTransitionsDisabled", !1), _this0.initializeCssTransitionDisablerMixin();
      return _this0;
    }
    _inherits(e, _s2);
    return _createClass(e, [{
      key: "disableCssTransitions",
      value: function disableCssTransitions() {
        this._isCssTransitionsDisabled = !0;
      }
    }, {
      key: "enableCssTransitions",
      value: function enableCssTransitions() {
        this._isCssTransitionsDisabled = !1;
      }
    }, {
      key: "initializeCssTransitionDisablerMixin",
      value: function initializeCssTransitionDisablerMixin() {
        this.extendTemplate({
          attributes: {
            class: [this.bindTemplate.if("_isCssTransitionsDisabled", "ck-transitions-disabled")]
          }
        });
      }
    }]);
  }(s);
  return e;
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function to(_ref4) {
  var s = _ref4.view;
  s.listenTo(s.element, "submit", function (e, t) {
    t.preventDefault(), s.fire("submit");
  }, {
    useCapture: !0
  });
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function fi(_ref5) {
  var s = _ref5.keystrokeHandler,
    e = _ref5.focusTracker,
    t = _ref5.gridItems,
    i = _ref5.numberOfColumns,
    o = _ref5.uiLanguageDirection;
  var n = typeof i == "number" ? function () {
    return i;
  } : i;
  s.set("arrowright", r(function (c, u) {
    return o === "rtl" ? l(c, u.length) : a(c, u.length);
  })), s.set("arrowleft", r(function (c, u) {
    return o === "rtl" ? a(c, u.length) : l(c, u.length);
  })), s.set("arrowup", r(function (c, u) {
    var f = c - n();
    return f < 0 && (f = c + n() * Math.floor(u.length / n()), f > u.length - 1 && (f -= n())), f;
  })), s.set("arrowdown", r(function (c, u) {
    var f = c + n();
    return f > u.length - 1 && (f = c % n()), f;
  }));
  function r(c) {
    return function (u) {
      var f = t.find(function (Bt) {
          return Bt.element === e.focusedElement;
        }),
        w = t.getIndex(f),
        F = c(w, t);
      t.get(F).focus(), u.stopPropagation(), u.preventDefault();
    };
  }
  function a(c, u) {
    return c === u - 1 ? 0 : c + 1;
  }
  function l(c, u) {
    return c === 0 ? u - 1 : c - 1;
  }
}
var L = /*#__PURE__*/function (_h2) {
  function L() {
    var _this1;
    _classCallCheck(this, L);
    _this1 = _callSuper(this, L);
    var e = _this1.bindTemplate;
    _this1.set("content", ""), _this1.set("viewBox", "0 0 20 20"), _this1.set("fillColor", ""), _this1.set("isColorInherited", !0), _this1.set("isVisible", !0), _this1.setTemplate({
      tag: "svg",
      ns: "http://www.w3.org/2000/svg",
      attributes: {
        class: ["ck", "ck-icon", e.if("isVisible", "ck-hidden", function (t) {
          return !t;
        }), "ck-reset_all-excluded", e.if("isColorInherited", "ck-icon_inherit-color")],
        viewBox: e.to("viewBox"),
        "aria-hidden": !0
      }
    });
    return _this1;
  }
  _inherits(L, _h2);
  return _createClass(L, [{
    key: "render",
    value: function render() {
      var _this10 = this;
      _superPropGet(L, "render", this, 3)([]), this._updateXMLContent(), this._colorFillPaths(), this.on("change:content", function () {
        _this10._updateXMLContent(), _this10._colorFillPaths();
      }), this.on("change:fillColor", function () {
        _this10._colorFillPaths();
      });
    }
  }, {
    key: "_updateXMLContent",
    value: function _updateXMLContent() {
      if (this.content) {
        var t = new DOMParser().parseFromString(this.content.trim(), "image/svg+xml").querySelector("svg");
        if (!t) throw new v("ui-iconview-invalid-svg", this);
        var i = t.getAttribute("viewBox");
        i && (this.viewBox = i);
        for (var _i5 = 0, _Array$from = Array.from(t.attributes); _i5 < _Array$from.length; _i5++) {
          var _ref6 = _Array$from[_i5];
          var o = _ref6.name;
          var n = _ref6.value;
          L.presentationalAttributeNames.includes(o) && this.element.setAttribute(o, n);
        }
        for (; this.element.firstChild;) this.element.removeChild(this.element.firstChild);
        for (; t.childNodes.length > 0;) this.element.appendChild(t.childNodes[0]);
      }
    }
  }, {
    key: "_colorFillPaths",
    value: function _colorFillPaths() {
      var _this11 = this;
      this.fillColor && this.element.querySelectorAll(".ck-icon__fill").forEach(function (e) {
        e.style.fill = _this11.fillColor;
      });
    }
  }]);
}(h);
_defineProperty(L, "presentationalAttributeNames", ["alignment-baseline", "baseline-shift", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-rendering", "cursor", "direction", "display", "dominant-baseline", "fill", "fill-opacity", "fill-rule", "filter", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "image-rendering", "letter-spacing", "lighting-color", "marker-end", "marker-mid", "marker-start", "mask", "opacity", "overflow", "paint-order", "pointer-events", "shape-rendering", "stop-color", "stop-opacity", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-anchor", "text-decoration", "text-overflow", "text-rendering", "transform", "unicode-bidi", "vector-effect", "visibility", "white-space", "word-spacing", "writing-mode"]);
var ut = /*#__PURE__*/function (_h3) {
  function ut() {
    var _this12;
    _classCallCheck(this, ut);
    _this12 = _callSuper(this, ut), _this12.set({
      style: void 0,
      text: void 0,
      id: void 0
    });
    var e = _this12.bindTemplate;
    _this12.setTemplate({
      tag: "span",
      attributes: {
        class: ["ck", "ck-button__label"],
        style: e.to("style"),
        id: e.to("id")
      },
      children: [{
        text: e.to("text")
      }]
    });
    return _this12;
  }
  _inherits(ut, _h3);
  return _createClass(ut);
}(h);
var p = /*#__PURE__*/function (_h4) {
  function p(e) {
    var _this13;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new ut();
    _classCallCheck(this, p);
    _this13 = _callSuper(this, p, [e]);
    _defineProperty(_this13, "children", void 0);
    _defineProperty(_this13, "labelView", void 0);
    _defineProperty(_this13, "iconView", void 0);
    _defineProperty(_this13, "keystrokeView", void 0);
    _defineProperty(_this13, "_focusDelayed", null);
    var i = _this13.bindTemplate,
      o = Q();
    _this13.set("_ariaPressed", !1), _this13.set("_ariaChecked", !1), _this13.set("ariaLabel", void 0), _this13.set("ariaLabelledBy", "ck-editor__aria-label_".concat(o)), _this13.set("class", void 0), _this13.set("labelStyle", void 0), _this13.set("icon", void 0), _this13.set("isEnabled", !0), _this13.set("isOn", !1), _this13.set("isVisible", !0), _this13.set("isToggleable", !1), _this13.set("keystroke", void 0), _this13.set("label", void 0), _this13.set("role", void 0), _this13.set("tabindex", -1), _this13.set("tooltip", !1), _this13.set("tooltipPosition", "s"), _this13.set("type", "button"), _this13.set("withText", !1), _this13.set("withKeystroke", !1), _this13.children = _this13.createCollection(), _this13.labelView = _this13._setupLabelView(t), _this13.iconView = new L(), _this13.iconView.extendTemplate({
      attributes: {
        class: "ck-button__icon"
      }
    }), _this13.iconView.bind("content").to(_this13, "icon"), _this13.keystrokeView = _this13._createKeystrokeView(), _this13.bind("_tooltipString").to(_this13, "tooltip", _this13, "label", _this13, "keystroke", _this13._getTooltipString.bind(_this13));
    var n = {
      tag: "button",
      attributes: {
        class: ["ck", "ck-button", i.to("class"), i.if("isEnabled", "ck-disabled", function (r) {
          return !r;
        }), i.if("isVisible", "ck-hidden", function (r) {
          return !r;
        }), i.to("isOn", function (r) {
          return r ? "ck-on" : "ck-off";
        }), i.if("withText", "ck-button_with-text"), i.if("withKeystroke", "ck-button_with-keystroke")],
        role: i.to("role"),
        type: i.to("type", function (r) {
          return r || "button";
        }),
        tabindex: i.to("tabindex"),
        "aria-checked": i.to("_ariaChecked"),
        "aria-pressed": i.to("_ariaPressed"),
        "aria-label": i.to("ariaLabel"),
        "aria-labelledby": i.to("ariaLabelledBy"),
        "aria-disabled": i.if("isEnabled", !0, function (r) {
          return !r;
        }),
        "data-cke-tooltip-text": i.to("_tooltipString"),
        "data-cke-tooltip-position": i.to("tooltipPosition")
      },
      children: _this13.children,
      on: {
        click: i.to(function (r) {
          _this13.isEnabled ? _this13.fire("execute") : r.preventDefault();
        })
      }
    };
    _this13.bind("_ariaPressed").to(_this13, "isOn", _this13, "isToggleable", _this13, "role", function (r, a, l) {
      return !a || De(l) ? !1 : String(!!r);
    }), _this13.bind("_ariaChecked").to(_this13, "isOn", _this13, "isToggleable", _this13, "role", function (r, a, l) {
      return !a || !De(l) ? !1 : String(!!r);
    }), A.isSafari && (_this13._focusDelayed || (_this13._focusDelayed = Lt(function () {
      return _this13.focus();
    }, 0)), n.on.mousedown = i.to(function () {
      _this13._focusDelayed();
    }), n.on.mouseup = i.to(function () {
      _this13._focusDelayed.cancel();
    })), _this13.setTemplate(n);
    return _this13;
  }
  _inherits(p, _h4);
  return _createClass(p, [{
    key: "render",
    value: function render() {
      var _this14 = this;
      _superPropGet(p, "render", this, 3)([]), this.icon && this.children.add(this.iconView), this.on("change:icon", function (e, t, i, o) {
        i && !o ? _this14.children.add(_this14.iconView, 0) : !i && o && _this14.children.remove(_this14.iconView);
      }), this.children.add(this.labelView), this.withKeystroke && this.keystroke && this.children.add(this.keystrokeView);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.element.focus();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._focusDelayed && this._focusDelayed.cancel(), _superPropGet(p, "destroy", this, 3)([]);
    }
  }, {
    key: "_setupLabelView",
    value: function _setupLabelView(e) {
      return e.bind("text", "style", "id").to(this, "label", "labelStyle", "ariaLabelledBy"), e;
    }
  }, {
    key: "_createKeystrokeView",
    value: function _createKeystrokeView() {
      var e = new h();
      return e.setTemplate({
        tag: "span",
        attributes: {
          class: ["ck", "ck-button__keystroke"]
        },
        children: [{
          text: this.bindTemplate.to("keystroke", function (t) {
            return Y(t);
          })
        }]
      }), e;
    }
  }, {
    key: "_getTooltipString",
    value: function _getTooltipString(e, t, i) {
      return e ? typeof e == "string" ? e : (i && (i = Y(i)), e instanceof Function ? e(t, i) : "".concat(t).concat(i ? " (".concat(i, ")") : "")) : "";
    }
  }]);
}(h);
function De(s) {
  switch (s) {
    case "radio":
    case "checkbox":
    case "option":
    case "switch":
    case "menuitemcheckbox":
    case "menuitemradio":
      return !0;
    default:
      return !1;
  }
}
var pi = /*#__PURE__*/function (_h5) {
  function pi(e) {
    var _this15;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, pi);
    _this15 = _callSuper(this, pi, [e]);
    _defineProperty(_this15, "children", void 0);
    _defineProperty(_this15, "iconView", void 0);
    var i = _this15.bindTemplate;
    _this15.set("label", t.label || ""), _this15.set("class", t.class || null), _this15.children = _this15.createCollection(), _this15.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-form__header", i.to("class")]
      },
      children: _this15.children
    }), t.icon && (_this15.iconView = new L(), _this15.iconView.content = t.icon, _this15.children.add(_this15.iconView));
    var o = new h(e);
    o.setTemplate({
      tag: "h2",
      attributes: {
        class: ["ck", "ck-form__header__label"],
        role: "presentation"
      },
      children: [{
        text: i.to("label")
      }]
    }), _this15.children.add(o);
    return _this15;
  }
  _inherits(pi, _h5);
  return _createClass(pi);
}(h);
var N = /*#__PURE__*/function (_Ze2) {
  function N(e) {
    var _this16;
    _classCallCheck(this, N);
    if (_this16 = _callSuper(this, N), _defineProperty(_assertThisInitialized(_this16), "focusables", void 0), _defineProperty(_assertThisInitialized(_this16), "focusTracker", void 0), _defineProperty(_assertThisInitialized(_this16), "keystrokeHandler", void 0), _defineProperty(_assertThisInitialized(_this16), "actions", void 0), _this16.focusables = e.focusables, _this16.focusTracker = e.focusTracker, _this16.keystrokeHandler = e.keystrokeHandler, _this16.actions = e.actions, e.actions && e.keystrokeHandler) {
      var _loop2 = function _loop2(t) {
        var i = e.actions[t];
        typeof i == "string" && (i = [i]);
        var _iterator11 = _createForOfIteratorHelper(i),
          _step11;
        try {
          for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
            var o = _step11.value;
            e.keystrokeHandler.set(o, function (n, r) {
              _this16[t](), r();
            }, e.keystrokeHandlerOptions);
          }
        } catch (err) {
          _iterator11.e(err);
        } finally {
          _iterator11.f();
        }
      };
      for (var t in e.actions) {
        _loop2(t);
      }
    }
    _this16.on("forwardCycle", function () {
      return _this16.focusFirst();
    }, {
      priority: "low"
    }), _this16.on("backwardCycle", function () {
      return _this16.focusLast();
    }, {
      priority: "low"
    });
    return _assertThisInitialized(_this16);
  }
  _inherits(N, _Ze2);
  return _createClass(N, [{
    key: "first",
    get: function get() {
      return this.focusables.find(le) || null;
    }
  }, {
    key: "last",
    get: function get() {
      return this.focusables.filter(le).slice(-1)[0] || null;
    }
  }, {
    key: "next",
    get: function get() {
      return this._getDomFocusableItem(1);
    }
  }, {
    key: "previous",
    get: function get() {
      return this._getDomFocusableItem(-1);
    }
  }, {
    key: "current",
    get: function get() {
      var _this17 = this;
      var e = null;
      return this.focusTracker.focusedElement === null ? null : (this.focusables.find(function (t, i) {
        var o = t.element === _this17.focusTracker.focusedElement;
        return o && (e = i), o;
      }), e);
    }
  }, {
    key: "focusFirst",
    value: function focusFirst() {
      this._focus(this.first, 1);
    }
  }, {
    key: "focusLast",
    value: function focusLast() {
      this._focus(this.last, -1);
    }
  }, {
    key: "focusNext",
    value: function focusNext() {
      var e = this.next;
      if (e && this.focusables.getIndex(e) === this.current) {
        this.fire("forwardCycle");
        return;
      }
      e === this.first ? this.fire("forwardCycle") : this._focus(e, 1);
    }
  }, {
    key: "focusPrevious",
    value: function focusPrevious() {
      var e = this.previous;
      if (e && this.focusables.getIndex(e) === this.current) {
        this.fire("backwardCycle");
        return;
      }
      e === this.last ? this.fire("backwardCycle") : this._focus(e, -1);
    }
  }, {
    key: "chain",
    value: function chain(e) {
      var _this18 = this;
      var t = function t() {
        return _this18.current === null ? null : _this18.focusables.get(_this18.current);
      };
      this.listenTo(e, "forwardCycle", function (i) {
        var o = t();
        _this18.focusNext(), o !== t() && i.stop();
      }, {
        priority: "low"
      }), this.listenTo(e, "backwardCycle", function (i) {
        var o = t();
        _this18.focusPrevious(), o !== t() && i.stop();
      }, {
        priority: "low"
      });
    }
  }, {
    key: "unchain",
    value: function unchain(e) {
      this.stopListening(e);
    }
  }, {
    key: "_focus",
    value: function _focus(e, t) {
      e && this.focusTracker.focusedElement !== e.element && e.focus(t);
    }
  }, {
    key: "_getDomFocusableItem",
    value: function _getDomFocusableItem(e) {
      var t = this.focusables.length;
      if (!t) return null;
      var i = this.current;
      if (i === null) return this[e === 1 ? "first" : "last"];
      var o = this.focusables.get(i),
        n = (i + t + e) % t;
      do {
        var r = this.focusables.get(n);
        if (le(r)) {
          o = r;
          break;
        }
        n = (n + t + e) % t;
      } while (n !== i);
      return o;
    }
  }]);
}(Ze());
function le(s) {
  return z(s) && O(s.element);
}
function z(s) {
  return "focus" in s && typeof s.focus == "function";
}
function mi(s) {
  return z(s) && "focusCycler" in s && s.focusCycler instanceof N;
}
function wi(s) {
  var e = /*#__PURE__*/function (_s3) {
    function e() {
      var _this19;
      _classCallCheck(this, e);
      for (var _len3 = arguments.length, i = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        i[_key3] = arguments[_key3];
      }
      _this19 = _callSuper(this, e, [].concat(i)), _defineProperty(_assertThisInitialized(_this19), "_onDragBound", _this19._onDrag.bind(_assertThisInitialized(_this19))), _defineProperty(_assertThisInitialized(_this19), "_onDragEndBound", _this19._onDragEnd.bind(_assertThisInitialized(_this19))), _defineProperty(_assertThisInitialized(_this19), "_lastDraggingCoordinates", {
        x: 0,
        y: 0
      }), _this19.on("render", function () {
        _this19._attachListeners();
      }), _this19.set("isDragging", !1);
      return _this19;
    }
    _inherits(e, _s3);
    return _createClass(e, [{
      key: "_attachListeners",
      value: function _attachListeners() {
        this.listenTo(this.element, "mousedown", this._onDragStart.bind(this)), this.listenTo(this.element, "touchstart", this._onDragStart.bind(this));
      }
    }, {
      key: "_attachDragListeners",
      value: function _attachDragListeners() {
        this.listenTo(d.document, "mouseup", this._onDragEndBound), this.listenTo(d.document, "touchend", this._onDragEndBound), this.listenTo(d.document, "mousemove", this._onDragBound), this.listenTo(d.document, "touchmove", this._onDragBound);
      }
    }, {
      key: "_detachDragListeners",
      value: function _detachDragListeners() {
        this.stopListening(d.document, "mouseup", this._onDragEndBound), this.stopListening(d.document, "touchend", this._onDragEndBound), this.stopListening(d.document, "mousemove", this._onDragBound), this.stopListening(d.document, "touchmove", this._onDragBound);
      }
    }, {
      key: "_onDragStart",
      value: function _onDragStart(i, o) {
        if (!this._isHandleElementPressed(o)) return;
        this._attachDragListeners();
        var n = 0,
          r = 0;
        o instanceof MouseEvent ? (n = o.clientX, r = o.clientY) : (n = o.touches[0].clientX, r = o.touches[0].clientY), this._lastDraggingCoordinates = {
          x: n,
          y: r
        }, this.isDragging = !0;
      }
    }, {
      key: "_onDrag",
      value: function _onDrag(i, o) {
        if (!this.isDragging) {
          this._detachDragListeners();
          return;
        }
        var n = 0,
          r = 0;
        o instanceof MouseEvent ? (n = o.clientX, r = o.clientY) : (n = o.touches[0].clientX, r = o.touches[0].clientY), o.preventDefault(), this.fire("drag", {
          deltaX: Math.round(n - this._lastDraggingCoordinates.x),
          deltaY: Math.round(r - this._lastDraggingCoordinates.y)
        }), this._lastDraggingCoordinates = {
          x: n,
          y: r
        };
      }
    }, {
      key: "_onDragEnd",
      value: function _onDragEnd() {
        this._detachDragListeners(), this.isDragging = !1;
      }
    }, {
      key: "_isHandleElementPressed",
      value: function _isHandleElementPressed(i) {
        return this.dragHandleElement ? this.dragHandleElement === i.target || i.target instanceof HTMLElement && this.dragHandleElement.contains(i.target) : !1;
      }
    }]);
  }(s);
  return e;
}
var bi = /*#__PURE__*/function (_h6) {
  function bi(e) {
    var _this20;
    _classCallCheck(this, bi);
    _this20 = _callSuper(this, bi, [e]), _defineProperty(_assertThisInitialized(_this20), "children", void 0), _defineProperty(_assertThisInitialized(_this20), "keystrokes", void 0), _defineProperty(_assertThisInitialized(_this20), "focusCycler", void 0), _defineProperty(_assertThisInitialized(_this20), "_focusTracker", void 0), _defineProperty(_assertThisInitialized(_this20), "_focusables", void 0), _this20.children = _this20.createCollection(), _this20.keystrokes = new E(), _this20._focusTracker = new b(), _this20._focusables = new B(), _this20.focusCycler = new N({
      focusables: _this20._focusables,
      focusTracker: _this20._focusTracker,
      keystrokeHandler: _this20.keystrokes,
      actions: {
        focusPrevious: "shift + tab",
        focusNext: "tab"
      }
    }), _this20.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-dialog__actions"]
      },
      children: _this20.children
    });
    return _this20;
  }
  _inherits(bi, _h6);
  return _createClass(bi, [{
    key: "render",
    value: function render() {
      _superPropGet(bi, "render", this, 3)([]), this.keystrokes.listenTo(this.element);
    }
  }, {
    key: "setButtons",
    value: function setButtons(e) {
      var _this21 = this;
      var _iterator12 = _createForOfIteratorHelper(e),
        _step12;
      try {
        var _loop3 = function _loop3() {
          var t = _step12.value;
          var i = new p(_this21.locale);
          var o;
          i.on("execute", function () {
            return t.onExecute();
          }), t.onCreate && t.onCreate(i);
          for (o in t) o != "onExecute" && o != "onCreate" && i.set(o, t[o]);
          _this21.children.add(i);
        };
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          _loop3();
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
      this._updateFocusCyclableItems();
    }
  }, {
    key: "focus",
    value: function focus(e) {
      e === -1 ? this.focusCycler.focusLast() : this.focusCycler.focusFirst();
    }
  }, {
    key: "_updateFocusCyclableItems",
    value: function _updateFocusCyclableItems() {
      var _this22 = this;
      Array.from(this.children).forEach(function (e) {
        _this22._focusables.add(e), _this22._focusTracker.add(e.element);
      });
    }
  }]);
}(h);
var gi = /*#__PURE__*/function (_h7) {
  function gi(e) {
    var _this23;
    _classCallCheck(this, gi);
    _this23 = _callSuper(this, gi, [e]), _defineProperty(_assertThisInitialized(_this23), "children", void 0), _this23.children = _this23.createCollection(), _this23.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-dialog__content"]
      },
      children: _this23.children
    });
    return _this23;
  }
  _inherits(gi, _h7);
  return _createClass(gi, [{
    key: "reset",
    value: function reset() {
      for (; this.children.length;) this.children.remove(0);
    }
  }]);
}(h);
var g = {
    SCREEN_CENTER: "screen-center",
    EDITOR_CENTER: "editor-center",
    EDITOR_TOP_SIDE: "editor-top-side",
    EDITOR_TOP_CENTER: "editor-top-center",
    EDITOR_BOTTOM_CENTER: "editor-bottom-center",
    EDITOR_ABOVE_CENTER: "editor-above-center",
    EDITOR_BELOW_CENTER: "editor-below-center"
  },
  Se = te("px");
var ve = /*#__PURE__*/function (_wi) {
  function ve(e, _ref7) {
    var _this24;
    var t = _ref7.getCurrentDomRoot,
      i = _ref7.getViewportOffset,
      o = _ref7.keystrokeHandlerOptions;
    _classCallCheck(this, ve);
    _this24 = _callSuper(this, ve, [e]);
    _defineProperty(_this24, "parts", void 0);
    _defineProperty(_this24, "headerView", void 0);
    _defineProperty(_this24, "closeButtonView", void 0);
    _defineProperty(_this24, "actionsView", void 0);
    _defineProperty(_this24, "contentView", void 0);
    _defineProperty(_this24, "keystrokes", void 0);
    _defineProperty(_this24, "focusTracker", void 0);
    _defineProperty(_this24, "wasMoved", !1);
    _defineProperty(_this24, "_getCurrentDomRoot", void 0);
    _defineProperty(_this24, "_getViewportOffset", void 0);
    _defineProperty(_this24, "_focusables", void 0);
    _defineProperty(_this24, "_focusCycler", void 0);
    var n = _this24.bindTemplate,
      r = e.t;
    _this24.set("className", ""), _this24.set("ariaLabel", r("Editor dialog")), _this24.set("isModal", !1), _this24.set("position", g.SCREEN_CENTER), _this24.set("_isVisible", !1), _this24.set("_isTransparent", !1), _this24.set("_top", 0), _this24.set("_left", 0), _this24._getCurrentDomRoot = t, _this24._getViewportOffset = i, _this24.decorate("moveTo"), _this24.parts = _this24.createCollection(), _this24.keystrokes = new E(), _this24.focusTracker = new b(), _this24._focusables = new B(), _this24._focusCycler = new N({
      focusables: _this24._focusables,
      focusTracker: _this24.focusTracker,
      keystrokeHandler: _this24.keystrokes,
      actions: {
        focusPrevious: "shift + tab",
        focusNext: "tab"
      },
      keystrokeHandlerOptions: o
    }), _this24.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-dialog-overlay", n.if("isModal", "ck-dialog-overlay__transparent", function (a) {
          return !a;
        }), n.if("_isVisible", "ck-hidden", function (a) {
          return !a;
        })],
        tabindex: "-1"
      },
      children: [{
        tag: "div",
        attributes: {
          tabindex: "-1",
          class: ["ck", "ck-dialog", n.if("isModal", "ck-dialog_modal"), n.to("className")],
          role: "dialog",
          "aria-label": n.to("ariaLabel"),
          style: {
            top: n.to("_top", function (a) {
              return Se(a);
            }),
            left: n.to("_left", function (a) {
              return Se(a);
            }),
            visibility: n.if("_isTransparent", "hidden")
          }
        },
        children: _this24.parts
      }]
    });
    return _this24;
  }
  _inherits(ve, _wi);
  return _createClass(ve, [{
    key: "render",
    value: function render() {
      var _this25 = this;
      _superPropGet(ve, "render", this, 3)([]), this.keystrokes.set("Esc", function (e, t) {
        e.defaultPrevented || (_this25.fire("close", {
          source: "escKeyPress"
        }), t());
      }), this.on("drag", function (e, _ref8) {
        var t = _ref8.deltaX,
          i = _ref8.deltaY;
        _this25.wasMoved = !0, _this25.moveBy(t, i);
      }), this.listenTo(d.window, "resize", function () {
        _this25._isVisible && !_this25.wasMoved && _this25.updatePosition();
      }), this.listenTo(d.document, "scroll", function () {
        _this25._isVisible && !_this25.wasMoved && _this25.updatePosition();
      }), this.on("change:_isVisible", function (e, t, i) {
        i && (_this25._isTransparent = !0, setTimeout(function () {
          _this25.updatePosition(), _this25._isTransparent = !1, _this25.focus();
        }, 10));
      }), this.keystrokes.listenTo(this.element);
    }
  }, {
    key: "dragHandleElement",
    get: function get() {
      return this.headerView && !this.isModal ? this.headerView.element : null;
    }
  }, {
    key: "setupParts",
    value: function setupParts(_ref9) {
      var e = _ref9.icon,
        t = _ref9.title,
        _ref9$hasCloseButton = _ref9.hasCloseButton,
        i = _ref9$hasCloseButton === void 0 ? !0 : _ref9$hasCloseButton,
        o = _ref9.content,
        n = _ref9.actionButtons;
      t && (this.headerView = new pi(this.locale, {
        icon: e
      }), i && (this.closeButtonView = this._createCloseButton(), this.headerView.children.add(this.closeButtonView)), this.headerView.label = t, this.ariaLabel = t, this.parts.add(this.headerView, 0)), o && (o instanceof h && (o = [o]), this.contentView = new gi(this.locale), this.contentView.children.addMany(o), this.parts.add(this.contentView)), n && (this.actionsView = new bi(this.locale), this.actionsView.setButtons(n), this.parts.add(this.actionsView)), this._updateFocusCyclableItems();
    }
  }, {
    key: "focus",
    value: function focus() {
      this._focusCycler.focusFirst();
    }
  }, {
    key: "moveTo",
    value: function moveTo(e, t) {
      var i = this._getViewportRect(),
        o = this._getDialogRect();
      e + o.width > i.right && (e = i.right - o.width), e < i.left && (e = i.left), t < i.top && (t = i.top), this._moveTo(e, t);
    }
  }, {
    key: "_moveTo",
    value: function _moveTo(e, t) {
      this._left = e, this._top = t;
    }
  }, {
    key: "moveBy",
    value: function moveBy(e, t) {
      this.moveTo(this._left + e, this._top + t);
    }
  }, {
    key: "_moveOffScreen",
    value: function _moveOffScreen() {
      this._moveTo(-9999, -9999);
    }
  }, {
    key: "updatePosition",
    value: function updatePosition() {
      if (!this.element || !this.element.parentNode) return;
      var e = this._getViewportRect();
      var t = this.position,
        i;
      this._getCurrentDomRoot() ? i = this._getVisibleDomRootRect(e) : t = g.SCREEN_CENTER;
      var o = ve.defaultOffset,
        n = this._getDialogRect();
      switch (t) {
        case g.EDITOR_TOP_SIDE:
          {
            if (i) {
              var r = this.locale.contentLanguageDirection === "ltr" ? i.right - n.width - o : i.left + o;
              this.moveTo(r, i.top + o);
            } else this._moveOffScreen();
            break;
          }
        case g.EDITOR_CENTER:
          {
            i ? this.moveTo(Math.round(i.left + i.width / 2 - n.width / 2), Math.round(i.top + i.height / 2 - n.height / 2)) : this._moveOffScreen();
            break;
          }
        case g.SCREEN_CENTER:
          {
            this.moveTo(Math.round((e.width - n.width) / 2), Math.round((e.height - n.height) / 2));
            break;
          }
        case g.EDITOR_TOP_CENTER:
          {
            i ? this.moveTo(Math.round(i.left + i.width / 2 - n.width / 2), i.top + o) : this._moveOffScreen();
            break;
          }
        case g.EDITOR_BOTTOM_CENTER:
          {
            i ? this.moveTo(Math.round(i.left + i.width / 2 - n.width / 2), i.bottom - n.height - o) : this._moveOffScreen();
            break;
          }
        case g.EDITOR_ABOVE_CENTER:
          {
            i ? this.moveTo(Math.round(i.left + i.width / 2 - n.width / 2), i.top - n.height - o) : this._moveOffScreen();
            break;
          }
        case g.EDITOR_BELOW_CENTER:
          {
            i ? this.moveTo(Math.round(i.left + i.width / 2 - n.width / 2), i.bottom + o) : this._moveOffScreen();
            break;
          }
      }
    }
  }, {
    key: "_getVisibleDomRootRect",
    value: function _getVisibleDomRootRect(e) {
      var t = new T(this._getCurrentDomRoot()).getVisible();
      if (t) {
        if (t = e.getIntersection(t), !t) return null;
      } else return null;
      return t;
    }
  }, {
    key: "_getDialogRect",
    value: function _getDialogRect() {
      return new T(this.element.firstElementChild);
    }
  }, {
    key: "_getViewportRect",
    value: function _getViewportRect() {
      var e = new T(d.window);
      if (this.isModal) return e;
      var t = _objectSpread({
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
      }, this._getViewportOffset());
      return e.top += t.top, e.height -= t.top, e.bottom -= t.bottom, e.height -= t.bottom, e.left += t.left, e.right -= t.right, e.width -= t.left + t.right, e;
    }
  }, {
    key: "_updateFocusCyclableItems",
    value: function _updateFocusCyclableItems() {
      var _this26 = this;
      var e = [];
      if (this.contentView) {
        var _iterator13 = _createForOfIteratorHelper(this.contentView.children),
          _step13;
        try {
          for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
            var t = _step13.value;
            z(t) && e.push(t);
          }
        } catch (err) {
          _iterator13.e(err);
        } finally {
          _iterator13.f();
        }
      }
      this.actionsView && e.push(this.actionsView), this.closeButtonView && e.push(this.closeButtonView), e.forEach(function (t) {
        _this26._focusables.add(t), _this26.focusTracker.add(t.element), mi(t) && _this26._focusCycler.chain(t.focusCycler);
      });
    }
  }, {
    key: "_createCloseButton",
    value: function _createCloseButton() {
      var _this27 = this;
      var e = new p(this.locale),
        t = this.locale.t;
      return e.set({
        label: t("Close"),
        tooltip: !0,
        icon: it
      }), e.on("execute", function () {
        return _this27.fire("close", {
          source: "closeButton"
        });
      }), e;
    }
  }]);
}(wi(h));
_defineProperty(ve, "defaultOffset", 15);
var y = /*#__PURE__*/function (_we) {
  function y(e) {
    var _this28;
    _classCallCheck(this, y);
    _this28 = _callSuper(this, y, [e]);
    _defineProperty(_this28, "view", void 0);
    _defineProperty(_this28, "_onHide", void 0);
    var t = e.t;
    _this28._initShowHideListeners(), _this28._initFocusToggler(), _this28._initMultiRootIntegration(), _this28.set({
      id: null,
      isOpen: !1
    }), e.accessibility.addKeystrokeInfos({
      categoryId: "navigation",
      keystrokes: [{
        label: t("Move focus in and out of an active dialog window"),
        keystroke: "Ctrl+F6",
        mayRequireFn: !0
      }]
    });
    return _this28;
  }
  _inherits(y, _we);
  return _createClass(y, [{
    key: "destroy",
    value: function destroy() {
      _superPropGet(y, "destroy", this, 3)([]), y._visibleDialogPlugin === this && this._unlockBodyScroll();
    }
  }, {
    key: "_initShowHideListeners",
    value: function _initShowHideListeners() {
      var _this29 = this;
      this.on("show", function (e, t) {
        _this29._show(t);
      }), this.on("show", function (e, t) {
        t.onShow && t.onShow(_this29);
      }, {
        priority: "low"
      }), this.on("hide", function () {
        y._visibleDialogPlugin && y._visibleDialogPlugin._hide();
      }), this.on("hide", function () {
        _this29._onHide && (_this29._onHide(_this29), _this29._onHide = void 0);
      }, {
        priority: "low"
      });
    }
  }, {
    key: "_initFocusToggler",
    value: function _initFocusToggler() {
      var _this30 = this;
      var e = this.editor;
      e.keystrokes.set("Ctrl+F6", function (t, i) {
        !_this30.isOpen || _this30.view.isModal || (_this30.view.focusTracker.isFocused ? e.editing.view.focus() : _this30.view.focus(), i());
      });
    }
  }, {
    key: "_initMultiRootIntegration",
    value: function _initMultiRootIntegration() {
      var _this31 = this;
      var e = this.editor.model;
      e.document.on("change:data", function () {
        if (!_this31.view) return;
        var t = e.document.differ.getChangedRoots();
        var _iterator14 = _createForOfIteratorHelper(t),
          _step14;
        try {
          for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
            var i = _step14.value;
            i.state && _this31.view.updatePosition();
          }
        } catch (err) {
          _iterator14.e(err);
        } finally {
          _iterator14.f();
        }
      });
    }
  }, {
    key: "show",
    value: function show(e) {
      this.hide(), this.fire("show:".concat(e.id), e);
    }
  }, {
    key: "_show",
    value: function _show(_ref0) {
      var _this32 = this;
      var e = _ref0.id,
        t = _ref0.icon,
        i = _ref0.title,
        _ref0$hasCloseButton = _ref0.hasCloseButton,
        o = _ref0$hasCloseButton === void 0 ? !0 : _ref0$hasCloseButton,
        n = _ref0.content,
        r = _ref0.actionButtons,
        a = _ref0.className,
        l = _ref0.isModal,
        c = _ref0.position,
        u = _ref0.onHide,
        f = _ref0.keystrokeHandlerOptions;
      var w = this.editor;
      this.view = new ve(w.locale, {
        getCurrentDomRoot: function getCurrentDomRoot() {
          return w.editing.view.getDomRoot(w.model.document.selection.anchor.root.rootName);
        },
        getViewportOffset: function getViewportOffset() {
          return w.ui.viewportOffset;
        },
        keystrokeHandlerOptions: f
      });
      var F = this.view;
      F.on("close", function () {
        _this32.hide();
      }), w.ui.view.body.add(F), w.keystrokes.listenTo(F.element), c || (c = l ? g.SCREEN_CENTER : g.EDITOR_CENTER), l && this._lockBodyScroll(), F.set({
        position: c,
        _isVisible: !0,
        className: a,
        isModal: l
      }), F.setupParts({
        icon: t,
        title: i,
        hasCloseButton: o,
        content: n,
        actionButtons: r
      }), this.id = e, u && (this._onHide = u), this.isOpen = !0, y._visibleDialogPlugin = this;
    }
  }, {
    key: "hide",
    value: function hide() {
      y._visibleDialogPlugin && y._visibleDialogPlugin.fire("hide:".concat(y._visibleDialogPlugin.id));
    }
  }, {
    key: "_hide",
    value: function _hide() {
      if (!this.view) return;
      var e = this.editor,
        t = this.view;
      t.isModal && this._unlockBodyScroll(), t.contentView && t.contentView.reset(), e.ui.view.body.remove(t), e.ui.focusTracker.remove(t.element), e.keystrokes.stopListening(t.element), t.destroy(), e.editing.view.focus(), this.id = null, this.isOpen = !1, y._visibleDialogPlugin = null;
    }
  }, {
    key: "_lockBodyScroll",
    value: function _lockBodyScroll() {
      document.documentElement.classList.add("ck-dialog-scroll-locked");
    }
  }, {
    key: "_unlockBodyScroll",
    value: function _unlockBodyScroll() {
      document.documentElement.classList.remove("ck-dialog-scroll-locked");
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "Dialog";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(we);
_defineProperty(y, "_visibleDialogPlugin", void 0);
var W = /*#__PURE__*/function (_p2) {
  function W(e) {
    var _this33;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new ut();
    _classCallCheck(this, W);
    _this33 = _callSuper(this, W, [e, t]), _defineProperty(_assertThisInitialized(_this33), "_checkIconHolderView", new _i()), _this33.set({
      hasCheckSpace: !1,
      _hasCheck: _this33.isToggleable
    });
    var i = _this33.bindTemplate;
    _this33.extendTemplate({
      attributes: {
        class: ["ck-list-item-button", i.if("isToggleable", "ck-list-item-button_toggleable")]
      }
    }), _this33.bind("_hasCheck").to(_this33, "hasCheckSpace", _this33, "isToggleable", function (o, n) {
      return o || n;
    });
    return _this33;
  }
  _inherits(W, _p2);
  return _createClass(W, [{
    key: "render",
    value: function render() {
      _superPropGet(W, "render", this, 3)([]), this._hasCheck && this.children.add(this._checkIconHolderView, 0), this._watchCheckIconHolderMount();
    }
  }, {
    key: "_watchCheckIconHolderMount",
    value: function _watchCheckIconHolderMount() {
      var _this34 = this;
      this._checkIconHolderView.bind("isOn").to(this, "isOn", function (e) {
        return _this34.isToggleable && e;
      }), this.on("change:_hasCheck", function (e, t, i) {
        var o = _this34.children,
          n = _this34._checkIconHolderView;
        i ? o.add(n, 0) : o.remove(n);
      });
    }
  }]);
}(p);
var _i = /*#__PURE__*/function (_h8) {
  function _i() {
    var _this35;
    _classCallCheck(this, _i);
    _this35 = _callSuper(this, _i);
    _defineProperty(_this35, "children", void 0);
    _defineProperty(_this35, "_checkIconView", _this35._createCheckIconView());
    var e = _this35.bindTemplate;
    _this35.children = _this35.createCollection(), _this35.set("isOn", !1), _this35.setTemplate({
      tag: "span",
      children: _this35.children,
      attributes: {
        class: ["ck", "ck-list-item-button__check-holder", e.to("isOn", function (t) {
          return t ? "ck-on" : "ck-off";
        })]
      }
    });
    return _this35;
  }
  _inherits(_i, _h8);
  return _createClass(_i, [{
    key: "render",
    value: function render() {
      _superPropGet(_i, "render", this, 3)([]), this.isOn && this.children.add(this._checkIconView, 0), this._watchCheckIconMount();
    }
  }, {
    key: "_watchCheckIconMount",
    value: function _watchCheckIconMount() {
      var _this36 = this;
      this.on("change:isOn", function (e, t, i) {
        var o = _this36.children,
          n = _this36._checkIconView;
        i && !o.has(n) ? o.add(n) : !i && o.has(n) && o.remove(n);
      });
    }
  }, {
    key: "_createCheckIconView",
    value: function _createCheckIconView() {
      var e = new L();
      return e.content = st, e.extendTemplate({
        attributes: {
          class: "ck-list-item-button__check-icon"
        }
      }), e;
    }
  }]);
}(h);
var dt = /*#__PURE__*/function (_W2) {
  function dt(e) {
    var _this37;
    _classCallCheck(this, dt);
    _this37 = _callSuper(this, dt, [e]), _this37.set({
      withText: !0,
      withKeystroke: !0,
      tooltip: !1,
      role: "menuitem"
    }), _this37.extendTemplate({
      attributes: {
        class: ["ck-menu-bar__menu__item__button"]
      }
    });
    return _this37;
  }
  _inherits(dt, _W2);
  return _createClass(dt);
}(W);
var re = /*#__PURE__*/function (_h9) {
  function re(e) {
    var _this38;
    _classCallCheck(this, re);
    _this38 = _callSuper(this, re, [e]), _defineProperty(_assertThisInitialized(_this38), "id", void 0), _this38.set("text", void 0), _this38.set("for", void 0), _this38.id = "ck-editor__label_".concat(Q());
    var t = _this38.bindTemplate;
    _this38.setTemplate({
      tag: "label",
      attributes: {
        class: ["ck", "ck-label"],
        id: _this38.id,
        for: t.to("for")
      },
      children: [{
        text: t.to("text")
      }]
    });
    return _this38;
  }
  _inherits(re, _h9);
  return _createClass(re);
}(h);
var ki = /*#__PURE__*/function (_h0) {
  function ki(e, t) {
    var _this39;
    _classCallCheck(this, ki);
    _this39 = _callSuper(this, ki, [e]);
    var i = e.t,
      o = new re();
    o.text = i("Help Contents. To close this dialog press ESC."), _this39.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-accessibility-help-dialog__content"],
        "aria-labelledby": o.id,
        role: "document",
        tabindex: -1
      },
      children: [x(document, "p", {}, i("Below, you can find a list of keyboard shortcuts that can be used in the editor."))].concat(_toConsumableArray(_this39._createCategories(Array.from(t.values()))), [o])
    });
    return _this39;
  }
  _inherits(ki, _h0);
  return _createClass(ki, [{
    key: "focus",
    value: function focus() {
      this.element.focus();
    }
  }, {
    key: "_createCategories",
    value: function _createCategories(e) {
      var _this40 = this;
      return e.map(function (t) {
        var i = [x(document, "h3", {}, t.label)].concat(_toConsumableArray(Array.from(t.groups.values()).map(function (o) {
          return _this40._createGroup(o);
        }).flat()));
        return t.description && i.splice(1, 0, x(document, "p", {}, t.description)), x(document, "section", {}, i);
      });
    }
  }, {
    key: "_createGroup",
    value: function _createGroup(e) {
      var _this41 = this;
      var t = e.keystrokes.sort(function (o, n) {
          return o.label.localeCompare(n.label);
        }).map(function (o) {
          return _this41._createGroupRow(o);
        }).flat(),
        i = [x(document, "dl", {}, t)];
      return e.label && i.unshift(x(document, "h4", {}, e.label)), i;
    }
  }, {
    key: "_createGroupRow",
    value: function _createGroupRow(e) {
      var t = this.locale.t,
        i = x(document, "dt"),
        o = x(document, "dd"),
        n = vi(e.keystroke),
        r = [];
      var _iterator15 = _createForOfIteratorHelper(n),
        _step15;
      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var a = _step15.value;
          r.push(a.map(Ti).join(""));
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
      return i.innerHTML = e.label, o.innerHTML = r.join(", ") + (e.mayRequireFn && A.isMac ? " ".concat(t("(may require <kbd>Fn</kbd>)")) : ""), [i, o];
    }
  }]);
}(h);
function Ti(s) {
  return Y(s).split("+").map(function (e) {
    return "<kbd>".concat(e, "</kbd>");
  }).join("+");
}
function vi(s) {
  return typeof s == "string" ? [[s]] : typeof s[0] == "string" ? [s] : s;
}
var io = /*#__PURE__*/function (_we2) {
  function io() {
    var _this42;
    _classCallCheck(this, io);
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    _this42 = _callSuper(this, io, [].concat(args));
    _defineProperty(_this42, "contentView", null);
    return _this42;
  }
  _inherits(io, _we2);
  return _createClass(io, [{
    key: "init",
    value: function init() {
      var _this43 = this;
      var e = this.editor,
        t = e.locale.t;
      e.ui.componentFactory.add("accessibilityHelp", function () {
        var i = _this43._createButton(p);
        return i.set({
          tooltip: !0,
          withText: !1,
          label: t("Accessibility help")
        }), i;
      }), e.ui.componentFactory.add("menuBar:accessibilityHelp", function () {
        var i = _this43._createButton(dt);
        return i.label = t("Accessibility"), i;
      }), e.keystrokes.set("Alt+0", function (i, o) {
        _this43._toggleDialog(), o();
      }), this._setupRootLabels();
    }
  }, {
    key: "_createButton",
    value: function _createButton(e) {
      var _this44 = this;
      var t = this.editor,
        i = t.plugins.get("Dialog"),
        o = t.locale,
        n = new e(o);
      return n.set({
        keystroke: "Alt+0",
        icon: Ee,
        isToggleable: !0
      }), n.on("execute", function () {
        return _this44._toggleDialog();
      }), n.bind("isOn").to(i, "id", function (r) {
        return r === "accessibilityHelp";
      }), n;
    }
  }, {
    key: "_setupRootLabels",
    value: function _setupRootLabels() {
      var e = this.editor,
        t = e.editing.view,
        i = e.t;
      e.ui.on("ready", function () {
        t.change(function (n) {
          var _iterator16 = _createForOfIteratorHelper(t.document.roots),
            _step16;
          try {
            for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
              var r = _step16.value;
              o(n, r);
            }
          } catch (err) {
            _iterator16.e(err);
          } finally {
            _iterator16.f();
          }
        }), e.on("addRoot", function (n, r) {
          var a = e.editing.view.document.getRoot(r.rootName);
          t.change(function (l) {
            return o(l, a);
          });
        }, {
          priority: "low"
        });
      });
      function o(n, r) {
        var l = [r.getAttribute("aria-label"), i("Press %0 for help.", [Y("Alt+0")])].filter(function (c) {
          return c;
        }).join(". ");
        n.setAttribute("aria-label", l, r);
      }
    }
  }, {
    key: "_toggleDialog",
    value: function _toggleDialog() {
      var e = this.editor,
        t = e.plugins.get("Dialog"),
        i = e.locale.t;
      this.contentView || (this.contentView = new ki(e.locale, e.accessibility.keystrokeInfos)), t.id === "accessibilityHelp" ? t.hide() : t.show({
        id: "accessibilityHelp",
        className: "ck-accessibility-help-dialog",
        title: i("Accessibility help"),
        icon: Ee,
        hasCloseButton: !0,
        content: this.contentView
      });
    }
  }], [{
    key: "requires",
    get: function get() {
      return [y];
    }
  }, {
    key: "pluginName",
    get: function get() {
      return "AccessibilityHelp";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(we);
var _ = /*#__PURE__*/function (_B2) {
  function _(e) {
    var _this45;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    _classCallCheck(this, _);
    _this45 = _callSuper(this, _, [t]), _defineProperty(_assertThisInitialized(_this45), "locale", void 0), _defineProperty(_assertThisInitialized(_this45), "_bodyCollectionContainer", void 0), _assertThisInitialized(_this45), _this45.locale = e;
    return _this45;
  }
  _inherits(_, _B2);
  return _createClass(_, [{
    key: "bodyCollectionContainer",
    get: function get() {
      return this._bodyCollectionContainer;
    }
  }, {
    key: "attachToDom",
    value: function attachToDom() {
      this._bodyCollectionContainer = new V({
        tag: "div",
        attributes: {
          class: ["ck", "ck-reset_all", "ck-body", "ck-rounded-corners"],
          dir: this.locale.uiLanguageDirection,
          role: "application"
        },
        children: this
      }).render(), (!_._bodyWrapper || !_._bodyWrapper.isConnected) && (_._bodyWrapper = x(document, "div", {
        class: "ck-body-wrapper"
      }), document.body.appendChild(_._bodyWrapper)), _._bodyWrapper.appendChild(this._bodyCollectionContainer);
    }
  }, {
    key: "detachFromDom",
    value: function detachFromDom() {
      _superPropGet(_, "destroy", this, 3)([]), this._bodyCollectionContainer && this._bodyCollectionContainer.remove(), _._bodyWrapper && !_._bodyWrapper.childElementCount && (_._bodyWrapper.remove(), delete _._bodyWrapper);
    }
  }]);
}(B);
_defineProperty(_, "_bodyWrapper", void 0);
var ft = /*#__PURE__*/function (_p3) {
  function ft(e) {
    var _this46;
    _classCallCheck(this, ft);
    _this46 = _callSuper(this, ft, [e]), _defineProperty(_assertThisInitialized(_this46), "toggleSwitchView", void 0), _this46.isToggleable = !0, _this46.toggleSwitchView = _this46._createToggleView(), _this46.extendTemplate({
      attributes: {
        class: "ck-switchbutton"
      }
    });
    return _this46;
  }
  _inherits(ft, _p3);
  return _createClass(ft, [{
    key: "render",
    value: function render() {
      _superPropGet(ft, "render", this, 3)([]), this.children.add(this.toggleSwitchView);
    }
  }, {
    key: "_createToggleView",
    value: function _createToggleView() {
      var e = new h();
      return e.setTemplate({
        tag: "span",
        attributes: {
          class: ["ck", "ck-button__toggle"]
        },
        children: [{
          tag: "span",
          attributes: {
            class: ["ck", "ck-button__toggle__inner"]
          }
        }]
      }), e;
    }
  }]);
}(p);
var so = /*#__PURE__*/function (_pt) {
  function so() {
    _classCallCheck(this, so);
    return _callSuper(this, so, arguments);
  }
  _inherits(so, _pt);
  return _createClass(so);
}(pt(p));
var yi = /*#__PURE__*/function (_pt2) {
  function yi() {
    _classCallCheck(this, yi);
    return _callSuper(this, yi, arguments);
  }
  _inherits(yi, _pt2);
  return _createClass(yi);
}(pt(W));
function pt(s) {
  var e = /*#__PURE__*/function (_s4) {
    function e() {
      var _this47;
      _classCallCheck(this, e);
      for (var _len5 = arguments.length, i = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        i[_key5] = arguments[_key5];
      }
      _this47 = _callSuper(this, e, [].concat(i)), _defineProperty(_assertThisInitialized(_this47), "buttonView", void 0), _defineProperty(_assertThisInitialized(_this47), "_fileInputView", void 0), _this47.buttonView = _assertThisInitialized(_this47), _this47._fileInputView = new Ci(_this47.locale), _this47._fileInputView.bind("acceptedType").to(_assertThisInitialized(_this47)), _this47._fileInputView.bind("allowMultipleFiles").to(_assertThisInitialized(_this47)), _this47._fileInputView.delegate("done").to(_assertThisInitialized(_this47)), _this47.on("execute", function () {
        _this47._fileInputView.open();
      }), _this47.extendTemplate({
        attributes: {
          class: "ck-file-dialog-button"
        }
      });
      return _this47;
    }
    _inherits(e, _s4);
    return _createClass(e, [{
      key: "render",
      value: function render() {
        _superPropGet(e, "render", this, 3)([]), this.children.add(this._fileInputView);
      }
    }]);
  }(s);
  return e;
}
var Ci = /*#__PURE__*/function (_h1) {
  function Ci(e) {
    var _this48;
    _classCallCheck(this, Ci);
    _this48 = _callSuper(this, Ci, [e]), _this48.set("acceptedType", void 0), _this48.set("allowMultipleFiles", !1);
    var t = _this48.bindTemplate;
    _this48.setTemplate({
      tag: "input",
      attributes: {
        class: ["ck-hidden"],
        type: "file",
        tabindex: "-1",
        accept: t.to("acceptedType"),
        multiple: t.to("allowMultipleFiles")
      },
      on: {
        change: t.to(function () {
          var _this48$element;
          (_this48$element = _this48.element) !== null && _this48$element !== void 0 && (_this48$element = _this48$element.files) !== null && _this48$element !== void 0 && _this48$element.length && _this48.fire("done", _this48.element.files), _this48.element.value = "";
        })
      }
    });
    return _this48;
  }
  _inherits(Ci, _h1);
  return _createClass(Ci, [{
    key: "open",
    value: function open() {
      this.element.click();
    }
  }]);
}(h);
var oo = /*#__PURE__*/function (_h10) {
  function oo(e, t) {
    var _this49;
    _classCallCheck(this, oo);
    _this49 = _callSuper(this, oo, [e]);
    _defineProperty(_this49, "buttonView", void 0);
    _defineProperty(_this49, "children", void 0);
    var i = _this49.bindTemplate;
    _this49.set("isCollapsed", !1), _this49.set("label", ""), _this49.buttonView = _this49._createButtonView(), _this49.children = _this49.createCollection(), _this49.set("_collapsibleAriaLabelUid", void 0), t && _this49.children.addMany(t), _this49.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-collapsible", i.if("isCollapsed", "ck-collapsible_collapsed")]
      },
      children: [_this49.buttonView, {
        tag: "div",
        attributes: {
          class: ["ck", "ck-collapsible__children"],
          role: "region",
          hidden: i.if("isCollapsed", "hidden"),
          "aria-labelledby": i.to("_collapsibleAriaLabelUid")
        },
        children: _this49.children
      }]
    });
    return _this49;
  }
  _inherits(oo, _h10);
  return _createClass(oo, [{
    key: "render",
    value: function render() {
      _superPropGet(oo, "render", this, 3)([]), this._collapsibleAriaLabelUid = this.buttonView.labelView.element.id;
    }
  }, {
    key: "focus",
    value: function focus() {
      this.buttonView.focus();
    }
  }, {
    key: "_createButtonView",
    value: function _createButtonView() {
      var _this50 = this;
      var e = new p(this.locale),
        t = e.bindTemplate;
      return e.set({
        withText: !0,
        icon: ne
      }), e.extendTemplate({
        attributes: {
          "aria-expanded": t.to("isOn", function (i) {
            return String(i);
          })
        }
      }), e.bind("label").to(this), e.bind("isOn").to(this, "isCollapsed", function (i) {
        return !i;
      }), e.on("execute", function () {
        _this50.isCollapsed = !_this50.isCollapsed;
      }), e;
    }
  }]);
}(h);
/**
* @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/
function no(s, e) {
  var t = s.t,
    i = {
      Black: t("Black"),
      "Dim grey": t("Dim grey"),
      Grey: t("Grey"),
      "Light grey": t("Light grey"),
      White: t("White"),
      Red: t("Red"),
      Orange: t("Orange"),
      Yellow: t("Yellow"),
      "Light green": t("Light green"),
      Green: t("Green"),
      Aquamarine: t("Aquamarine"),
      Turquoise: t("Turquoise"),
      "Light blue": t("Light blue"),
      Blue: t("Blue"),
      Purple: t("Purple")
    };
  return e.map(function (o) {
    var n = i[o.label];
    return n && n != o.label && (o.label = n), o;
  });
}
function ro(s) {
  return s.map(Vi).filter(function (e) {
    return !!e;
  });
}
function Vi(s) {
  return typeof s == "string" ? {
    model: s,
    label: s,
    hasBorder: !1,
    view: {
      name: "span",
      styles: {
        color: s
      }
    }
  } : {
    model: s.color,
    label: s.label || s.color,
    hasBorder: s.hasBorder === void 0 ? !1 : s.hasBorder,
    view: {
      name: "span",
      styles: {
        color: "".concat(s.color)
      }
    }
  };
}
var mt = /*#__PURE__*/function (_p4) {
  function mt(e) {
    var _this51;
    _classCallCheck(this, mt);
    _this51 = _callSuper(this, mt, [e]);
    var t = _this51.bindTemplate;
    _this51.set("color", void 0), _this51.set("hasBorder", !1), _this51.icon = Qt, _this51.extendTemplate({
      attributes: {
        style: {
          backgroundColor: t.to("color", function (i) {
            return A.isMediaForcedColors ? null : i;
          })
        },
        class: ["ck", "ck-color-grid__tile", t.if("hasBorder", "ck-color-selector__color-tile_bordered")]
      }
    });
    return _this51;
  }
  _inherits(mt, _p4);
  return _createClass(mt, [{
    key: "render",
    value: function render() {
      _superPropGet(mt, "render", this, 3)([]), this.iconView.fillColor = "hsl(0, 0%, 100%)";
    }
  }]);
}(p);
var Me = /*#__PURE__*/function (_h11) {
  function Me(e, t) {
    var _this52;
    _classCallCheck(this, Me);
    _this52 = _callSuper(this, Me, [e]);
    _defineProperty(_this52, "columns", void 0);
    _defineProperty(_this52, "items", void 0);
    _defineProperty(_this52, "focusTracker", void 0);
    _defineProperty(_this52, "keystrokes", void 0);
    var i = t && t.colorDefinitions ? t.colorDefinitions : [];
    _this52.columns = (t === null || t === void 0 ? void 0 : t.columns) || 5;
    var o = {
      gridTemplateColumns: "repeat( ".concat(_this52.columns, ", 1fr)")
    };
    _this52.set("selectedColor", void 0), _this52.items = _this52.createCollection(), _this52.focusTracker = new b(), _this52.keystrokes = new E(), _this52.items.on("add", function (n, r) {
      r.isOn = r.color === _this52.selectedColor;
    }), i.forEach(function (n) {
      var r = new mt();
      r.set({
        color: n.color,
        label: n.label,
        tooltip: !0,
        hasBorder: n.options.hasBorder
      }), r.on("execute", function () {
        _this52.fire("execute", {
          value: n.color,
          hasBorder: n.options.hasBorder,
          label: n.label
        });
      }), _this52.items.add(r);
    }), _this52.setTemplate({
      tag: "div",
      children: _this52.items,
      attributes: {
        class: ["ck", "ck-color-grid"],
        style: o
      }
    }), _this52.on("change:selectedColor", function (n, r, a) {
      var _iterator17 = _createForOfIteratorHelper(_this52.items),
        _step17;
      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var l = _step17.value;
          l.isOn = l.color === a;
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }
    });
    return _this52;
  }
  _inherits(Me, _h11);
  return _createClass(Me, [{
    key: "focus",
    value: function focus() {
      this.items.length && this.items.first.focus();
    }
  }, {
    key: "focusLast",
    value: function focusLast() {
      this.items.length && this.items.last.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this53 = this,
        _this$locale;
      _superPropGet(Me, "render", this, 3)([]);
      var _iterator18 = _createForOfIteratorHelper(this.items),
        _step18;
      try {
        for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
          var _e1 = _step18.value;
          this.focusTracker.add(_e1.element);
        }
      } catch (err) {
        _iterator18.e(err);
      } finally {
        _iterator18.f();
      }
      this.items.on("add", function (e, t) {
        _this53.focusTracker.add(t.element);
      }), this.items.on("remove", function (e, t) {
        _this53.focusTracker.remove(t.element);
      }), this.keystrokes.listenTo(this.element), fi({
        keystrokeHandler: this.keystrokes,
        focusTracker: this.focusTracker,
        gridItems: this.items,
        numberOfColumns: this.columns,
        uiLanguageDirection: (_this$locale = this.locale) === null || _this$locale === void 0 ? void 0 : _this$locale.uiLanguageDirection
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(Me, "destroy", this, 3)([]), this.focusTracker.destroy(), this.keystrokes.destroy();
    }
  }]);
}(h);
/**
* @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/
function wt(s, e) {
  if (!s) return "";
  var t = bt(s);
  if (!t) return "";
  if (t.space === e) return s;
  if (!Oi(t)) return "";
  var o = ot[t.space][e];
  if (!o) return "";
  var n = o(t.space === "hex" ? t.hexValue : t.values);
  return Ii(n, e);
}
function xi(s) {
  if (!s) return "";
  var e = bt(s);
  return e ? e.space === "hex" ? e.hexValue : wt(s, "hex") : "#000";
}
function Ei(s, e) {
  customElements.get(s) === void 0 && customElements.define(s, e);
}
function Ii(s, e) {
  switch (e) {
    case "hex":
      return "#".concat(s);
    case "rgb":
      return "rgb(".concat(s[0], ", ").concat(s[1], ", ").concat(s[2], ")");
    case "hsl":
      return "hsl(".concat(s[0], ", ").concat(s[1], "%, ").concat(s[2], "%)");
    case "hwb":
      return "hwb(".concat(s[0], ", ").concat(s[1], ", ").concat(s[2], ")");
    case "lab":
      return "lab(".concat(s[0], "% ").concat(s[1], " ").concat(s[2], ")");
    case "lch":
      return "lch(".concat(s[0], "% ").concat(s[1], " ").concat(s[2], ")");
    default:
      return "";
  }
}
function bt(s) {
  if (s.startsWith("#")) {
    var t = Ie(s);
    return {
      space: "hex",
      values: t.values,
      hexValue: s,
      alpha: t.alpha
    };
  }
  var e = Ie(s);
  return e.space ? e : null;
}
function Oi(s) {
  return Object.keys(ot).includes(s.space);
}
var Pi = /*#__PURE__*/function (_h12) {
  function Pi(e, t) {
    var _this54;
    _classCallCheck(this, Pi);
    _this54 = _callSuper(this, Pi, [e]);
    _defineProperty(_this54, "fieldView", void 0);
    _defineProperty(_this54, "labelView", void 0);
    _defineProperty(_this54, "statusView", void 0);
    _defineProperty(_this54, "fieldWrapperChildren", void 0);
    var i = "ck-labeled-field-view-".concat(Q()),
      o = "ck-labeled-field-view-status-".concat(Q());
    _this54.fieldView = t(_this54, i, o), _this54.set("label", void 0), _this54.set("isEnabled", !0), _this54.set("isEmpty", !0), _this54.set("isFocused", !1), _this54.set("errorText", null), _this54.set("infoText", null), _this54.set("class", void 0), _this54.set("placeholder", void 0), _this54.labelView = _this54._createLabelView(i), _this54.statusView = _this54._createStatusView(o), _this54.fieldWrapperChildren = _this54.createCollection([_this54.fieldView, _this54.labelView]), _this54.bind("_statusText").to(_this54, "errorText", _this54, "infoText", function (r, a) {
      return r || a;
    });
    var n = _this54.bindTemplate;
    _this54.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-labeled-field-view", n.to("class"), n.if("isEnabled", "ck-disabled", function (r) {
          return !r;
        }), n.if("isEmpty", "ck-labeled-field-view_empty"), n.if("isFocused", "ck-labeled-field-view_focused"), n.if("placeholder", "ck-labeled-field-view_placeholder"), n.if("errorText", "ck-error")]
      },
      children: [{
        tag: "div",
        attributes: {
          class: ["ck", "ck-labeled-field-view__input-wrapper"]
        },
        children: _this54.fieldWrapperChildren
      }, _this54.statusView]
    });
    return _this54;
  }
  _inherits(Pi, _h12);
  return _createClass(Pi, [{
    key: "_createLabelView",
    value: function _createLabelView(e) {
      var t = new re(this.locale);
      return t.for = e, t.bind("text").to(this, "label"), t;
    }
  }, {
    key: "_createStatusView",
    value: function _createStatusView(e) {
      var t = new h(this.locale),
        i = this.bindTemplate;
      return t.setTemplate({
        tag: "div",
        attributes: {
          class: ["ck", "ck-labeled-field-view__status", i.if("errorText", "ck-labeled-field-view__status_error"), i.if("_statusText", "ck-hidden", function (o) {
            return !o;
          })],
          id: e,
          role: i.if("errorText", "alert")
        },
        children: [{
          text: i.to("_statusText")
        }]
      }), t;
    }
  }, {
    key: "focus",
    value: function focus(e) {
      this.fieldView.focus(e);
    }
  }]);
}(h);
var Bi = /*#__PURE__*/function (_h13) {
  function Bi(e) {
    var _this55;
    _classCallCheck(this, Bi);
    _this55 = _callSuper(this, Bi, [e]), _defineProperty(_assertThisInitialized(_this55), "focusTracker", void 0), _this55.set("value", void 0), _this55.set("id", void 0), _this55.set("placeholder", void 0), _this55.set("tabIndex", void 0), _this55.set("isReadOnly", !1), _this55.set("hasError", !1), _this55.set("ariaDescribedById", void 0), _this55.set("ariaLabel", void 0), _this55.focusTracker = new b(), _this55.bind("isFocused").to(_this55.focusTracker), _this55.set("isEmpty", !0);
    var t = _this55.bindTemplate;
    _this55.setTemplate({
      tag: "input",
      attributes: {
        class: ["ck", "ck-input", t.if("isFocused", "ck-input_focused"), t.if("isEmpty", "ck-input-text_empty"), t.if("hasError", "ck-error")],
        id: t.to("id"),
        placeholder: t.to("placeholder"),
        tabindex: t.to("tabIndex"),
        readonly: t.to("isReadOnly"),
        "aria-invalid": t.if("hasError", !0),
        "aria-describedby": t.to("ariaDescribedById"),
        "aria-label": t.to("ariaLabel")
      },
      on: {
        input: t.to(function () {
          var _this56;
          for (var _len6 = arguments.length, i = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            i[_key6] = arguments[_key6];
          }
          (_this56 = _this55).fire.apply(_this56, ["input"].concat(i)), _this55._updateIsEmpty();
        }),
        change: t.to(_this55._updateIsEmpty.bind(_this55))
      }
    });
    return _this55;
  }
  _inherits(Bi, _h13);
  return _createClass(Bi, [{
    key: "render",
    value: function render() {
      var _this57 = this;
      _superPropGet(Bi, "render", this, 3)([]), this.focusTracker.add(this.element), this._setDomElementValue(this.value), this._updateIsEmpty(), this.on("change:value", function (e, t, i) {
        _this57._setDomElementValue(i), _this57._updateIsEmpty();
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(Bi, "destroy", this, 3)([]), this.focusTracker.destroy();
    }
  }, {
    key: "select",
    value: function select() {
      this.element.select();
    }
  }, {
    key: "focus",
    value: function focus() {
      this.element.focus();
    }
  }, {
    key: "reset",
    value: function reset() {
      this.value = this.element.value = "", this._updateIsEmpty();
    }
  }, {
    key: "_updateIsEmpty",
    value: function _updateIsEmpty() {
      this.isEmpty = Li(this.element);
    }
  }, {
    key: "_setDomElementValue",
    value: function _setDomElementValue(e) {
      this.element.value = !e && e !== 0 ? "" : e;
    }
  }]);
}(h);
function Li(s) {
  return !s.value;
}
var gt = /*#__PURE__*/function (_Bi2) {
  function gt(e) {
    var _this58;
    _classCallCheck(this, gt);
    _this58 = _callSuper(this, gt, [e]), _this58.set("inputMode", "text");
    var t = _this58.bindTemplate;
    _this58.extendTemplate({
      attributes: {
        inputmode: t.to("inputMode")
      }
    });
    return _this58;
  }
  _inherits(gt, _Bi2);
  return _createClass(gt);
}(Bi);
var Fi = /*#__PURE__*/function (_gt) {
  function Fi(e) {
    var _this59;
    _classCallCheck(this, Fi);
    _this59 = _callSuper(this, Fi, [e]), _this59.extendTemplate({
      attributes: {
        type: "text",
        class: ["ck-input-text"]
      }
    });
    return _this59;
  }
  _inherits(Fi, _gt);
  return _createClass(Fi);
}(gt);
var Ai = /*#__PURE__*/function (_gt2) {
  function Ai(e) {
    var _this60;
    var _ref1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      t = _ref1.min,
      i = _ref1.max,
      o = _ref1.step;
    _classCallCheck(this, Ai);
    _this60 = _callSuper(this, Ai, [e]);
    var n = _this60.bindTemplate;
    _this60.set("min", t), _this60.set("max", i), _this60.set("step", o), _this60.extendTemplate({
      attributes: {
        type: "number",
        class: ["ck-input-number"],
        min: n.to("min"),
        max: n.to("max"),
        step: n.to("step")
      }
    });
    return _this60;
  }
  _inherits(Ai, _gt2);
  return _createClass(Ai);
}(gt);
var Di = /*#__PURE__*/function (_h14) {
  function Di(e) {
    var _this61;
    _classCallCheck(this, Di);
    _this61 = _callSuper(this, Di, [e]);
    _defineProperty(_this61, "children", void 0);
    var t = _this61.bindTemplate;
    _this61.set("isVisible", !1), _this61.set("position", "se"), _this61.children = _this61.createCollection(), _this61.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-reset", "ck-dropdown__panel", t.to("position", function (i) {
          return "ck-dropdown__panel_".concat(i);
        }), t.if("isVisible", "ck-dropdown__panel-visible")],
        tabindex: "-1"
      },
      children: _this61.children,
      on: {
        selectstart: t.to(function (i) {
          i.target.tagName.toLocaleLowerCase() !== "input" && i.preventDefault();
        })
      }
    });
    return _this61;
  }
  _inherits(Di, _h14);
  return _createClass(Di, [{
    key: "focus",
    value: function focus() {
      if (this.children.length) {
        var _e10 = this.children.first;
        typeof _e10.focus == "function" ? _e10.focus() : C("ui-dropdown-panel-focus-child-missing-focus", {
          childView: this.children.first,
          dropdownPanel: this
        });
      }
    }
  }, {
    key: "focusLast",
    value: function focusLast() {
      if (this.children.length) {
        var _e11 = this.children.last;
        typeof _e11.focusLast == "function" ? _e11.focusLast() : _e11.focus();
      }
    }
  }]);
}(h);
var ee = /*#__PURE__*/function (_h15) {
  function ee(e, t, i) {
    var _this62;
    _classCallCheck(this, ee);
    _this62 = _callSuper(this, ee, [e]);
    _defineProperty(_this62, "buttonView", void 0);
    _defineProperty(_this62, "panelView", void 0);
    _defineProperty(_this62, "focusTracker", void 0);
    _defineProperty(_this62, "keystrokes", void 0);
    _defineProperty(_this62, "listView", void 0);
    _defineProperty(_this62, "toolbarView", void 0);
    _defineProperty(_this62, "menuView", void 0);
    var o = _this62.bindTemplate;
    _this62.buttonView = t, _this62.panelView = i, _this62.set("isOpen", !1), _this62.set("isEnabled", !0), _this62.set("class", void 0), _this62.set("id", void 0), _this62.set("panelPosition", "auto"), _this62.panelView.bind("isVisible").to(_this62, "isOpen"), _this62.keystrokes = new E(), _this62.focusTracker = new b(), _this62.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-dropdown", o.to("class"), o.if("isEnabled", "ck-disabled", function (n) {
          return !n;
        })],
        id: o.to("id"),
        "aria-describedby": o.to("ariaDescribedById")
      },
      children: [t, i]
    }), t.extendTemplate({
      attributes: {
        class: ["ck-dropdown__button"],
        "data-cke-tooltip-disabled": o.to("isOpen")
      }
    });
    return _this62;
  }
  _inherits(ee, _h15);
  return _createClass(ee, [{
    key: "render",
    value: function render() {
      var _this63 = this;
      _superPropGet(ee, "render", this, 3)([]), this.focusTracker.add(this.buttonView.element), this.focusTracker.add(this.panelView.element), this.listenTo(this.buttonView, "open", function () {
        _this63.isOpen = !_this63.isOpen;
      }), this.on("change:isOpen", function (t, i, o) {
        if (o) if (_this63.panelPosition === "auto") {
          var n = ee._getOptimalPosition({
            element: _this63.panelView.element,
            target: _this63.buttonView.element,
            fitInViewport: !0,
            positions: _this63._panelPositions
          });
          _this63.panelView.position = n ? n.name : _this63._defaultPanelPositionName;
        } else _this63.panelView.position = _this63.panelPosition;
      }), this.keystrokes.listenTo(this.element);
      var e = function e(t, i) {
        _this63.isOpen && (_this63.isOpen = !1, i());
      };
      this.keystrokes.set("arrowdown", function (t, i) {
        _this63.buttonView.isEnabled && !_this63.isOpen && (_this63.isOpen = !0, i());
      }), this.keystrokes.set("arrowright", function (t, i) {
        _this63.isOpen && i();
      }), this.keystrokes.set("arrowleft", e), this.keystrokes.set("esc", e);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.buttonView.focus();
    }
  }, {
    key: "_panelPositions",
    get: function get() {
      var _ee$defaultPanelPosit = ee.defaultPanelPositions,
        e = _ee$defaultPanelPosit.south,
        t = _ee$defaultPanelPosit.north,
        i = _ee$defaultPanelPosit.southEast,
        o = _ee$defaultPanelPosit.southWest,
        n = _ee$defaultPanelPosit.northEast,
        r = _ee$defaultPanelPosit.northWest,
        a = _ee$defaultPanelPosit.southMiddleEast,
        l = _ee$defaultPanelPosit.southMiddleWest,
        c = _ee$defaultPanelPosit.northMiddleEast,
        u = _ee$defaultPanelPosit.northMiddleWest;
      return this.locale.uiLanguageDirection !== "rtl" ? [i, o, a, l, e, n, r, c, u, t] : [o, i, l, a, e, r, n, u, c, t];
    }
  }, {
    key: "_defaultPanelPositionName",
    get: function get() {
      return this.locale.uiLanguageDirection === "rtl" ? "sw" : "se";
    }
  }]);
}(h);
_defineProperty(ee, "defaultPanelPositions", {
  south: function south(e, t) {
    return {
      top: e.bottom,
      left: e.left - (t.width - e.width) / 2,
      name: "s"
    };
  },
  southEast: function southEast(e) {
    return {
      top: e.bottom,
      left: e.left,
      name: "se"
    };
  },
  southWest: function southWest(e, t) {
    return {
      top: e.bottom,
      left: e.left - t.width + e.width,
      name: "sw"
    };
  },
  southMiddleEast: function southMiddleEast(e, t) {
    return {
      top: e.bottom,
      left: e.left - (t.width - e.width) / 4,
      name: "sme"
    };
  },
  southMiddleWest: function southMiddleWest(e, t) {
    return {
      top: e.bottom,
      left: e.left - (t.width - e.width) * 3 / 4,
      name: "smw"
    };
  },
  north: function north(e, t) {
    return {
      top: e.top - t.height,
      left: e.left - (t.width - e.width) / 2,
      name: "n"
    };
  },
  northEast: function northEast(e, t) {
    return {
      top: e.top - t.height,
      left: e.left,
      name: "ne"
    };
  },
  northWest: function northWest(e, t) {
    return {
      top: e.top - t.height,
      left: e.left - t.width + e.width,
      name: "nw"
    };
  },
  northMiddleEast: function northMiddleEast(e, t) {
    return {
      top: e.top - t.height,
      left: e.left - (t.width - e.width) / 4,
      name: "nme"
    };
  },
  northMiddleWest: function northMiddleWest(e, t) {
    return {
      top: e.top - t.height,
      left: e.left - (t.width - e.width) * 3 / 4,
      name: "nmw"
    };
  }
});
_defineProperty(ee, "_getOptimalPosition", me);
var Si = /*#__PURE__*/function (_p5) {
  function Si(e) {
    var _this64;
    _classCallCheck(this, Si);
    _this64 = _callSuper(this, Si, [e]), _defineProperty(_assertThisInitialized(_this64), "arrowView", void 0), _this64.arrowView = _this64._createArrowView(), _this64.extendTemplate({
      attributes: {
        "aria-haspopup": !0,
        "aria-expanded": _this64.bindTemplate.to("isOn", function (t) {
          return String(t);
        })
      }
    }), _this64.delegate("execute").to(_assertThisInitialized(_this64), "open");
    return _this64;
  }
  _inherits(Si, _p5);
  return _createClass(Si, [{
    key: "render",
    value: function render() {
      _superPropGet(Si, "render", this, 3)([]), this.children.add(this.arrowView);
    }
  }, {
    key: "_createArrowView",
    value: function _createArrowView() {
      var e = new L();
      return e.content = ne, e.extendTemplate({
        attributes: {
          class: "ck-dropdown__arrow"
        }
      }), e;
    }
  }]);
}(p);
var P = /*#__PURE__*/function (_h16) {
  function P(e) {
    var _this65;
    _classCallCheck(this, P);
    _this65 = _callSuper(this, P, [e]);
    _defineProperty(_this65, "children", void 0);
    var t = _this65.bindTemplate;
    _this65.set("isVisible", !0), _this65.children = _this65.createCollection(), _this65.setTemplate({
      tag: "li",
      attributes: {
        class: ["ck", "ck-list__item", t.if("isVisible", "ck-hidden", function (i) {
          return !i;
        })],
        role: "presentation"
      },
      children: _this65.children
    });
    return _this65;
  }
  _inherits(P, _h16);
  return _createClass(P, [{
    key: "focus",
    value: function focus() {
      this.children.first && this.children.first.focus();
    }
  }]);
}(h);
var ye = /*#__PURE__*/function (_h17) {
  function ye(e) {
    var _this66;
    _classCallCheck(this, ye);
    _this66 = _callSuper(this, ye, [e]), _this66.setTemplate({
      tag: "li",
      attributes: {
        class: ["ck", "ck-list__separator"]
      }
    });
    return _this66;
  }
  _inherits(ye, _h17);
  return _createClass(ye);
}(h);
var X = /*#__PURE__*/function (_h18) {
  function X(e) {
    var _this67;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new re();
    _classCallCheck(this, X);
    _this67 = _callSuper(this, X, [e]);
    _defineProperty(_this67, "labelView", void 0);
    _defineProperty(_this67, "items", void 0);
    _defineProperty(_this67, "children", void 0);
    var i = _this67.bindTemplate,
      o = new Ce(e);
    _this67.set({
      label: "",
      isVisible: !0
    }), _this67.labelView = t, _this67.labelView.bind("text").to(_this67, "label"), _this67.children = _this67.createCollection(), _this67.children.addMany([_this67.labelView, o]), o.set({
      role: "group",
      ariaLabelledBy: t.id
    }), o.focusTracker.destroy(), o.keystrokes.destroy(), _this67.items = o.items, _this67.setTemplate({
      tag: "li",
      attributes: {
        role: "presentation",
        class: ["ck", "ck-list__group", i.if("isVisible", "ck-hidden", function (n) {
          return !n;
        })]
      },
      children: _this67.children
    });
    return _this67;
  }
  _inherits(X, _h18);
  return _createClass(X, [{
    key: "focus",
    value: function focus() {
      if (this.items) {
        var _e12 = this.items.find(function (t) {
          return !(t instanceof ye);
        });
        _e12 && _e12.focus();
      }
    }
  }]);
}(h);
var Ce = /*#__PURE__*/function (_h19) {
  function Ce(e) {
    var _this68;
    _classCallCheck(this, Ce);
    _this68 = _callSuper(this, Ce, [e]);
    _defineProperty(_this68, "focusables", void 0);
    _defineProperty(_this68, "items", void 0);
    _defineProperty(_this68, "focusTracker", void 0);
    _defineProperty(_this68, "keystrokes", void 0);
    _defineProperty(_this68, "_focusCycler", void 0);
    _defineProperty(_this68, "_listItemGroupToChangeListeners", new WeakMap());
    var t = _this68.bindTemplate;
    _this68.focusables = new B(), _this68.items = _this68.createCollection(), _this68.focusTracker = new b(), _this68.keystrokes = new E(), _this68._focusCycler = new N({
      focusables: _this68.focusables,
      focusTracker: _this68.focusTracker,
      keystrokeHandler: _this68.keystrokes,
      actions: {
        focusPrevious: "arrowup",
        focusNext: "arrowdown"
      }
    }), _this68.set("ariaLabel", void 0), _this68.set("ariaLabelledBy", void 0), _this68.set("role", void 0), _this68.setTemplate({
      tag: "ul",
      attributes: {
        class: ["ck", "ck-reset", "ck-list"],
        role: t.to("role"),
        "aria-label": t.to("ariaLabel"),
        "aria-labelledby": t.to("ariaLabelledBy")
      },
      children: _this68.items
    });
    return _this68;
  }
  _inherits(Ce, _h19);
  return _createClass(Ce, [{
    key: "render",
    value: function render() {
      var _this69 = this;
      _superPropGet(Ce, "render", this, 3)([]);
      var _iterator19 = _createForOfIteratorHelper(this.items),
        _step19;
      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var _e13 = _step19.value;
          _e13 instanceof X ? this._registerFocusableItemsGroup(_e13) : _e13 instanceof P && this._registerFocusableListItem(_e13);
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }
      this.items.on("change", function (e, t) {
        var _iterator20 = _createForOfIteratorHelper(t.removed),
          _step20;
        try {
          for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
            var i = _step20.value;
            i instanceof X ? _this69._deregisterFocusableItemsGroup(i) : i instanceof P && _this69._deregisterFocusableListItem(i);
          }
        } catch (err) {
          _iterator20.e(err);
        } finally {
          _iterator20.f();
        }
        var _iterator21 = _createForOfIteratorHelper(Array.from(t.added).reverse()),
          _step21;
        try {
          for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
            var _i7 = _step21.value;
            _i7 instanceof X ? _this69._registerFocusableItemsGroup(_i7, t.index) : _this69._registerFocusableListItem(_i7, t.index);
          }
        } catch (err) {
          _iterator21.e(err);
        } finally {
          _iterator21.f();
        }
      }), this.keystrokes.listenTo(this.element);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(Ce, "destroy", this, 3)([]), this.focusTracker.destroy(), this.keystrokes.destroy();
    }
  }, {
    key: "focus",
    value: function focus() {
      this._focusCycler.focusFirst();
    }
  }, {
    key: "focusFirst",
    value: function focusFirst() {
      this._focusCycler.focusFirst();
    }
  }, {
    key: "focusLast",
    value: function focusLast() {
      this._focusCycler.focusLast();
    }
  }, {
    key: "_registerFocusableListItem",
    value: function _registerFocusableListItem(e, t) {
      this.focusTracker.add(e.element), this.focusables.add(e, t);
    }
  }, {
    key: "_deregisterFocusableListItem",
    value: function _deregisterFocusableListItem(e) {
      this.focusTracker.remove(e.element), this.focusables.remove(e);
    }
  }, {
    key: "_getOnGroupItemsChangeCallback",
    value: function _getOnGroupItemsChangeCallback(e) {
      var _this70 = this;
      return function (t, i) {
        var _iterator22 = _createForOfIteratorHelper(i.removed),
          _step22;
        try {
          for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
            var o = _step22.value;
            _this70._deregisterFocusableListItem(o);
          }
        } catch (err) {
          _iterator22.e(err);
        } finally {
          _iterator22.f();
        }
        var _iterator23 = _createForOfIteratorHelper(Array.from(i.added).reverse()),
          _step23;
        try {
          for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
            var _o4 = _step23.value;
            _this70._registerFocusableListItem(_o4, _this70.items.getIndex(e) + i.index);
          }
        } catch (err) {
          _iterator23.e(err);
        } finally {
          _iterator23.f();
        }
      };
    }
  }, {
    key: "_registerFocusableItemsGroup",
    value: function _registerFocusableItemsGroup(e, t) {
      var _this71 = this;
      Array.from(e.items).forEach(function (o, n) {
        var r = _typeof(t) < "u" ? t + n : void 0;
        _this71._registerFocusableListItem(o, r);
      });
      var i = this._getOnGroupItemsChangeCallback(e);
      this._listItemGroupToChangeListeners.set(e, i), e.items.on("change", i);
    }
  }, {
    key: "_deregisterFocusableItemsGroup",
    value: function _deregisterFocusableItemsGroup(e) {
      var _iterator24 = _createForOfIteratorHelper(e.items),
        _step24;
      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var t = _step24.value;
          this._deregisterFocusableListItem(t);
        }
      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }
      e.items.off("change", this._listItemGroupToChangeListeners.get(e)), this._listItemGroupToChangeListeners.delete(e);
    }
  }]);
}(h);
var Ne = te("px"),
  Mi = {
    top: -99999,
    left: -99999,
    name: "arrowless",
    config: {
      withArrow: !1
    }
  };
var k = /*#__PURE__*/function (_h20) {
  function k(e) {
    var _this72;
    _classCallCheck(this, k);
    _this72 = _callSuper(this, k, [e]);
    _defineProperty(_this72, "content", void 0);
    _defineProperty(_this72, "_pinWhenIsVisibleCallback", void 0);
    _defineProperty(_this72, "_resizeObserver", void 0);
    var t = _this72.bindTemplate;
    _this72.set("top", 0), _this72.set("left", 0), _this72.set("position", "arrow_nw"), _this72.set("isVisible", !1), _this72.set("withArrow", !0), _this72.set("class", void 0), _this72._pinWhenIsVisibleCallback = null, _this72._resizeObserver = null, _this72.content = _this72.createCollection(), _this72.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-balloon-panel", t.to("position", function (i) {
          return "ck-balloon-panel_".concat(i);
        }), t.if("isVisible", "ck-balloon-panel_visible"), t.if("withArrow", "ck-balloon-panel_with-arrow"), t.to("class")],
        style: {
          top: t.to("top", Ne),
          left: t.to("left", Ne)
        }
      },
      children: _this72.content
    });
    return _this72;
  }
  _inherits(k, _h20);
  return _createClass(k, [{
    key: "destroy",
    value: function destroy() {
      this.hide(), _superPropGet(k, "destroy", this, 3)([]);
    }
  }, {
    key: "show",
    value: function show() {
      this.isVisible = !0;
    }
  }, {
    key: "hide",
    value: function hide() {
      this.isVisible = !1;
    }
  }, {
    key: "attachTo",
    value: function attachTo(e) {
      var t = q(e.target);
      if (t && !O(t)) return !1;
      this.show();
      var i = k.defaultPositions,
        o = Object.assign({}, {
          element: this.element,
          positions: [i.southArrowNorth, i.southArrowNorthMiddleWest, i.southArrowNorthMiddleEast, i.southArrowNorthWest, i.southArrowNorthEast, i.northArrowSouth, i.northArrowSouthMiddleWest, i.northArrowSouthMiddleEast, i.northArrowSouthWest, i.northArrowSouthEast, i.viewportStickyNorth],
          limiter: d.document.body,
          fitInViewport: !0
        }, e),
        n = k._getOptimalPosition(o) || Mi,
        r = parseInt(n.left),
        a = parseInt(n.top),
        l = n.name,
        c = n.config || {},
        _c$withArrow = c.withArrow,
        u = _c$withArrow === void 0 ? !0 : _c$withArrow;
      return this.top = a, this.left = r, this.position = l, this.withArrow = u, !0;
    }
  }, {
    key: "pin",
    value: function pin(e) {
      var _this73 = this;
      this.unpin(), this._startPinning(e) && (this._pinWhenIsVisibleCallback = function () {
        _this73.isVisible ? _this73._startPinning(e) : _this73._stopPinning();
      }, this.listenTo(this, "change:isVisible", this._pinWhenIsVisibleCallback));
    }
  }, {
    key: "unpin",
    value: function unpin() {
      this._pinWhenIsVisibleCallback && (this._stopPinning(), this.stopListening(this, "change:isVisible", this._pinWhenIsVisibleCallback), this._pinWhenIsVisibleCallback = null, this.hide());
    }
  }, {
    key: "_startPinning",
    value: function _startPinning(e) {
      var _this74 = this;
      if (!this.attachTo(e)) return !1;
      var t = q(e.target);
      var i = e.limiter ? q(e.limiter) : d.document.body;
      if (this.listenTo(d.document, "scroll", function (o, n) {
        var r = n.target,
          a = t && r.contains(t),
          l = i && r.contains(i);
        (a || l || !t || !i) && _this74.attachTo(e);
      }, {
        useCapture: !0
      }), this.listenTo(d.window, "resize", function () {
        _this74.attachTo(e);
      }), !this._resizeObserver && (t && At(t) && (t = t.parentElement), t)) {
        var o = function o() {
          O(t) || _this74.unpin();
        };
        this._resizeObserver = new et(t, o);
      }
      return !0;
    }
  }, {
    key: "_stopPinning",
    value: function _stopPinning() {
      this.stopListening(d.document, "scroll"), this.stopListening(d.window, "resize"), this._resizeObserver && (this._resizeObserver.destroy(), this._resizeObserver = null);
    }
  }], [{
    key: "generatePositions",
    value: function generatePositions() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _e$sideOffset = e.sideOffset,
        t = _e$sideOffset === void 0 ? k.arrowSideOffset : _e$sideOffset,
        _e$heightOffset = e.heightOffset,
        i = _e$heightOffset === void 0 ? k.arrowHeightOffset : _e$heightOffset,
        _e$stickyVerticalOffs = e.stickyVerticalOffset,
        o = _e$stickyVerticalOffs === void 0 ? k.stickyVerticalOffset : _e$stickyVerticalOffs,
        n = e.config;
      return {
        northWestArrowSouthWest: function northWestArrowSouthWest(l, c) {
          return _objectSpread({
            top: r(l, c),
            left: l.left - t,
            name: "arrow_sw"
          }, n && {
            config: n
          });
        },
        northWestArrowSouthMiddleWest: function northWestArrowSouthMiddleWest(l, c) {
          return _objectSpread({
            top: r(l, c),
            left: l.left - c.width * .25 - t,
            name: "arrow_smw"
          }, n && {
            config: n
          });
        },
        northWestArrowSouth: function northWestArrowSouth(l, c) {
          return _objectSpread({
            top: r(l, c),
            left: l.left - c.width / 2,
            name: "arrow_s"
          }, n && {
            config: n
          });
        },
        northWestArrowSouthMiddleEast: function northWestArrowSouthMiddleEast(l, c) {
          return _objectSpread({
            top: r(l, c),
            left: l.left - c.width * .75 + t,
            name: "arrow_sme"
          }, n && {
            config: n
          });
        },
        northWestArrowSouthEast: function northWestArrowSouthEast(l, c) {
          return _objectSpread({
            top: r(l, c),
            left: l.left - c.width + t,
            name: "arrow_se"
          }, n && {
            config: n
          });
        },
        northArrowSouthWest: function northArrowSouthWest(l, c) {
          return _objectSpread({
            top: r(l, c),
            left: l.left + l.width / 2 - t,
            name: "arrow_sw"
          }, n && {
            config: n
          });
        },
        northArrowSouthMiddleWest: function northArrowSouthMiddleWest(l, c) {
          return _objectSpread({
            top: r(l, c),
            left: l.left + l.width / 2 - c.width * .25 - t,
            name: "arrow_smw"
          }, n && {
            config: n
          });
        },
        northArrowSouth: function northArrowSouth(l, c) {
          return _objectSpread({
            top: r(l, c),
            left: l.left + l.width / 2 - c.width / 2,
            name: "arrow_s"
          }, n && {
            config: n
          });
        },
        northArrowSouthMiddleEast: function northArrowSouthMiddleEast(l, c) {
          return _objectSpread({
            top: r(l, c),
            left: l.left + l.width / 2 - c.width * .75 + t,
            name: "arrow_sme"
          }, n && {
            config: n
          });
        },
        northArrowSouthEast: function northArrowSouthEast(l, c) {
          return _objectSpread({
            top: r(l, c),
            left: l.left + l.width / 2 - c.width + t,
            name: "arrow_se"
          }, n && {
            config: n
          });
        },
        northEastArrowSouthWest: function northEastArrowSouthWest(l, c) {
          return _objectSpread({
            top: r(l, c),
            left: l.right - t,
            name: "arrow_sw"
          }, n && {
            config: n
          });
        },
        northEastArrowSouthMiddleWest: function northEastArrowSouthMiddleWest(l, c) {
          return _objectSpread({
            top: r(l, c),
            left: l.right - c.width * .25 - t,
            name: "arrow_smw"
          }, n && {
            config: n
          });
        },
        northEastArrowSouth: function northEastArrowSouth(l, c) {
          return _objectSpread({
            top: r(l, c),
            left: l.right - c.width / 2,
            name: "arrow_s"
          }, n && {
            config: n
          });
        },
        northEastArrowSouthMiddleEast: function northEastArrowSouthMiddleEast(l, c) {
          return _objectSpread({
            top: r(l, c),
            left: l.right - c.width * .75 + t,
            name: "arrow_sme"
          }, n && {
            config: n
          });
        },
        northEastArrowSouthEast: function northEastArrowSouthEast(l, c) {
          return _objectSpread({
            top: r(l, c),
            left: l.right - c.width + t,
            name: "arrow_se"
          }, n && {
            config: n
          });
        },
        southWestArrowNorthWest: function southWestArrowNorthWest(l) {
          return _objectSpread({
            top: a(l),
            left: l.left - t,
            name: "arrow_nw"
          }, n && {
            config: n
          });
        },
        southWestArrowNorthMiddleWest: function southWestArrowNorthMiddleWest(l, c) {
          return _objectSpread({
            top: a(l),
            left: l.left - c.width * .25 - t,
            name: "arrow_nmw"
          }, n && {
            config: n
          });
        },
        southWestArrowNorth: function southWestArrowNorth(l, c) {
          return _objectSpread({
            top: a(l),
            left: l.left - c.width / 2,
            name: "arrow_n"
          }, n && {
            config: n
          });
        },
        southWestArrowNorthMiddleEast: function southWestArrowNorthMiddleEast(l, c) {
          return _objectSpread({
            top: a(l),
            left: l.left - c.width * .75 + t,
            name: "arrow_nme"
          }, n && {
            config: n
          });
        },
        southWestArrowNorthEast: function southWestArrowNorthEast(l, c) {
          return _objectSpread({
            top: a(l),
            left: l.left - c.width + t,
            name: "arrow_ne"
          }, n && {
            config: n
          });
        },
        southArrowNorthWest: function southArrowNorthWest(l) {
          return _objectSpread({
            top: a(l),
            left: l.left + l.width / 2 - t,
            name: "arrow_nw"
          }, n && {
            config: n
          });
        },
        southArrowNorthMiddleWest: function southArrowNorthMiddleWest(l, c) {
          return _objectSpread({
            top: a(l),
            left: l.left + l.width / 2 - c.width * .25 - t,
            name: "arrow_nmw"
          }, n && {
            config: n
          });
        },
        southArrowNorth: function southArrowNorth(l, c) {
          return _objectSpread({
            top: a(l),
            left: l.left + l.width / 2 - c.width / 2,
            name: "arrow_n"
          }, n && {
            config: n
          });
        },
        southArrowNorthMiddleEast: function southArrowNorthMiddleEast(l, c) {
          return _objectSpread({
            top: a(l),
            left: l.left + l.width / 2 - c.width * .75 + t,
            name: "arrow_nme"
          }, n && {
            config: n
          });
        },
        southArrowNorthEast: function southArrowNorthEast(l, c) {
          return _objectSpread({
            top: a(l),
            left: l.left + l.width / 2 - c.width + t,
            name: "arrow_ne"
          }, n && {
            config: n
          });
        },
        southEastArrowNorthWest: function southEastArrowNorthWest(l) {
          return _objectSpread({
            top: a(l),
            left: l.right - t,
            name: "arrow_nw"
          }, n && {
            config: n
          });
        },
        southEastArrowNorthMiddleWest: function southEastArrowNorthMiddleWest(l, c) {
          return _objectSpread({
            top: a(l),
            left: l.right - c.width * .25 - t,
            name: "arrow_nmw"
          }, n && {
            config: n
          });
        },
        southEastArrowNorth: function southEastArrowNorth(l, c) {
          return _objectSpread({
            top: a(l),
            left: l.right - c.width / 2,
            name: "arrow_n"
          }, n && {
            config: n
          });
        },
        southEastArrowNorthMiddleEast: function southEastArrowNorthMiddleEast(l, c) {
          return _objectSpread({
            top: a(l),
            left: l.right - c.width * .75 + t,
            name: "arrow_nme"
          }, n && {
            config: n
          });
        },
        southEastArrowNorthEast: function southEastArrowNorthEast(l, c) {
          return _objectSpread({
            top: a(l),
            left: l.right - c.width + t,
            name: "arrow_ne"
          }, n && {
            config: n
          });
        },
        westArrowEast: function westArrowEast(l, c) {
          return _objectSpread({
            top: l.top + l.height / 2 - c.height / 2,
            left: l.left - c.width - i,
            name: "arrow_e"
          }, n && {
            config: n
          });
        },
        eastArrowWest: function eastArrowWest(l, c) {
          return _objectSpread({
            top: l.top + l.height / 2 - c.height / 2,
            left: l.right + i,
            name: "arrow_w"
          }, n && {
            config: n
          });
        },
        viewportStickyNorth: function viewportStickyNorth(l, c, u) {
          var f = new T(d.document.body).getIntersection(u.getVisible());
          if (!f) return null;
          var w = f.getVisible();
          return !l.getIntersection(w) || !(w.top - l.top - o < c.height && w.bottom - l.bottom < c.height) ? null : {
            top: w.top + o,
            left: l.left + l.width / 2 - c.width / 2,
            name: "arrowless",
            config: _objectSpread({
              withArrow: !1
            }, n)
          };
        }
      };
      function r(l, c) {
        return l.top - c.height - i;
      }
      function a(l) {
        return l.bottom + i;
      }
    }
  }]);
}(h);
_k = k;
_defineProperty(k, "arrowSideOffset", 25);
_defineProperty(k, "arrowHeightOffset", 10);
_defineProperty(k, "stickyVerticalOffset", 20);
_defineProperty(k, "_getOptimalPosition", me);
_defineProperty(k, "defaultPositions", _k.generatePositions());
function q(s) {
  return _e(s) ? s : St(s) ? s.commonAncestorContainer : typeof s == "function" ? q(s()) : null;
}
var _t = /*#__PURE__*/function (_h21) {
  function _t(e) {
    var _this75;
    _classCallCheck(this, _t);
    _this75 = _callSuper(this, _t, [e]), _this75.setTemplate({
      tag: "span",
      attributes: {
        class: ["ck", "ck-toolbar__separator"]
      }
    });
    return _this75;
  }
  _inherits(_t, _h21);
  return _createClass(_t);
}(h);
var Ni = /*#__PURE__*/function (_h22) {
  function Ni(e) {
    var _this76;
    _classCallCheck(this, Ni);
    _this76 = _callSuper(this, Ni, [e]), _this76.setTemplate({
      tag: "span",
      attributes: {
        class: ["ck", "ck-toolbar__line-break"]
      }
    });
    return _this76;
  }
  _inherits(Ni, _h22);
  return _createClass(Ni);
}(h);
/**
* @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/
function Wi(s) {
  return s.bindTemplate.to(function (e) {
    e.target === s.element && e.preventDefault();
  });
} /**
  * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
  * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
  */
function Gi(s) {
  if (Array.isArray(s)) return {
    items: s,
    removeItems: []
  };
  var e = {
    items: [],
    removeItems: []
  };
  return s ? _objectSpread(_objectSpread({}, e), s) : e;
}
var Ri = {
  alignLeft: $t,
  bold: Ut,
  importExport: zt,
  paragraph: Ht,
  plus: Rt,
  text: Gt,
  threeVerticalDots: be,
  pilcrow: Wt,
  dragIndicator: Nt
};
var Hi = /*#__PURE__*/function (_h23) {
  function Hi(e, t) {
    var _this77;
    _classCallCheck(this, Hi);
    _this77 = _callSuper(this, Hi, [e]);
    _defineProperty(_this77, "options", void 0);
    _defineProperty(_this77, "items", void 0);
    _defineProperty(_this77, "focusTracker", void 0);
    _defineProperty(_this77, "keystrokes", void 0);
    _defineProperty(_this77, "itemsView", void 0);
    _defineProperty(_this77, "children", void 0);
    _defineProperty(_this77, "focusables", void 0);
    _defineProperty(_this77, "_focusCycler", void 0);
    _defineProperty(_this77, "_behavior", void 0);
    var i = _this77.bindTemplate,
      o = _this77.t;
    _this77.options = t || {}, _this77.set("ariaLabel", o("Editor toolbar")), _this77.set("maxWidth", "auto"), _this77.set("role", "toolbar"), _this77.set("isGrouping", !!_this77.options.shouldGroupWhenFull), _this77.items = _this77.createCollection(), _this77.focusTracker = new b(), _this77.keystrokes = new E(), _this77.set("class", void 0), _this77.set("isCompact", !1), _this77.set("isVertical", !1), _this77.itemsView = new zi(e), _this77.children = _this77.createCollection(), _this77.children.add(_this77.itemsView), _this77.focusables = _this77.createCollection();
    var n = e.uiLanguageDirection === "rtl";
    _this77._focusCycler = new N({
      focusables: _this77.focusables,
      focusTracker: _this77.focusTracker,
      keystrokeHandler: _this77.keystrokes,
      actions: {
        focusPrevious: [n ? "arrowright" : "arrowleft", "arrowup"],
        focusNext: [n ? "arrowleft" : "arrowright", "arrowdown"]
      }
    });
    var r = ["ck", "ck-toolbar", i.to("class"), i.if("isCompact", "ck-toolbar_compact"), i.if("isGrouping", "ck-toolbar_grouping"), i.if("isVertical", "ck-toolbar_vertical")];
    _this77.options.shouldGroupWhenFull && _this77.options.isFloating && r.push("ck-toolbar_floating"), _this77.setTemplate({
      tag: "div",
      attributes: {
        class: r,
        role: i.to("role"),
        "aria-label": i.to("ariaLabel"),
        style: {
          maxWidth: i.to("maxWidth")
        },
        tabindex: -1
      },
      children: _this77.children,
      on: {
        mousedown: Wi(_this77)
      }
    }), _this77._behavior = _this77.options.shouldGroupWhenFull ? new Ge(_this77) : new We(_this77);
    return _this77;
  }
  _inherits(Hi, _h23);
  return _createClass(Hi, [{
    key: "render",
    value: function render() {
      var _this78 = this;
      _superPropGet(Hi, "render", this, 3)([]), this.focusTracker.add(this.element);
      var _iterator25 = _createForOfIteratorHelper(this.items),
        _step25;
      try {
        for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
          var _e14 = _step25.value;
          this.focusTracker.add(_e14);
        }
      } catch (err) {
        _iterator25.e(err);
      } finally {
        _iterator25.f();
      }
      this.items.on("add", function (e, t) {
        _this78.focusTracker.add(t);
      }), this.items.on("remove", function (e, t) {
        _this78.focusTracker.remove(t);
      }), this.keystrokes.listenTo(this.element), this._behavior.render(this);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      return this._behavior.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy(), _superPropGet(Hi, "destroy", this, 3)([]);
    }
  }, {
    key: "focus",
    value: function focus() {
      this._focusCycler.focusFirst();
    }
  }, {
    key: "focusLast",
    value: function focusLast() {
      this._focusCycler.focusLast();
    }
  }, {
    key: "fillFromConfig",
    value: function fillFromConfig(e, t, i) {
      this.items.addMany(this._buildItemsFromConfig(e, t, i));
    }
  }, {
    key: "switchBehavior",
    value: function switchBehavior(e) {
      this._behavior.type !== e && (this._behavior.destroy(), this.itemsView.children.clear(), this.focusables.clear(), e === "dynamic" ? (this._behavior = new Ge(this), this._behavior.render(this), this._behavior.refreshItems()) : (this._behavior = new We(this), this._behavior.render(this)));
    }
  }, {
    key: "_buildItemsFromConfig",
    value: function _buildItemsFromConfig(e, t, i) {
      var _this79 = this;
      var o = Gi(e),
        n = i || o.removeItems;
      return this._cleanItemsConfiguration(o.items, t, n).map(function (a) {
        return Z(a) ? _this79._createNestedToolbarDropdown(a, t, n) : a === "|" ? new _t() : a === "-" ? new Ni() : t.create(a);
      }).filter(function (a) {
        return !!a;
      });
    }
  }, {
    key: "_cleanItemsConfiguration",
    value: function _cleanItemsConfiguration(e, t, i) {
      var _this80 = this;
      var o = e.filter(function (n, r, a) {
        return n === "|" ? !0 : i.indexOf(n) !== -1 ? !1 : n === "-" ? _this80.options.shouldGroupWhenFull ? (C("toolbarview-line-break-ignored-when-grouping-items", a), !1) : !0 : !Z(n) && !t.has(n) ? (C("toolbarview-item-unavailable", {
          item: n
        }), !1) : !0;
      });
      return this._cleanSeparatorsAndLineBreaks(o);
    }
  }, {
    key: "_cleanSeparatorsAndLineBreaks",
    value: function _cleanSeparatorsAndLineBreaks(e) {
      var t = function t(r) {
          return r !== "-" && r !== "|";
        },
        i = e.length,
        o = e.findIndex(t);
      if (o === -1) return [];
      var n = i - e.slice().reverse().findIndex(t);
      return e.slice(o, n).filter(function (r, a, l) {
        return t(r) ? !0 : !(a > 0 && l[a - 1] === r);
      });
    }
  }, {
    key: "_createNestedToolbarDropdown",
    value: function _createNestedToolbarDropdown(e, t, i) {
      var o = e.label,
        n = e.icon,
        r = e.items,
        _e$tooltip = e.tooltip,
        a = _e$tooltip === void 0 ? !0 : _e$tooltip,
        _e$withText = e.withText,
        l = _e$withText === void 0 ? !1 : _e$withText;
      if (r = this._cleanItemsConfiguration(r, t, i), !r.length) return null;
      var c = this.locale,
        u = Ve(c);
      return o || C("toolbarview-nested-toolbar-dropdown-missing-label", e), u.class = "ck-toolbar__nested-toolbar-dropdown", u.buttonView.set({
        label: o,
        tooltip: a,
        withText: !!l
      }), n !== !1 ? u.buttonView.icon = Ri[n] || n || be : u.buttonView.withText = !0, kt(u, function () {
        return u.toolbarView._buildItemsFromConfig(r, t, i);
      }), u;
    }
  }]);
}(h);
var zi = /*#__PURE__*/function (_h24) {
  function zi(e) {
    var _this81;
    _classCallCheck(this, zi);
    _this81 = _callSuper(this, zi, [e]), _defineProperty(_assertThisInitialized(_this81), "children", void 0), _this81.children = _this81.createCollection(), _this81.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-toolbar__items"]
      },
      children: _this81.children
    });
    return _this81;
  }
  _inherits(zi, _h24);
  return _createClass(zi);
}(h);
var We = /*#__PURE__*/function () {
  function We(e) {
    _classCallCheck(this, We);
    _defineProperty(this, "type", "static");
    e.isGrouping = !1, e.itemsView.children.bindTo(e.items).using(function (t) {
      return t;
    }), e.focusables.bindTo(e.items).using(function (t) {
      return z(t) ? t : null;
    });
  }
  return _createClass(We, [{
    key: "render",
    value: function render() {}
  }, {
    key: "destroy",
    value: function destroy() {}
  }]);
}();
var Ge = /*#__PURE__*/function () {
  function Ge(e) {
    var _this82 = this;
    _classCallCheck(this, Ge);
    _defineProperty(this, "type", "dynamic");
    _defineProperty(this, "view", void 0);
    _defineProperty(this, "viewChildren", void 0);
    _defineProperty(this, "viewFocusables", void 0);
    _defineProperty(this, "viewItemsView", void 0);
    _defineProperty(this, "viewFocusTracker", void 0);
    _defineProperty(this, "viewLocale", void 0);
    _defineProperty(this, "ungroupedItems", void 0);
    _defineProperty(this, "groupedItems", void 0);
    _defineProperty(this, "groupedItemsDropdown", void 0);
    _defineProperty(this, "resizeObserver", null);
    _defineProperty(this, "cachedPadding", null);
    _defineProperty(this, "shouldUpdateGroupingOnNextResize", !1);
    _defineProperty(this, "viewElement", void 0);
    this.view = e, this.viewChildren = e.children, this.viewFocusables = e.focusables, this.viewItemsView = e.itemsView, this.viewFocusTracker = e.focusTracker, this.viewLocale = e.locale, this.view.isGrouping = !0, this.ungroupedItems = e.createCollection(), this.groupedItems = e.createCollection(), this.groupedItemsDropdown = this._createGroupedItemsDropdown(), e.itemsView.children.bindTo(this.ungroupedItems).using(function (t) {
      return t;
    }), this.ungroupedItems.on("change", this._updateFocusCyclableItems.bind(this)), e.children.on("change", this._updateFocusCyclableItems.bind(this)), e.items.on("change", function (t, i) {
      var o = i.index,
        n = Array.from(i.added);
      var _iterator26 = _createForOfIteratorHelper(i.removed),
        _step26;
      try {
        for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
          var _r = _step26.value;
          o >= _this82.ungroupedItems.length ? _this82.groupedItems.remove(_r) : _this82.ungroupedItems.remove(_r);
        }
      } catch (err) {
        _iterator26.e(err);
      } finally {
        _iterator26.f();
      }
      for (var r = o; r < o + n.length; r++) {
        var a = n[r - o];
        r > _this82.ungroupedItems.length ? _this82.groupedItems.add(a, r - _this82.ungroupedItems.length) : _this82.ungroupedItems.add(a, r);
      }
      _this82._updateGrouping();
    });
  }
  return _createClass(Ge, [{
    key: "render",
    value: function render(e) {
      this.viewElement = e.element, this._enableGroupingOnResize(), this._enableGroupingOnMaxWidthChange(e);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.groupedItemsDropdown.destroy(), this.viewChildren.length > 1 && (this.viewChildren.remove(this.groupedItemsDropdown), this.viewChildren.remove(this.viewChildren.last)), this.resizeObserver.destroy();
    }
  }, {
    key: "refreshItems",
    value: function refreshItems() {
      var e = this.view;
      if (e.items.length) {
        for (var t = 0; t < e.items.length; t++) {
          var i = _toConsumableArray(e.items)[t];
          this.ungroupedItems.add(i, t);
        }
        this._updateGrouping();
      }
    }
  }, {
    key: "_updateGrouping",
    value: function _updateGrouping() {
      if (!this.viewElement.ownerDocument.body.contains(this.viewElement)) return;
      if (!O(this.viewElement)) {
        this.shouldUpdateGroupingOnNextResize = !0;
        return;
      }
      var e = this.groupedItems.length;
      var t;
      for (; this._areItemsOverflowing;) this._groupLastItem(), t = !0;
      if (!t && this.groupedItems.length) {
        for (; this.groupedItems.length && !this._areItemsOverflowing;) this._ungroupFirstItem();
        this._areItemsOverflowing && this._groupLastItem();
      }
      this.groupedItems.length !== e && this.view.fire("groupedItemsUpdate");
    }
  }, {
    key: "_areItemsOverflowing",
    get: function get() {
      if (!this.ungroupedItems.length) return !1;
      var e = this.viewElement,
        t = this.viewLocale.uiLanguageDirection,
        i = new T(e.lastChild),
        o = new T(e);
      if (!this.cachedPadding) {
        var n = d.window.getComputedStyle(e),
          r = t === "ltr" ? "paddingRight" : "paddingLeft";
        this.cachedPadding = Number.parseInt(n[r]);
      }
      return t === "ltr" ? i.right > o.right - this.cachedPadding : i.left < o.left + this.cachedPadding;
    }
  }, {
    key: "_enableGroupingOnResize",
    value: function _enableGroupingOnResize() {
      var _this83 = this;
      var e;
      this.resizeObserver = new et(this.viewElement, function (t) {
        (!e || e !== t.contentRect.width || _this83.shouldUpdateGroupingOnNextResize) && (_this83.shouldUpdateGroupingOnNextResize = !1, _this83._updateGrouping(), e = t.contentRect.width);
      }), this._updateGrouping();
    }
  }, {
    key: "_enableGroupingOnMaxWidthChange",
    value: function _enableGroupingOnMaxWidthChange(e) {
      var _this84 = this;
      e.on("change:maxWidth", function () {
        _this84._updateGrouping();
      });
    }
  }, {
    key: "_groupLastItem",
    value: function _groupLastItem() {
      this.groupedItems.length || (this.viewChildren.add(new _t()), this.viewChildren.add(this.groupedItemsDropdown), this.viewFocusTracker.add(this.groupedItemsDropdown.element)), this.groupedItems.add(this.ungroupedItems.remove(this.ungroupedItems.last), 0);
    }
  }, {
    key: "_ungroupFirstItem",
    value: function _ungroupFirstItem() {
      this.ungroupedItems.add(this.groupedItems.remove(this.groupedItems.first)), this.groupedItems.length || (this.viewChildren.remove(this.groupedItemsDropdown), this.viewChildren.remove(this.viewChildren.last), this.viewFocusTracker.remove(this.groupedItemsDropdown.element));
    }
  }, {
    key: "_createGroupedItemsDropdown",
    value: function _createGroupedItemsDropdown() {
      var e = this.viewLocale,
        t = e.t,
        i = Ve(e);
      return i.class = "ck-toolbar__grouped-dropdown", i.panelPosition = e.uiLanguageDirection === "ltr" ? "sw" : "se", kt(i, this.groupedItems), i.buttonView.set({
        label: t("Show more items"),
        tooltip: !0,
        tooltipPosition: e.uiLanguageDirection === "rtl" ? "se" : "sw",
        icon: be
      }), i;
    }
  }, {
    key: "_updateFocusCyclableItems",
    value: function _updateFocusCyclableItems() {
      var _this85 = this;
      this.viewFocusables.clear(), this.ungroupedItems.map(function (e) {
        z(e) && _this85.viewFocusables.add(e);
      }), this.groupedItems.length && this.viewFocusables.add(this.groupedItemsDropdown);
    }
  }]);
}();
var Ui = /*#__PURE__*/function (_h25) {
  function Ui(e, t) {
    var _this86;
    _classCallCheck(this, Ui);
    _this86 = _callSuper(this, Ui, [e]);
    _defineProperty(_this86, "children", void 0);
    _defineProperty(_this86, "actionView", void 0);
    _defineProperty(_this86, "arrowView", void 0);
    _defineProperty(_this86, "keystrokes", void 0);
    _defineProperty(_this86, "focusTracker", void 0);
    var i = _this86.bindTemplate;
    _this86.set("class", void 0), _this86.set("labelStyle", void 0), _this86.set("icon", void 0), _this86.set("isEnabled", !0), _this86.set("isOn", !1), _this86.set("isToggleable", !1), _this86.set("isVisible", !0), _this86.set("keystroke", void 0), _this86.set("withKeystroke", !1), _this86.set("label", void 0), _this86.set("tabindex", -1), _this86.set("tooltip", !1), _this86.set("tooltipPosition", "s"), _this86.set("type", "button"), _this86.set("withText", !1), _this86.children = _this86.createCollection(), _this86.actionView = _this86._createActionView(t), _this86.arrowView = _this86._createArrowView(), _this86.keystrokes = new E(), _this86.focusTracker = new b(), _this86.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-splitbutton", i.to("class"), i.if("isVisible", "ck-hidden", function (o) {
          return !o;
        }), _this86.arrowView.bindTemplate.if("isOn", "ck-splitbutton_open")]
      },
      children: _this86.children
    });
    return _this86;
  }
  _inherits(Ui, _h25);
  return _createClass(Ui, [{
    key: "render",
    value: function render() {
      var _this87 = this;
      _superPropGet(Ui, "render", this, 3)([]), this.children.add(this.actionView), this.children.add(this.arrowView), this.focusTracker.add(this.actionView.element), this.focusTracker.add(this.arrowView.element), this.keystrokes.listenTo(this.element), this.keystrokes.set("arrowright", function (e, t) {
        _this87.focusTracker.focusedElement === _this87.actionView.element && (_this87.arrowView.focus(), t());
      }), this.keystrokes.set("arrowleft", function (e, t) {
        _this87.focusTracker.focusedElement === _this87.arrowView.element && (_this87.actionView.focus(), t());
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(Ui, "destroy", this, 3)([]), this.focusTracker.destroy(), this.keystrokes.destroy();
    }
  }, {
    key: "focus",
    value: function focus() {
      this.actionView.focus();
    }
  }, {
    key: "_createActionView",
    value: function _createActionView(e) {
      var t = e || new p();
      return e || t.bind("icon", "isEnabled", "isOn", "isToggleable", "keystroke", "label", "tabindex", "tooltip", "tooltipPosition", "type", "withText").to(this), t.extendTemplate({
        attributes: {
          class: "ck-splitbutton__action"
        }
      }), t.delegate("execute").to(this), t;
    }
  }, {
    key: "_createArrowView",
    value: function _createArrowView() {
      var e = new p(),
        t = e.bindTemplate;
      return e.icon = ne, e.extendTemplate({
        attributes: {
          class: ["ck-splitbutton__arrow"],
          "data-cke-tooltip-disabled": t.to("isOn"),
          "aria-haspopup": !0,
          "aria-expanded": t.to("isOn", function (i) {
            return String(i);
          })
        }
      }), e.bind("isEnabled").to(this), e.bind("label").to(this), e.bind("tooltip").to(this), e.delegate("execute").to(this, "open"), e;
    }
  }]);
}(h);
function Ve(s) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Si;
  var t = typeof e == "function" ? new e(s) : e,
    i = new Di(s),
    o = new ee(s, t, i);
  return t.bind("isEnabled").to(o), t instanceof Ui ? t.arrowView.bind("isOn").to(o, "isOpen") : t.bind("isOn").to(o, "isOpen"), $i(o), o;
}
function kt(s, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  s.extendTemplate({
    attributes: {
      class: ["ck-toolbar-dropdown"]
    }
  }), s.isOpen ? Re(s, e, t) : s.once("change:isOpen", function () {
    return Re(s, e, t);
  }, {
    priority: "highest"
  }), t.enableActiveItemFocusOnDropdownOpen && Tt(s, function () {
    return s.toolbarView.items.find(function (i) {
      return i.isOn;
    });
  });
}
function Re(s, e, t) {
  var i = s.locale,
    o = i.t,
    n = s.toolbarView = new Hi(i),
    r = typeof e == "function" ? e() : e;
  n.ariaLabel = t.ariaLabel || o("Dropdown toolbar"), t.maxWidth && (n.maxWidth = t.maxWidth), t.class && (n.class = t.class), t.isCompact && (n.isCompact = t.isCompact), t.isVertical && (n.isVertical = !0), r instanceof B ? n.items.bindTo(r).using(function (a) {
    return a;
  }) : n.items.addMany(r), s.panelView.children.add(n), s.focusTracker.add(n), n.items.delegate("execute").to(s);
}
function lo(s, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  s.isOpen ? He(s, e, t) : s.once("change:isOpen", function () {
    return He(s, e, t);
  }, {
    priority: "highest"
  }), Tt(s, function () {
    return s.listView.items.find(function (i) {
      return i instanceof P ? i.children.first.isOn : !1;
    });
  });
}
function He(s, e, t) {
  var i = s.locale,
    o = s.listView = new Ce(i),
    n = typeof e == "function" ? e() : e;
  o.ariaLabel = t.ariaLabel, o.role = t.role, yt(s, o.items, n, i), s.panelView.children.add(o), o.items.delegate("execute").to(s);
}
function Tt(s, e) {
  s.on("change:isOpen", function () {
    if (!s.isOpen) return;
    var t = e();
    t && (typeof t.focus == "function" ? t.focus() : C("ui-dropdown-focus-child-on-open-child-missing-focus", {
      view: t
    }));
  }, {
    priority: Ft.low - 10
  });
}
function $i(s) {
  Ki(s), ji(s), Xi(s), qi(s), Yi(s), Qi(s);
}
function Ki(s) {
  ht({
    emitter: s,
    activator: function activator() {
      return s.isRendered && s.isOpen;
    },
    callback: function callback() {
      s.isOpen = !1;
    },
    contextElements: function contextElements() {
      return [s.element].concat(_toConsumableArray(vt(s.focusTracker).filter(function (e) {
        return !s.element.contains(e);
      })));
    }
  });
}
function vt(s) {
  return [].concat(_toConsumableArray(s.elements), _toConsumableArray(s.externalViews.flatMap(function (e) {
    return vt(e.focusTracker);
  })));
}
function ji(s) {
  s.on("execute", function (e) {
    e.source instanceof ft || (s.isOpen = !1);
  });
}
function Xi(s) {
  s.focusTracker.on("change:isFocused", function (e, t, i) {
    i || !s.isOpen || (s.isOpen = !1);
  });
}
function qi(s) {
  s.keystrokes.set("arrowdown", function (e, t) {
    s.isOpen && (s.panelView.focus(), t());
  }), s.keystrokes.set("arrowup", function (e, t) {
    s.isOpen && (s.panelView.focusLast(), t());
  });
}
function Yi(s) {
  s.on("change:isOpen", function (e, t, i) {
    if (i) return;
    s.focusTracker.elements.some(function (n) {
      return n.contains(d.document.activeElement);
    }) && s.buttonView.focus();
  });
}
function Qi(s) {
  s.on("change:isOpen", function (e, t, i) {
    i && s.panelView.focus();
  }, {
    priority: "low"
  });
}
function yt(s, e, t, i) {
  Zi(e), e.bindTo(t).using(function (o) {
    if (o.type === "separator") return new ye(i);
    if (o.type === "group") {
      var n = new X(i);
      return n.set({
        label: o.label
      }), yt(s, n.items, o.items, i), n.items.delegate("execute").to(s), n;
    } else if (o.type === "button" || o.type === "switchbutton") {
      var _a2;
      var _n2 = o.model.role === "menuitemcheckbox" || o.model.role === "menuitemradio",
        r = new P(i);
      var a;
      return o.type === "button" ? (a = new W(i), a.set({
        isToggleable: _n2
      })) : a = new ft(i), (_a2 = a).bind.apply(_a2, _toConsumableArray(Object.keys(o.model))).to(o.model), a.delegate("execute").to(r), r.children.add(a), r;
    }
    return null;
  });
}
function Zi(s) {
  var e = 0;
  var t = function t(n) {
      return !(n instanceof P) || !(n.children.first instanceof W) ? null : n.children.first;
    },
    i = function i(n) {
      var r = t(n);
      return !r || !r.isToggleable ? null : r;
    },
    o = function o(n) {
      var _iterator27 = _createForOfIteratorHelper(s),
        _step27;
      try {
        for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
          var r = _step27.value;
          var a = t(r);
          a && (a.hasCheckSpace = n);
        }
      } catch (err) {
        _iterator27.e(err);
      } finally {
        _iterator27.f();
      }
    };
  s.on("change", function (n, r) {
    var a = e > 0;
    var _iterator28 = _createForOfIteratorHelper(r.removed),
      _step28;
    try {
      for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
        var c = _step28.value;
        i(c) && e--;
      }
    } catch (err) {
      _iterator28.e(err);
    } finally {
      _iterator28.f();
    }
    var _iterator29 = _createForOfIteratorHelper(r.added),
      _step29;
    try {
      for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
        var _c = _step29.value;
        var u = t(_c);
        u && (u.isToggleable && e++, u.hasCheckSpace = e > 0);
      }
    } catch (err) {
      _iterator29.e(err);
    } finally {
      _iterator29.f();
    }
    var l = e > 0;
    a !== l && o(l);
  });
}
var Ji = function Ji(s, e, t) {
    var i = new Fi(s.locale);
    return i.set({
      id: e,
      ariaDescribedById: t
    }), i.bind("isReadOnly").to(s, "isEnabled", function (o) {
      return !o;
    }), i.bind("hasError").to(s, "errorText", function (o) {
      return !!o;
    }), i.on("input", function () {
      s.errorText = null;
    }), s.bind("isEmpty", "isFocused", "placeholder").to(i), i;
  },
  ao = function ao(s, e, t) {
    var i = new Ai(s.locale);
    return i.set({
      id: e,
      ariaDescribedById: t,
      inputMode: "numeric"
    }), i.bind("isReadOnly").to(s, "isEnabled", function (o) {
      return !o;
    }), i.bind("hasError").to(s, "errorText", function (o) {
      return !!o;
    }), i.on("input", function () {
      s.errorText = null;
    }), s.bind("isEmpty", "isFocused", "placeholder").to(i), i;
  },
  co = function co(s, e, t) {
    var i = Ve(s.locale);
    return i.set({
      id: e,
      ariaDescribedById: t
    }), i.bind("isEnabled").to(s), i;
  },
  es = 150;
var ts = /*#__PURE__*/function (_h26) {
  function ts(e) {
    var _this88;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, ts);
    _this88 = _callSuper(this, ts, [e]), _defineProperty(_assertThisInitialized(_this88), "hexInputRow", void 0), _defineProperty(_assertThisInitialized(_this88), "_debounceColorPickerEvent", void 0), _defineProperty(_assertThisInitialized(_this88), "_config", void 0), _this88.set({
      color: "",
      _hexColor: ""
    }), _this88.hexInputRow = _this88._createInputRow();
    var i = _this88.createCollection();
    t.hideInput || i.add(_this88.hexInputRow), _this88.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-color-picker"],
        tabindex: -1
      },
      children: i
    }), _this88._config = t, _this88._debounceColorPickerEvent = fe(function (o) {
      _this88.set("color", o), _this88.fire("colorSelected", {
        color: _this88.color
      });
    }, es, {
      leading: !0
    }), _this88.on("set:color", function (o, n, r) {
      o.return = wt(r, _this88._config.format || "hsl");
    }), _this88.on("change:color", function () {
      _this88._hexColor = ae(_this88.color);
    }), _this88.on("change:_hexColor", function () {
      document.activeElement !== _this88.picker && _this88.picker.setAttribute("color", _this88._hexColor), ae(_this88.color) != ae(_this88._hexColor) && (_this88.color = _this88._hexColor);
    });
    return _this88;
  }
  _inherits(ts, _h26);
  return _createClass(ts, [{
    key: "render",
    value: function render() {
      var _this89 = this;
      if (_superPropGet(ts, "render", this, 3)([]), Ei("hex-color-picker", Zt), this.picker = d.document.createElement("hex-color-picker"), this.picker.setAttribute("class", "hex-color-picker"), this.picker.setAttribute("tabindex", "-1"), this._createSlidersView(), this.element) {
        this.hexInputRow.element ? this.element.insertBefore(this.picker, this.hexInputRow.element) : this.element.appendChild(this.picker);
        var _e15 = document.createElement("style");
        _e15.textContent = '[role="slider"]:focus [part$="pointer"] {border: 1px solid #fff;outline: 1px solid var(--ck-color-focus-border);box-shadow: 0 0 0 2px #fff;}', this.picker.shadowRoot.appendChild(_e15);
      }
      this.picker.addEventListener("color-changed", function (e) {
        var t = e.detail.value;
        _this89._debounceColorPickerEvent(t);
      });
    }
  }, {
    key: "focus",
    value: function focus() {
      /* istanbul ignore next -- @preserve */!this._config.hideInput && (A.isGecko || A.isiOS || A.isSafari || A.isBlink) && this.hexInputRow.children.get(1).focus(), this.slidersView.first.focus();
    }
  }, {
    key: "_createSlidersView",
    value: function _createSlidersView() {
      var _this90 = this;
      var i = _toConsumableArray(this.picker.shadowRoot.children).filter(function (o) {
        return o.getAttribute("role") === "slider";
      }).map(function (o) {
        return new is(o);
      });
      this.slidersView = this.createCollection(), i.forEach(function (o) {
        _this90.slidersView.add(o);
      });
    }
  }, {
    key: "_createInputRow",
    value: function _createInputRow() {
      var e = this._createColorInput();
      return new os(this.locale, e);
    }
  }, {
    key: "_createColorInput",
    value: function _createColorInput() {
      var _this91 = this;
      var e = new Pi(this.locale, Ji),
        t = this.locale.t;
      return e.set({
        label: t("HEX"),
        class: "color-picker-hex-input"
      }), e.fieldView.bind("value").to(this, "_hexColor", function (i) {
        return e.isFocused ? e.fieldView.value : i.startsWith("#") ? i.substring(1) : i;
      }), e.fieldView.on("input", function () {
        var i = e.fieldView.element.value;
        if (i) {
          var o = Ct(i);
          o && _this91._debounceColorPickerEvent(o);
        }
      }), e;
    }
  }, {
    key: "isValid",
    value: function isValid() {
      var e = this.locale.t;
      return this._config.hideInput ? !0 : (this.resetValidationStatus(), this.hexInputRow.getParsedColor() ? !0 : (this.hexInputRow.inputView.errorText = e('Please enter a valid color (e.g. "ff0000").'), !1));
    }
  }, {
    key: "resetValidationStatus",
    value: function resetValidationStatus() {
      this.hexInputRow.inputView.errorText = null;
    }
  }]);
}(h);
function ae(s) {
  var e = xi(s);
  return e || (e = "#000"), e.length === 4 && (e = "#" + [e[1], e[1], e[2], e[2], e[3], e[3]].join("")), e.toLowerCase();
}
var is = /*#__PURE__*/function (_h27) {
  function is(e) {
    var _this92;
    _classCallCheck(this, is);
    _this92 = _callSuper(this, is), _this92.element = e;
    return _this92;
  }
  _inherits(is, _h27);
  return _createClass(is, [{
    key: "focus",
    value: function focus() {
      this.element.focus();
    }
  }]);
}(h);
var ss = /*#__PURE__*/function (_h28) {
  function ss(e) {
    var _this93;
    _classCallCheck(this, ss);
    _this93 = _callSuper(this, ss, [e]), _this93.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-color-picker__hash-view"]
      },
      children: "#"
    });
    return _this93;
  }
  _inherits(ss, _h28);
  return _createClass(ss);
}(h);
var os = /*#__PURE__*/function (_h29) {
  function os(e, t) {
    var _this94;
    _classCallCheck(this, os);
    _this94 = _callSuper(this, os, [e]), _defineProperty(_assertThisInitialized(_this94), "children", void 0), _defineProperty(_assertThisInitialized(_this94), "inputView", void 0), _this94.inputView = t, _this94.children = _this94.createCollection([new ss(), _this94.inputView]), _this94.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-color-picker__row"]
      },
      children: _this94.children
    });
    return _this94;
  }
  _inherits(os, _h29);
  return _createClass(os, [{
    key: "getParsedColor",
    value: function getParsedColor() {
      return Ct(this.inputView.fieldView.element.value);
    }
  }]);
}(h);
function Ct(s) {
  if (!s) return null;
  var e = s.trim().replace(/^#/, "");
  return ![3, 4, 6, 8].includes(e.length) || !/^(([0-9a-fA-F]{2}){3,4}|([0-9a-fA-F]){3,4})$/.test(e) ? null : "#".concat(e);
}
var ns = /*#__PURE__*/function (_se) {
  function ns(e) {
    var _this95;
    _classCallCheck(this, ns);
    _this95 = _callSuper(this, ns, [e]), _this95.set("isEmpty", !0), _this95.on("change", function () {
      _this95.set("isEmpty", _this95.length === 0);
    });
    return _this95;
  }
  _inherits(ns, _se);
  return _createClass(ns, [{
    key: "add",
    value: function add(e, t) {
      return this.find(function (i) {
        return i.color === e.color;
      }) ? this : _superPropGet(ns, "add", this, 3)([e, t]);
    }
  }, {
    key: "hasColor",
    value: function hasColor(e) {
      return !!this.find(function (t) {
        return t.color === e;
      });
    }
  }]);
}(se(pe));
var rs = /*#__PURE__*/function (_h30) {
  function rs(e, _ref10) {
    var _this96;
    var t = _ref10.colors,
      i = _ref10.columns,
      o = _ref10.removeButtonLabel,
      n = _ref10.documentColorsLabel,
      r = _ref10.documentColorsCount,
      a = _ref10.colorPickerLabel,
      l = _ref10.focusTracker,
      c = _ref10.focusables;
    _classCallCheck(this, rs);
    _this96 = _callSuper(this, rs, [e]);
    _defineProperty(_this96, "items", void 0);
    _defineProperty(_this96, "colorDefinitions", void 0);
    _defineProperty(_this96, "focusTracker", void 0);
    _defineProperty(_this96, "columns", void 0);
    _defineProperty(_this96, "documentColors", void 0);
    _defineProperty(_this96, "documentColorsCount", void 0);
    _defineProperty(_this96, "staticColorsGrid", void 0);
    _defineProperty(_this96, "documentColorsGrid", void 0);
    _defineProperty(_this96, "colorPickerButtonView", void 0);
    _defineProperty(_this96, "removeColorButtonView", void 0);
    _defineProperty(_this96, "_focusables", void 0);
    _defineProperty(_this96, "_documentColorsLabel", void 0);
    _defineProperty(_this96, "_removeButtonLabel", void 0);
    _defineProperty(_this96, "_colorPickerLabel", void 0);
    var u = _this96.bindTemplate;
    _this96.set("isVisible", !0), _this96.focusTracker = l, _this96.items = _this96.createCollection(), _this96.colorDefinitions = t, _this96.columns = i, _this96.documentColors = new ns(), _this96.documentColorsCount = r, _this96._focusables = c, _this96._removeButtonLabel = o, _this96._colorPickerLabel = a, _this96._documentColorsLabel = n, _this96.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck-color-grids-fragment", u.if("isVisible", "ck-hidden", function (f) {
          return !f;
        })]
      },
      children: _this96.items
    }), _this96.removeColorButtonView = _this96._createRemoveColorButton(), _this96.items.add(_this96.removeColorButtonView);
    return _this96;
  }
  _inherits(rs, _h30);
  return _createClass(rs, [{
    key: "updateDocumentColors",
    value: function updateDocumentColors(e, t) {
      var i = e.document,
        o = this.documentColorsCount;
      this.documentColors.clear();
      var _iterator30 = _createForOfIteratorHelper(i.getRoots()),
        _step30;
      try {
        for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
          var n = _step30.value;
          var r = e.createRangeIn(n);
          var _iterator31 = _createForOfIteratorHelper(r.getItems()),
            _step31;
          try {
            for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
              var a = _step31.value;
              if (a.is("$textProxy") && a.hasAttribute(t) && (this._addColorToDocumentColors(a.getAttribute(t)), this.documentColors.length >= o)) return;
            }
          } catch (err) {
            _iterator31.e(err);
          } finally {
            _iterator31.f();
          }
        }
      } catch (err) {
        _iterator30.e(err);
      } finally {
        _iterator30.f();
      }
    }
  }, {
    key: "updateSelectedColors",
    value: function updateSelectedColors() {
      var e = this.documentColorsGrid,
        t = this.staticColorsGrid,
        i = this.selectedColor;
      t.selectedColor = i, e && (e.selectedColor = i);
    }
  }, {
    key: "render",
    value: function render() {
      if (_superPropGet(rs, "render", this, 3)([]), this.staticColorsGrid = this._createStaticColorsGrid(), this.items.add(this.staticColorsGrid), this.documentColorsCount) {
        var _e16 = V.bind(this.documentColors, this.documentColors),
          t = new h(this.locale);
        t.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-color-grid__label", _e16.if("isEmpty", "ck-hidden")]
          },
          children: [{
            text: this._documentColorsLabel
          }]
        }), this.items.add(t), this.documentColorsGrid = this._createDocumentColorsGrid(), this.items.add(this.documentColorsGrid);
      }
      this._createColorPickerButton(), this._addColorSelectorElementsToFocusTracker();
    }
  }, {
    key: "focus",
    value: function focus() {
      this.removeColorButtonView.focus();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(rs, "destroy", this, 3)([]);
    }
  }, {
    key: "addColorPickerButton",
    value: function addColorPickerButton() {
      this.colorPickerButtonView && (this.items.add(this.colorPickerButtonView), this.focusTracker.add(this.colorPickerButtonView.element), this._focusables.add(this.colorPickerButtonView));
    }
  }, {
    key: "_addColorSelectorElementsToFocusTracker",
    value: function _addColorSelectorElementsToFocusTracker() {
      this.focusTracker.add(this.removeColorButtonView.element), this._focusables.add(this.removeColorButtonView), this.staticColorsGrid && (this.focusTracker.add(this.staticColorsGrid.element), this._focusables.add(this.staticColorsGrid)), this.documentColorsGrid && (this.focusTracker.add(this.documentColorsGrid.element), this._focusables.add(this.documentColorsGrid));
    }
  }, {
    key: "_createColorPickerButton",
    value: function _createColorPickerButton() {
      var _this97 = this;
      this.colorPickerButtonView = new p(), this.colorPickerButtonView.set({
        label: this._colorPickerLabel,
        withText: !0,
        icon: Xt,
        class: "ck-color-selector__color-picker"
      }), this.colorPickerButtonView.on("execute", function () {
        _this97.fire("colorPicker:show");
      });
    }
  }, {
    key: "_createRemoveColorButton",
    value: function _createRemoveColorButton() {
      var _this98 = this;
      var e = new p();
      return e.set({
        withText: !0,
        icon: qt,
        label: this._removeButtonLabel
      }), e.class = "ck-color-selector__remove-color", e.on("execute", function () {
        _this98.fire("execute", {
          value: null,
          source: "removeColorButton"
        });
      }), e.render(), e;
    }
  }, {
    key: "_createStaticColorsGrid",
    value: function _createStaticColorsGrid() {
      var _this99 = this;
      var e = new Me(this.locale, {
        colorDefinitions: this.colorDefinitions,
        columns: this.columns
      });
      return e.on("execute", function (t, i) {
        _this99.fire("execute", {
          value: i.value,
          source: "staticColorsGrid"
        });
      }), e;
    }
  }, {
    key: "_createDocumentColorsGrid",
    value: function _createDocumentColorsGrid() {
      var _this100 = this;
      var e = V.bind(this.documentColors, this.documentColors),
        t = new Me(this.locale, {
          columns: this.columns
        });
      return t.extendTemplate({
        attributes: {
          class: e.if("isEmpty", "ck-hidden")
        }
      }), t.items.bindTo(this.documentColors).using(function (i) {
        var _i$options;
        var o = new mt();
        return o.set({
          color: i.color,
          hasBorder: (_i$options = i.options) === null || _i$options === void 0 ? void 0 : _i$options.hasBorder
        }), i.label && o.set({
          label: i.label,
          tooltip: !0
        }), o.on("execute", function () {
          _this100.fire("execute", {
            value: i.color,
            source: "documentColorsGrid"
          });
        }), o;
      }), this.documentColors.on("change:isEmpty", function (i, o, n) {
        n && (t.selectedColor = null);
      }), t;
    }
  }, {
    key: "_addColorToDocumentColors",
    value: function _addColorToDocumentColors(e) {
      var t = this.colorDefinitions.find(function (i) {
        return i.color === e;
      });
      t ? this.documentColors.add(Object.assign({}, t)) : this.documentColors.add({
        color: e,
        label: e,
        options: {
          hasBorder: !1
        }
      });
    }
  }]);
}(h);
var ls = /*#__PURE__*/function (_h31) {
  function ls(e, _ref11) {
    var _this101;
    var t = _ref11.focusTracker,
      i = _ref11.focusables,
      o = _ref11.keystrokes,
      n = _ref11.colorPickerViewConfig;
    _classCallCheck(this, ls);
    _this101 = _callSuper(this, ls, [e]), _defineProperty(_assertThisInitialized(_this101), "items", void 0), _defineProperty(_assertThisInitialized(_this101), "colorPickerView", void 0), _defineProperty(_assertThisInitialized(_this101), "saveButtonView", void 0), _defineProperty(_assertThisInitialized(_this101), "cancelButtonView", void 0), _defineProperty(_assertThisInitialized(_this101), "actionBarView", void 0), _defineProperty(_assertThisInitialized(_this101), "focusTracker", void 0), _defineProperty(_assertThisInitialized(_this101), "keystrokes", void 0), _defineProperty(_assertThisInitialized(_this101), "_focusables", void 0), _defineProperty(_assertThisInitialized(_this101), "_colorPickerViewConfig", void 0), _this101.items = _this101.createCollection(), _this101.focusTracker = t, _this101.keystrokes = o, _this101.set("isVisible", !1), _this101.set("selectedColor", void 0), _this101._focusables = i, _this101._colorPickerViewConfig = n;
    var r = _this101.bindTemplate,
      _this101$_createActio = _this101._createActionButtons(),
      a = _this101$_createActio.saveButtonView,
      l = _this101$_createActio.cancelButtonView;
    _this101.saveButtonView = a, _this101.cancelButtonView = l, _this101.actionBarView = _this101._createActionBarView({
      saveButtonView: a,
      cancelButtonView: l
    }), _this101.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck-color-picker-fragment", r.if("isVisible", "ck-hidden", function (c) {
          return !c;
        })]
      },
      children: _this101.items
    });
    return _this101;
  }
  _inherits(ls, _h31);
  return _createClass(ls, [{
    key: "render",
    value: function render() {
      _superPropGet(ls, "render", this, 3)([]);
      var e = new ts(this.locale, _objectSpread({}, this._colorPickerViewConfig));
      this.colorPickerView = e, this.colorPickerView.render(), this.selectedColor && (e.color = this.selectedColor), this.listenTo(this, "change:selectedColor", function (t, i, o) {
        e.color = o;
      }), this.items.add(this.colorPickerView), this.items.add(this.actionBarView), this._addColorPickersElementsToFocusTracker(), this._stopPropagationOnArrowsKeys(), this._executeOnEnterPress(), this._executeUponColorChange();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(ls, "destroy", this, 3)([]);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.colorPickerView.focus();
    }
  }, {
    key: "resetValidationStatus",
    value: function resetValidationStatus() {
      this.colorPickerView.resetValidationStatus();
    }
  }, {
    key: "_executeOnEnterPress",
    value: function _executeOnEnterPress() {
      var _this102 = this;
      this.keystrokes.set("enter", function (e) {
        _this102.isVisible && _this102.focusTracker.focusedElement !== _this102.cancelButtonView.element && _this102.colorPickerView.isValid() && (_this102.fire("execute", {
          value: _this102.selectedColor
        }), e.stopPropagation(), e.preventDefault());
      });
    }
  }, {
    key: "_stopPropagationOnArrowsKeys",
    value: function _stopPropagationOnArrowsKeys() {
      var e = function e(t) {
        return t.stopPropagation();
      };
      this.keystrokes.set("arrowright", e), this.keystrokes.set("arrowleft", e), this.keystrokes.set("arrowup", e), this.keystrokes.set("arrowdown", e);
    }
  }, {
    key: "_addColorPickersElementsToFocusTracker",
    value: function _addColorPickersElementsToFocusTracker() {
      var _iterator32 = _createForOfIteratorHelper(this.colorPickerView.slidersView),
        _step32;
      try {
        for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
          var t = _step32.value;
          this.focusTracker.add(t.element), this._focusables.add(t);
        }
      } catch (err) {
        _iterator32.e(err);
      } finally {
        _iterator32.f();
      }
      var e = this.colorPickerView.hexInputRow.children.get(1);
      e.element && (this.focusTracker.add(e.element), this._focusables.add(e)), this.focusTracker.add(this.saveButtonView.element), this._focusables.add(this.saveButtonView), this.focusTracker.add(this.cancelButtonView.element), this._focusables.add(this.cancelButtonView);
    }
  }, {
    key: "_createActionBarView",
    value: function _createActionBarView(_ref12) {
      var e = _ref12.saveButtonView,
        t = _ref12.cancelButtonView;
      var i = new h(),
        o = this.createCollection();
      return o.add(e), o.add(t), i.setTemplate({
        tag: "div",
        attributes: {
          class: ["ck", "ck-color-selector_action-bar"]
        },
        children: o
      }), i;
    }
  }, {
    key: "_createActionButtons",
    value: function _createActionButtons() {
      var _this103 = this;
      var e = this.locale,
        t = e.t,
        i = new p(e),
        o = new p(e);
      return i.set({
        icon: st,
        class: "ck-button-save",
        type: "button",
        withText: !1,
        label: t("Accept")
      }), o.set({
        icon: it,
        class: "ck-button-cancel",
        type: "button",
        withText: !1,
        label: t("Cancel")
      }), i.on("execute", function () {
        _this103.colorPickerView.isValid() && _this103.fire("execute", {
          source: "colorPickerSaveButton",
          value: _this103.selectedColor
        });
      }), o.on("execute", function () {
        _this103.fire("colorPicker:cancel");
      }), {
        saveButtonView: i,
        cancelButtonView: o
      };
    }
  }, {
    key: "_executeUponColorChange",
    value: function _executeUponColorChange() {
      var _this104 = this;
      this.colorPickerView.on("colorSelected", function (e, t) {
        _this104.fire("execute", {
          value: t.color,
          source: "colorPicker"
        }), _this104.set("selectedColor", t.color);
      });
    }
  }]);
}(h);
var ho = /*#__PURE__*/function (_h32) {
  function ho(e, _ref13) {
    var _this105;
    var t = _ref13.colors,
      i = _ref13.columns,
      o = _ref13.removeButtonLabel,
      n = _ref13.documentColorsLabel,
      r = _ref13.documentColorsCount,
      a = _ref13.colorPickerLabel,
      l = _ref13.colorPickerViewConfig;
    _classCallCheck(this, ho);
    _this105 = _callSuper(this, ho, [e]), _defineProperty(_assertThisInitialized(_this105), "focusTracker", void 0), _defineProperty(_assertThisInitialized(_this105), "keystrokes", void 0), _defineProperty(_assertThisInitialized(_this105), "items", void 0), _defineProperty(_assertThisInitialized(_this105), "colorGridsFragmentView", void 0), _defineProperty(_assertThisInitialized(_this105), "colorPickerFragmentView", void 0), _defineProperty(_assertThisInitialized(_this105), "_focusCycler", void 0), _defineProperty(_assertThisInitialized(_this105), "_focusables", void 0), _defineProperty(_assertThisInitialized(_this105), "_colorPickerViewConfig", void 0), _this105.items = _this105.createCollection(), _this105.focusTracker = new b(), _this105.keystrokes = new E(), _this105._focusables = new B(), _this105._colorPickerViewConfig = l, _this105._focusCycler = new N({
      focusables: _this105._focusables,
      focusTracker: _this105.focusTracker,
      keystrokeHandler: _this105.keystrokes,
      actions: {
        focusPrevious: "shift + tab",
        focusNext: "tab"
      }
    }), _this105.colorGridsFragmentView = new rs(e, {
      colors: t,
      columns: i,
      removeButtonLabel: o,
      documentColorsLabel: n,
      documentColorsCount: r,
      colorPickerLabel: a,
      focusTracker: _this105.focusTracker,
      focusables: _this105._focusables
    }), _this105.colorPickerFragmentView = new ls(e, {
      focusables: _this105._focusables,
      focusTracker: _this105.focusTracker,
      keystrokes: _this105.keystrokes,
      colorPickerViewConfig: l
    }), _this105.set("_isColorGridsFragmentVisible", !0), _this105.set("_isColorPickerFragmentVisible", !1), _this105.set("selectedColor", void 0), _this105.colorGridsFragmentView.bind("isVisible").to(_assertThisInitialized(_this105), "_isColorGridsFragmentVisible"), _this105.colorPickerFragmentView.bind("isVisible").to(_assertThisInitialized(_this105), "_isColorPickerFragmentVisible"), _this105.on("change:selectedColor", function (c, u, f) {
      _this105.colorGridsFragmentView.set("selectedColor", f), _this105.colorPickerFragmentView.set("selectedColor", f);
    }), _this105.colorGridsFragmentView.on("change:selectedColor", function (c, u, f) {
      _this105.set("selectedColor", f);
    }), _this105.colorPickerFragmentView.on("change:selectedColor", function (c, u, f) {
      _this105.set("selectedColor", f);
    }), _this105.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-color-selector"]
      },
      children: _this105.items
    });
    return _this105;
  }
  _inherits(ho, _h32);
  return _createClass(ho, [{
    key: "render",
    value: function render() {
      _superPropGet(ho, "render", this, 3)([]), this.keystrokes.listenTo(this.element);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(ho, "destroy", this, 3)([]), this.focusTracker.destroy(), this.keystrokes.destroy();
    }
  }, {
    key: "appendUI",
    value: function appendUI() {
      this._appendColorGridsFragment(), this._colorPickerViewConfig && this._appendColorPickerFragment();
    }
  }, {
    key: "showColorPickerFragment",
    value: function showColorPickerFragment() {
      !this.colorPickerFragmentView.colorPickerView || this._isColorPickerFragmentVisible || (this._isColorPickerFragmentVisible = !0, this.colorPickerFragmentView.focus(), this.colorPickerFragmentView.resetValidationStatus(), this._isColorGridsFragmentVisible = !1);
    }
  }, {
    key: "showColorGridsFragment",
    value: function showColorGridsFragment() {
      this._isColorGridsFragmentVisible || (this._isColorGridsFragmentVisible = !0, this.colorGridsFragmentView.focus(), this._isColorPickerFragmentVisible = !1);
    }
  }, {
    key: "focus",
    value: function focus() {
      this._focusCycler.focusFirst();
    }
  }, {
    key: "focusLast",
    value: function focusLast() {
      this._focusCycler.focusLast();
    }
  }, {
    key: "updateDocumentColors",
    value: function updateDocumentColors(e, t) {
      this.colorGridsFragmentView.updateDocumentColors(e, t);
    }
  }, {
    key: "updateSelectedColors",
    value: function updateSelectedColors() {
      this.colorGridsFragmentView.updateSelectedColors();
    }
  }, {
    key: "_appendColorGridsFragment",
    value: function _appendColorGridsFragment() {
      this.items.length || (this.items.add(this.colorGridsFragmentView), this.colorGridsFragmentView.delegate("execute").to(this), this.colorGridsFragmentView.delegate("colorPicker:show").to(this));
    }
  }, {
    key: "_appendColorPickerFragment",
    value: function _appendColorPickerFragment() {
      var _this106 = this;
      this.items.length !== 2 && (this.items.add(this.colorPickerFragmentView), this.colorGridsFragmentView.colorPickerButtonView && this.colorGridsFragmentView.colorPickerButtonView.on("execute", function () {
        _this106.showColorPickerFragment();
      }), this.colorGridsFragmentView.addColorPickerButton(), this.colorPickerFragmentView.delegate("execute").to(this), this.colorPickerFragmentView.delegate("colorPicker:cancel").to(this));
    }
  }]);
}(h);
var as = /*#__PURE__*/function () {
  function as(e) {
    _classCallCheck(this, as);
    _defineProperty(this, "editor", void 0);
    _defineProperty(this, "_components", new Map());
    this.editor = e;
  }
  return _createClass(as, [{
    key: "names",
    value: /*#__PURE__*/_regeneratorRuntime().mark(function names() {
      var _iterator33, _step33, _e17;
      return _regeneratorRuntime().wrap(function names$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _iterator33 = _createForOfIteratorHelper(this._components.values());
            _context3.prev = 1;
            _iterator33.s();
          case 3:
            if ((_step33 = _iterator33.n()).done) {
              _context3.next = 9;
              break;
            }
            _e17 = _step33.value;
            _context3.next = 7;
            return _e17.originalName;
          case 7:
            _context3.next = 3;
            break;
          case 9:
            _context3.next = 14;
            break;
          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](1);
            _iterator33.e(_context3.t0);
          case 14:
            _context3.prev = 14;
            _iterator33.f();
            return _context3.finish(14);
          case 17:
          case "end":
            return _context3.stop();
        }
      }, names, this, [[1, 11, 14, 17]]);
    })
  }, {
    key: "add",
    value: function add(e, t) {
      this._components.set(ce(e), {
        callback: t,
        originalName: e
      });
    }
  }, {
    key: "create",
    value: function create(e) {
      if (!this.has(e)) throw new v("componentfactory-item-missing", this, {
        name: e
      });
      return this._components.get(ce(e)).callback(this.editor.locale);
    }
  }, {
    key: "has",
    value: function has(e) {
      return this._components.has(ce(e));
    }
  }]);
}();
function ce(s) {
  return String(s).toLowerCase();
}
var ze = "ck-tooltip";
var m = /*#__PURE__*/function (_ie2) {
  function m(e) {
    var _this107;
    _classCallCheck(this, m);
    if (_this107 = _callSuper(this, m), _defineProperty(_assertThisInitialized(_this107), "tooltipTextView", void 0), _defineProperty(_assertThisInitialized(_this107), "balloonPanelView", void 0), _defineProperty(_assertThisInitialized(_this107), "_currentElementWithTooltip", null), _defineProperty(_assertThisInitialized(_this107), "_currentTooltipPosition", null), _defineProperty(_assertThisInitialized(_this107), "_mutationObserver", null), _defineProperty(_assertThisInitialized(_this107), "_pinTooltipDebounced", void 0), _defineProperty(_assertThisInitialized(_this107), "_unpinTooltipDebounced", void 0), _defineProperty(_assertThisInitialized(_this107), "_watchdogExcluded", void 0), _assertThisInitialized(_this107), m._editors.add(e), m._instance) return _possibleConstructorReturn(_this107, m._instance);
    m._instance = _assertThisInitialized(_this107), _this107.tooltipTextView = new h(e.locale), _this107.tooltipTextView.set("text", ""), _this107.tooltipTextView.setTemplate({
      tag: "span",
      attributes: {
        class: ["ck", "ck-tooltip__text"]
      },
      children: [{
        text: _this107.tooltipTextView.bindTemplate.to("text")
      }]
    }), _this107.balloonPanelView = new k(e.locale), _this107.balloonPanelView.class = ze, _this107.balloonPanelView.content.add(_this107.tooltipTextView), _this107._mutationObserver = cs(function () {
      _this107._updateTooltipPosition();
    }), _this107._pinTooltipDebounced = fe(_this107._pinTooltip, 600), _this107._unpinTooltipDebounced = fe(_this107._unpinTooltip, 400), _this107.listenTo(d.document, "keydown", _this107._onKeyDown.bind(_assertThisInitialized(_this107)), {
      useCapture: !0
    }), _this107.listenTo(d.document, "mouseenter", _this107._onEnterOrFocus.bind(_assertThisInitialized(_this107)), {
      useCapture: !0
    }), _this107.listenTo(d.document, "mouseleave", _this107._onLeaveOrBlur.bind(_assertThisInitialized(_this107)), {
      useCapture: !0
    }), _this107.listenTo(d.document, "focus", _this107._onEnterOrFocus.bind(_assertThisInitialized(_this107)), {
      useCapture: !0
    }), _this107.listenTo(d.document, "blur", _this107._onLeaveOrBlur.bind(_assertThisInitialized(_this107)), {
      useCapture: !0
    }), _this107.listenTo(d.document, "scroll", _this107._onScroll.bind(_assertThisInitialized(_this107)), {
      useCapture: !0
    }), _this107._watchdogExcluded = !0;
    return _assertThisInitialized(_this107);
  }
  _inherits(m, _ie2);
  return _createClass(m, [{
    key: "destroy",
    value: function destroy(e) {
      var t = e.ui.view && e.ui.view.body;
      m._editors.delete(e), this.stopListening(e.ui), t && t.has(this.balloonPanelView) && t.remove(this.balloonPanelView), m._editors.size || (this._unpinTooltip(), this.balloonPanelView.destroy(), this.stopListening(), m._instance = null);
    }
  }, {
    key: "_onKeyDown",
    value: function _onKeyDown(e, t) {
      t.key === "Escape" && this._currentElementWithTooltip && (this._unpinTooltip(), t.stopPropagation());
    }
  }, {
    key: "_onEnterOrFocus",
    value: function _onEnterOrFocus(e, _ref14) {
      var t = _ref14.target;
      var i = he(t);
      if (!i) {
        e.name === "focus" && this._unpinTooltip();
        return;
      }
      if (i === this._currentElementWithTooltip) {
        this._unpinTooltipDebounced.cancel();
        return;
      }
      this._unpinTooltip(), e.name === "focus" && !i.matches(":hover") || i.matches("[data-cke-tooltip-instant]") ? this._pinTooltip(i, ue(i)) : this._pinTooltipDebounced(i, ue(i));
    }
  }, {
    key: "_onLeaveOrBlur",
    value: function _onLeaveOrBlur(e, _ref15) {
      var t = _ref15.target,
        i = _ref15.relatedTarget;
      if (e.name === "mouseleave") {
        if (!_e(t)) return;
        var o = this.balloonPanelView.element,
          n = o && (o === i || o.contains(i)),
          r = !n && t === o;
        if (n) {
          this._unpinTooltipDebounced.cancel();
          return;
        }
        if (!r && this._currentElementWithTooltip && t !== this._currentElementWithTooltip) return;
        var a = he(t),
          l = he(i);
        (r || a && a !== l) && (this._pinTooltipDebounced.cancel(), this._currentElementWithTooltip && this._currentElementWithTooltip.matches("[data-cke-tooltip-instant]") || a && a.matches("[data-cke-tooltip-instant]") ? this._unpinTooltip() : this._unpinTooltipDebounced());
      } else {
        if (this._currentElementWithTooltip && t !== this._currentElementWithTooltip) return;
        this._pinTooltipDebounced.cancel(), this._unpinTooltipDebounced();
      }
    }
  }, {
    key: "_onScroll",
    value: function _onScroll(e, _ref16) {
      var t = _ref16.target;
      this._currentElementWithTooltip && (t.contains(this.balloonPanelView.element) && t.contains(this._currentElementWithTooltip) || this._unpinTooltip());
    }
  }, {
    key: "_pinTooltip",
    value: function _pinTooltip(e, _ref17) {
      var t = _ref17.text,
        i = _ref17.position,
        o = _ref17.cssClass;
      this._unpinTooltip();
      var n = Dt(m._editors.values()).ui.view.body;
      n.has(this.balloonPanelView) || n.add(this.balloonPanelView), this.tooltipTextView.text = t, this.balloonPanelView.class = [ze, o].filter(function (r) {
        return r;
      }).join(" "), this.balloonPanelView.pin({
        target: e,
        positions: m.getPositioningFunctions(i)
      }), this._mutationObserver.attach(e);
      var _iterator34 = _createForOfIteratorHelper(m._editors),
        _step34;
      try {
        for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
          var r = _step34.value;
          this.listenTo(r.ui, "update", this._updateTooltipPosition.bind(this), {
            priority: "low"
          });
        }
      } catch (err) {
        _iterator34.e(err);
      } finally {
        _iterator34.f();
      }
      this._currentElementWithTooltip = e, this._currentTooltipPosition = i;
    }
  }, {
    key: "_unpinTooltip",
    value: function _unpinTooltip() {
      this._unpinTooltipDebounced.cancel(), this._pinTooltipDebounced.cancel(), this.balloonPanelView.unpin();
      var _iterator35 = _createForOfIteratorHelper(m._editors),
        _step35;
      try {
        for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
          var _e18 = _step35.value;
          this.stopListening(_e18.ui, "update");
        }
      } catch (err) {
        _iterator35.e(err);
      } finally {
        _iterator35.f();
      }
      this._currentElementWithTooltip = null, this._currentTooltipPosition = null, this.tooltipTextView.text = "", this._mutationObserver.detach();
    }
  }, {
    key: "_updateTooltipPosition",
    value: function _updateTooltipPosition() {
      if (!this._currentElementWithTooltip) return;
      var e = ue(this._currentElementWithTooltip);
      if (!O(this._currentElementWithTooltip) || !e.text) {
        this._unpinTooltip();
        return;
      }
      this.balloonPanelView.pin({
        target: this._currentElementWithTooltip,
        positions: m.getPositioningFunctions(e.position)
      });
    }
  }], [{
    key: "getPositioningFunctions",
    value: function getPositioningFunctions(e) {
      var t = m.defaultBalloonPositions;
      return {
        s: [t.southArrowNorth, t.southArrowNorthEast, t.southArrowNorthWest],
        n: [t.northArrowSouth],
        e: [t.eastArrowWest],
        w: [t.westArrowEast],
        sw: [t.southArrowNorthEast],
        se: [t.southArrowNorthWest]
      }[e];
    }
  }]);
}(ie());
_defineProperty(m, "defaultBalloonPositions", k.generatePositions({
  heightOffset: 5,
  sideOffset: 13
}));
_defineProperty(m, "_editors", new Set());
_defineProperty(m, "_instance", null);
function he(s) {
  return _e(s) ? s.closest("[data-cke-tooltip-text]:not([data-cke-tooltip-disabled])") : null;
}
function ue(s) {
  return {
    text: s.dataset.ckeTooltipText,
    position: s.dataset.ckeTooltipPosition || "s",
    cssClass: s.dataset.ckeTooltipClass || ""
  };
}
function cs(s) {
  var e = new MutationObserver(function () {
    s();
  });
  return {
    attach: function attach(t) {
      e.observe(t, {
        attributes: !0,
        attributeFilter: ["data-cke-tooltip-text", "data-cke-tooltip-position"]
      });
    },
    detach: function detach() {
      e.disconnect();
    }
  };
}
var hs = 50,
  us = 350;
var Vt = /*#__PURE__*/function (_ie3) {
  function Vt(e) {
    var _this108;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Vt);
    _this108 = _callSuper(this, Vt), _defineProperty(_assertThisInitialized(_this108), "editor", void 0), _defineProperty(_assertThisInitialized(_this108), "_balloonView", null), _defineProperty(_assertThisInitialized(_this108), "_showBalloonThrottled", ti(function () {
      return _this108._showBalloon();
    }, 50, {
      leading: !0
    })), _defineProperty(_assertThisInitialized(_this108), "_lastFocusedEditableElement", null), _defineProperty(_assertThisInitialized(_this108), "_balloonClass", void 0), _this108.editor = e, _this108._balloonClass = t.balloonClass, e.on("ready", function () {
      return _this108._handleEditorReady();
    });
    return _this108;
  }
  _inherits(Vt, _ie3);
  return _createClass(Vt, [{
    key: "destroy",
    value: function destroy() {
      var e = this._balloonView;
      e && (e.unpin(), this._balloonView = null), this._showBalloonThrottled.cancel(), this.stopListening();
    }
  }, {
    key: "_handleEditorReady",
    value: function _handleEditorReady() {
      var _this109 = this;
      var e = this.editor;
      this._isEnabled() && e.ui.view && (e.ui.focusTracker.on("change:isFocused", function (t, i, o) {
        _this109._updateLastFocusedEditableElement(), o ? _this109._showBalloon() : _this109._hideBalloon();
      }), e.ui.focusTracker.on("change:focusedElement", function (t, i, o) {
        _this109._updateLastFocusedEditableElement(), o && _this109._showBalloon();
      }), e.ui.on("update", function () {
        _this109._showBalloonThrottled();
      }));
    }
  }, {
    key: "_getNormalizedConfig",
    value: function _getNormalizedConfig() {
      return {
        side: this.editor.locale.contentLanguageDirection === "ltr" ? "right" : "left",
        position: "border",
        verticalOffset: 0,
        horizontalOffset: 5
      };
    }
  }, {
    key: "_showBalloon",
    value: function _showBalloon() {
      var e = this._getBalloonAttachOptions();
      e && (this._balloonView || (this._balloonView = this._createBalloonView()), this._balloonView.pin(e));
    }
  }, {
    key: "_hideBalloon",
    value: function _hideBalloon() {
      this._balloonView && this._balloonView.unpin();
    }
  }, {
    key: "_createBalloonView",
    value: function _createBalloonView() {
      var e = this.editor,
        t = new k(),
        i = this._createBadgeContent();
      return t.content.add(i), this._balloonClass && (t.class = this._balloonClass), e.ui.view.body.add(t), t;
    }
  }, {
    key: "_getBalloonAttachOptions",
    value: function _getBalloonAttachOptions() {
      if (!this._lastFocusedEditableElement) return null;
      var e = this._getNormalizedConfig(),
        t = e.side === "right" ? ds(this._lastFocusedEditableElement, e) : fs(this._lastFocusedEditableElement, e);
      return {
        target: this._lastFocusedEditableElement,
        positions: [t]
      };
    }
  }, {
    key: "_updateLastFocusedEditableElement",
    value: function _updateLastFocusedEditableElement() {
      var e = this.editor,
        t = e.ui.focusTracker.isFocused,
        i = e.ui.focusTracker.focusedElement;
      if (!t || !i) {
        this._lastFocusedEditableElement = null;
        return;
      }
      var o = Array.from(e.ui.getEditableElementsNames()).map(function (n) {
        return e.ui.getEditableElement(n);
      });
      o.includes(i) ? this._lastFocusedEditableElement = i : this._lastFocusedEditableElement = o[0];
    }
  }]);
}(ie());
function ds(s, e) {
  return xt(s, e, function (t, i) {
    return t.left + t.width - i.width - e.horizontalOffset;
  });
}
function fs(s, e) {
  return xt(s, e, function (t) {
    return t.left + e.horizontalOffset;
  });
}
function xt(s, e, t) {
  return function (i, o) {
    var n = new T(s);
    if (n.width < us || n.height < hs) return null;
    var r;
    e.position === "inside" ? r = n.bottom - o.height : r = n.bottom - o.height / 2, r -= e.verticalOffset;
    var a = t(n, o),
      c = i.clone().moveTo(a, r).getIntersection(o.clone().moveTo(a, r)).getVisible();
    return !c || c.getArea() < o.getArea() ? null : {
      top: r,
      left: a,
      name: "position_".concat(e.position, "-side_").concat(e.side),
      config: {
        withArrow: !1
      }
    };
  };
}
var ps = "Powered by";
var ms = /*#__PURE__*/function (_Vt2) {
  function ms(e) {
    _classCallCheck(this, ms);
    return _callSuper(this, ms, [e, {
      balloonClass: "ck-powered-by-balloon"
    }]);
  }
  _inherits(ms, _Vt2);
  return _createClass(ms, [{
    key: "_isEnabled",
    value: function _isEnabled() {
      var e = this.editor;
      if (e.config.get("ui.poweredBy.forceVisible")) return !0;
      var i = e.config.get("licenseKey");
      if (i == "GPL") return !0;
      var o = tt(i.split(".")[1]);
      return o ? !o.whiteLabel : !0;
    }
  }, {
    key: "_createBadgeContent",
    value: function _createBadgeContent() {
      return new ws(this.editor.locale, this._getNormalizedConfig().label);
    }
  }, {
    key: "_getNormalizedConfig",
    value: function _getNormalizedConfig() {
      var e = _superPropGet(ms, "_getNormalizedConfig", this, 3)([]),
        t = this.editor.config.get("ui.poweredBy") || {},
        i = t.position || e.position,
        o = i === "inside" ? 5 : e.verticalOffset;
      return {
        position: i,
        side: t.side || e.side,
        label: t.label === void 0 ? ps : t.label,
        verticalOffset: t.verticalOffset !== void 0 ? t.verticalOffset : o,
        horizontalOffset: t.horizontalOffset !== void 0 ? t.horizontalOffset : e.horizontalOffset,
        forceVisible: !!t.forceVisible
      };
    }
  }]);
}(Vt);
var ws = /*#__PURE__*/function (_h33) {
  function ws(e, t) {
    var _this110;
    _classCallCheck(this, ws);
    _this110 = _callSuper(this, ws, [e]);
    var i = new L(),
      o = _this110.bindTemplate;
    i.set({
      content: Yt,
      isColorInherited: !1
    }), _this110.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-powered-by"],
        "aria-hidden": !0
      },
      children: [{
        tag: "a",
        attributes: {
          href: "https://ckeditor.com/powered-by-ckeditor/?utm_source=ckeditor&utm_medium=referral&utm_campaign=701Dn000000hVgmIAE_powered_by_ckeditor_logo",
          target: "_blank",
          tabindex: "-1"
        },
        children: [].concat(_toConsumableArray(t ? [{
          tag: "span",
          attributes: {
            class: ["ck", "ck-powered-by__label"]
          },
          children: [t]
        }] : []), [i]),
        on: {
          dragstart: o.to(function (n) {
            return n.preventDefault();
          })
        }
      }]
    });
    return _this110;
  }
  _inherits(ws, _h33);
  return _createClass(ws);
}(h);
var bs = /*#__PURE__*/function (_Vt3) {
  function bs(e) {
    var _this111;
    _classCallCheck(this, bs);
    _this111 = _callSuper(this, bs, [e, {
      balloonClass: "ck-evaluation-badge-balloon"
    }]);
    _defineProperty(_this111, "licenseTypeMessage", {
      evaluation: "For evaluation purposes only",
      trial: "For evaluation purposes only",
      development: "For development purposes only"
    });
    return _this111;
  }
  _inherits(bs, _Vt3);
  return _createClass(bs, [{
    key: "_isEnabled",
    value: function _isEnabled() {
      var t = this.editor.config.get("licenseKey"),
        i = Ue(t);
      return !!(i && this.licenseTypeMessage[i]);
    }
  }, {
    key: "_createBadgeContent",
    value: function _createBadgeContent() {
      var e = this.editor.config.get("licenseKey"),
        t = Ue(e);
      return new gs(this.editor.locale, this.licenseTypeMessage[t]);
    }
  }, {
    key: "_getNormalizedConfig",
    value: function _getNormalizedConfig() {
      var e = _superPropGet(bs, "_getNormalizedConfig", this, 3)([]),
        t = this.editor.config.get("ui.poweredBy") || {},
        i = t.position || e.position,
        o = t.side || e.side;
      return {
        position: i,
        side: o === "left" ? "right" : "left",
        verticalOffset: e.verticalOffset,
        horizontalOffset: e.horizontalOffset
      };
    }
  }]);
}(Vt);
var gs = /*#__PURE__*/function (_h34) {
  function gs(e, t) {
    var _this112;
    _classCallCheck(this, gs);
    _this112 = _callSuper(this, gs, [e]), _this112.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-evaluation-badge"],
        "aria-hidden": !0
      },
      children: [{
        tag: "span",
        attributes: {
          class: ["ck", "ck-evaluation-badge__label"]
        },
        children: [t]
      }]
    });
    return _this112;
  }
  _inherits(gs, _h34);
  return _createClass(gs);
}(h);
function Ue(s) {
  if (s == "GPL") return "GPL";
  var e = tt(s.split(".")[1]);
  return e ? e.licenseType || "production" : null;
}
var $e = {
  POLITE: "polite",
  ASSERTIVE: "assertive"
};
var _s = /*#__PURE__*/function () {
  function _s(e) {
    var _this113 = this;
    _classCallCheck(this, _s);
    _defineProperty(this, "editor", void 0);
    _defineProperty(this, "view", void 0);
    this.editor = e, e.once("ready", function () {
      for (var _i8 = 0, _Object$values = Object.values($e); _i8 < _Object$values.length; _i8++) {
        var t = _Object$values[_i8];
        _this113.announce("", t);
      }
    });
  }
  return _createClass(_s, [{
    key: "announce",
    value: function announce(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e.POLITE;
      var i = this.editor;
      if (!i.ui.view) return;
      this.view || (this.view = new ks(i.locale), i.ui.view.body.add(this.view));
      var _ref18 = typeof t == "string" ? {
          politeness: t
        } : t,
        o = _ref18.politeness,
        n = _ref18.isUnsafeHTML;
      var r = this.view.regionViews.find(function (a) {
        return a.politeness === o;
      });
      r || (r = new Ts(i, o), this.view.regionViews.add(r)), r.announce({
        announcement: e,
        isUnsafeHTML: n
      });
    }
  }]);
}();
var ks = /*#__PURE__*/function (_h35) {
  function ks(e) {
    var _this114;
    _classCallCheck(this, ks);
    _this114 = _callSuper(this, ks, [e]), _defineProperty(_assertThisInitialized(_this114), "regionViews", void 0), _this114.regionViews = _this114.createCollection(), _this114.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-aria-live-announcer"]
      },
      children: _this114.regionViews
    });
    return _this114;
  }
  _inherits(ks, _h35);
  return _createClass(ks);
}(h);
var Ts = /*#__PURE__*/function (_h36) {
  function Ts(e, t) {
    var _this115;
    _classCallCheck(this, Ts);
    _this115 = _callSuper(this, Ts, [e.locale]), _defineProperty(_assertThisInitialized(_this115), "politeness", void 0), _defineProperty(_assertThisInitialized(_this115), "_domConverter", void 0), _defineProperty(_assertThisInitialized(_this115), "_pruneAnnouncementsInterval", void 0), _this115.setTemplate({
      tag: "div",
      attributes: {
        "aria-live": t,
        "aria-relevant": "additions"
      },
      children: [{
        tag: "ul",
        attributes: {
          class: ["ck", "ck-aria-live-region-list"]
        }
      }]
    }), e.on("destroy", function () {
      _this115._pruneAnnouncementsInterval !== null && (clearInterval(_this115._pruneAnnouncementsInterval), _this115._pruneAnnouncementsInterval = null);
    }), _this115.politeness = t, _this115._domConverter = e.data.htmlProcessor.domConverter, _this115._pruneAnnouncementsInterval = setInterval(function () {
      _this115.element && _this115._listElement.firstChild && _this115._listElement.firstChild.remove();
    }, 5e3);
    return _this115;
  }
  _inherits(Ts, _h36);
  return _createClass(Ts, [{
    key: "announce",
    value: function announce(_ref19) {
      var e = _ref19.announcement,
        t = _ref19.isUnsafeHTML;
      if (!e.trim().length) return;
      var i = document.createElement("li");
      t ? this._domConverter.setContentOf(i, e) : i.innerText = e, this._listElement.appendChild(i);
    }
  }, {
    key: "_listElement",
    get: function get() {
      return this.element.querySelector("ul");
    }
  }]);
}(h);
var Et = /*#__PURE__*/function (_P2) {
  function Et(e, t) {
    var _this116;
    _classCallCheck(this, Et);
    _this116 = _callSuper(this, Et, [e]);
    var i = _this116.bindTemplate;
    _this116.extendTemplate({
      attributes: {
        class: ["ck-menu-bar__menu__item"]
      },
      on: {
        mouseenter: i.to("mouseenter")
      }
    }), _this116.delegate("mouseenter").to(t);
    return _this116;
  }
  _inherits(Et, _P2);
  return _createClass(Et);
}(P);
var U = 5,
  D = {
    toggleMenusAndFocusItemsOnHover: function toggleMenusAndFocusItemsOnHover(s) {
      s.on("menu:mouseenter", function (e) {
        if (!(!s.isFocusBorderEnabled && !s.isOpen)) {
          if (s.isOpen) {
            var _iterator36 = _createForOfIteratorHelper(s.menus),
              _step36;
            try {
              for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
                var t = _step36.value;
                var i = e.path[0],
                  o = i instanceof Et && i.children.first === t;
                t.isOpen = (e.path.includes(t) || o) && t.isEnabled;
              }
            } catch (err) {
              _iterator36.e(err);
            } finally {
              _iterator36.f();
            }
          }
          e.source.focus();
        }
      });
    },
    focusCycleMenusOnArrows: function focusCycleMenusOnArrows(s) {
      var e = s.locale.uiLanguageDirection === "rtl";
      s.on("menu:arrowright", function (i) {
        t(i.source, e ? -1 : 1);
      }), s.on("menu:arrowleft", function (i) {
        t(i.source, e ? 1 : -1);
      });
      function t(i, o) {
        var n = s.children.getIndex(i),
          r = i.isOpen,
          a = s.children.length,
          l = s.children.get((n + a + o) % a);
        i.isOpen = !1, r && (l.isOpen = !0), l.buttonView.focus();
      }
    },
    closeMenusWhenTheBarCloses: function closeMenusWhenTheBarCloses(s) {
      s.on("change:isOpen", function () {
        s.isOpen || s.menus.forEach(function (e) {
          e.isOpen = !1;
        });
      });
    },
    closeMenuWhenAnotherOnTheSameLevelOpens: function closeMenuWhenAnotherOnTheSameLevelOpens(s) {
      s.on("menu:change:isOpen", function (e, t, i) {
        i && s.menus.filter(function (o) {
          return e.source.parentMenuView === o.parentMenuView && e.source !== o && o.isOpen;
        }).forEach(function (o) {
          o.isOpen = !1;
        });
      });
    },
    closeOnClickOutside: function closeOnClickOutside(s) {
      ht({
        emitter: s,
        activator: function activator() {
          return s.isOpen;
        },
        callback: function callback() {
          return s.close();
        },
        contextElements: function contextElements() {
          return s.children.map(function (e) {
            return e.element;
          });
        }
      });
    },
    enableFocusHighlightOnInteraction: function enableFocusHighlightOnInteraction(s) {
      var e = !1;
      s.on("change:isOpen", function (t, i, o) {
        o || (e || (s.isFocusBorderEnabled = !1), e = !1);
      }), s.listenTo(s.element, "keydown", function () {
        e = !0;
      }, {
        useCapture: !0
      }), s.listenTo(s.element, "keyup", function () {
        e = !1;
      }, {
        useCapture: !0
      }), s.listenTo(s.element, "focus", function () {
        e && (s.isFocusBorderEnabled = !0);
      }, {
        useCapture: !0
      });
    }
  },
  I = {
    openAndFocusPanelOnArrowDownKey: function openAndFocusPanelOnArrowDownKey(s) {
      s.keystrokes.set("arrowdown", function (e, t) {
        s.isEnabled && s.focusTracker.focusedElement === s.buttonView.element && (s.isOpen || (s.isOpen = !0), s.panelView.focus(), t());
      });
    },
    openOnArrowRightKey: function openOnArrowRightKey(s) {
      var e = s.locale.uiLanguageDirection === "rtl" ? "arrowleft" : "arrowright";
      s.keystrokes.set(e, function (t, i) {
        s.focusTracker.focusedElement !== s.buttonView.element || !s.isEnabled || (s.isOpen || (s.isOpen = !0), s.panelView.focus(), i());
      });
    },
    openOnButtonClick: function openOnButtonClick(s) {
      s.buttonView.on("execute", function () {
        s.isOpen = !0;
      });
    },
    toggleOnButtonClick: function toggleOnButtonClick(s) {
      s.buttonView.on("execute", function () {
        s.isOpen = !s.isOpen;
      });
    },
    openAndFocusOnEnterKeyPress: function openAndFocusOnEnterKeyPress(s) {
      s.keystrokes.set("enter", function (e, t) {
        s.focusTracker.focusedElement === s.buttonView.element && (s.isOpen = !0, s.panelView.focus(), t());
      });
    },
    closeOnArrowLeftKey: function closeOnArrowLeftKey(s) {
      var e = s.locale.uiLanguageDirection === "rtl" ? "arrowright" : "arrowleft";
      s.keystrokes.set(e, function (t, i) {
        s.isOpen && (s.isOpen = !1, s.focus(), i());
      });
    },
    closeOnEscKey: function closeOnEscKey(s) {
      s.keystrokes.set("esc", function (e, t) {
        s.isOpen && (s.isOpen = !1, s.focus(), t());
      });
    },
    closeOnParentClose: function closeOnParentClose(s) {
      s.parentMenuView.on("change:isOpen", function (e, t, i) {
        !i && e.source === s.parentMenuView && (s.isOpen = !1);
      });
    }
  },
  vs = {
    southEast: function southEast(s) {
      return {
        top: s.bottom,
        left: s.left,
        name: "se"
      };
    },
    southWest: function southWest(s, e) {
      return {
        top: s.bottom,
        left: s.left - e.width + s.width,
        name: "sw"
      };
    },
    northEast: function northEast(s, e) {
      return {
        top: s.top - e.height,
        left: s.left,
        name: "ne"
      };
    },
    northWest: function northWest(s, e) {
      return {
        top: s.top - e.height,
        left: s.left - e.width + s.width,
        name: "nw"
      };
    },
    eastSouth: function eastSouth(s) {
      return {
        top: s.top,
        left: s.right - U,
        name: "es"
      };
    },
    eastNorth: function eastNorth(s, e) {
      return {
        top: s.top - e.height,
        left: s.right - U,
        name: "en"
      };
    },
    westSouth: function westSouth(s, e) {
      return {
        top: s.top,
        left: s.left - e.width + U,
        name: "ws"
      };
    },
    westNorth: function westNorth(s, e) {
      return {
        top: s.top - e.height,
        left: s.left - e.width + U,
        name: "wn"
      };
    }
  },
  ys = [{
    menuId: "file",
    label: "File",
    groups: [{
      groupId: "export",
      items: ["menuBar:exportPdf", "menuBar:exportWord"]
    }, {
      groupId: "import",
      items: ["menuBar:importWord"]
    }, {
      groupId: "revisionHistory",
      items: ["menuBar:revisionHistory"]
    }]
  }, {
    menuId: "edit",
    label: "Edit",
    groups: [{
      groupId: "undo",
      items: ["menuBar:undo", "menuBar:redo"]
    }, {
      groupId: "selectAll",
      items: ["menuBar:selectAll"]
    }, {
      groupId: "findAndReplace",
      items: ["menuBar:findAndReplace"]
    }]
  }, {
    menuId: "view",
    label: "View",
    groups: [{
      groupId: "sourceEditingEnhanced",
      items: ["menuBar:sourceEditingEnhanced"]
    }, {
      groupId: "sourceEditing",
      items: ["menuBar:sourceEditing"]
    }, {
      groupId: "showBlocks",
      items: ["menuBar:showBlocks"]
    }, {
      groupId: "previewMergeFields",
      items: ["menuBar:previewMergeFields"]
    }, {
      groupId: "fullscreen",
      items: ["menuBar:fullscreen"]
    }, {
      groupId: "restrictedEditing",
      items: ["menuBar:restrictedEditing"]
    }]
  }, {
    menuId: "insert",
    label: "Insert",
    groups: [{
      groupId: "insertMainWidgets",
      items: ["menuBar:insertImage", "menuBar:ckbox", "menuBar:ckfinder", "menuBar:insertTable", "menuBar:insertTableLayout"]
    }, {
      groupId: "insertInline",
      items: ["menuBar:link", "menuBar:bookmark", "menuBar:comment", "menuBar:insertMergeField", "menuBar:emoji"]
    }, {
      groupId: "insertMinorWidgets",
      items: ["menuBar:mediaEmbed", "menuBar:insertTemplate", "menuBar:specialCharacters", "menuBar:blockQuote", "menuBar:codeBlock", "menuBar:htmlEmbed"]
    }, {
      groupId: "insertStructureWidgets",
      items: ["menuBar:horizontalLine", "menuBar:pageBreak", "menuBar:tableOfContents"]
    }, {
      groupId: "restrictedEditingException",
      items: ["menuBar:restrictedEditingException"]
    }]
  }, {
    menuId: "format",
    label: "Format",
    groups: [{
      groupId: "textAndFont",
      items: [{
        menuId: "text",
        label: "Text",
        groups: [{
          groupId: "basicStyles",
          items: ["menuBar:bold", "menuBar:italic", "menuBar:underline", "menuBar:strikethrough", "menuBar:superscript", "menuBar:subscript", "menuBar:code"]
        }, {
          groupId: "textPartLanguage",
          items: ["menuBar:textPartLanguage"]
        }]
      }, {
        menuId: "font",
        label: "Font",
        groups: [{
          groupId: "fontProperties",
          items: ["menuBar:fontSize", "menuBar:fontFamily"]
        }, {
          groupId: "fontColors",
          items: ["menuBar:fontColor", "menuBar:fontBackgroundColor"]
        }, {
          groupId: "highlight",
          items: ["menuBar:highlight"]
        }]
      }, "menuBar:heading"]
    }, {
      groupId: "list",
      items: ["menuBar:bulletedList", "menuBar:numberedList", "menuBar:multiLevelList", "menuBar:todoList"]
    }, {
      groupId: "indent",
      items: ["menuBar:alignment", "menuBar:indent", "menuBar:outdent"]
    }, {
      groupId: "caseChange",
      items: ["menuBar:caseChange"]
    }, {
      groupId: "removeFormat",
      items: ["menuBar:removeFormat"]
    }]
  }, {
    menuId: "tools",
    label: "Tools",
    groups: [{
      groupId: "aiTools",
      items: ["menuBar:aiAssistant", "menuBar:aiCommands"]
    }, {
      groupId: "tools",
      items: ["menuBar:trackChanges", "menuBar:commentsArchive"]
    }]
  }, {
    menuId: "help",
    label: "Help",
    groups: [{
      groupId: "help",
      items: ["menuBar:accessibilityHelp"]
    }]
  }];
function Cs(s) {
  var e;
  return !("items" in s) || !s.items ? e = _objectSpread({
    items: ge(ys),
    addItems: [],
    removeItems: [],
    isVisible: !0,
    isUsingDefaultConfig: !0
  }, s) : e = _objectSpread({
    items: s.items,
    removeItems: [],
    addItems: [],
    isVisible: !0,
    isUsingDefaultConfig: !1
  }, s), e;
}
function Vs(_ref20) {
  var s = _ref20.normalizedConfig,
    e = _ref20.locale,
    t = _ref20.componentFactory,
    i = _ref20.extraItems;
  var o = ge(s);
  return Ke(s, o, i), xs(s, o), Ke(s, o, o.addItems), Es(s, o, t), It(s, o), Is(o, e), o;
}
function xs(s, e) {
  var t = e.removeItems,
    i = [];
  e.items = e.items.filter(function (_ref21) {
    var o = _ref21.menuId;
    return t.includes(o) ? (i.push(o), !1) : !0;
  }), G(e.items, function (o) {
    o.groups = o.groups.filter(function (_ref22) {
      var n = _ref22.groupId;
      return t.includes(n) ? (i.push(n), !1) : !0;
    });
    var _iterator37 = _createForOfIteratorHelper(o.groups),
      _step37;
    try {
      for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
        var n = _step37.value;
        n.items = n.items.filter(function (r) {
          var a = Ot(r);
          return t.includes(a) ? (i.push(a), !1) : !0;
        });
      }
    } catch (err) {
      _iterator37.e(err);
    } finally {
      _iterator37.f();
    }
  });
  var _iterator38 = _createForOfIteratorHelper(t),
    _step38;
  try {
    for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
      var o = _step38.value;
      i.includes(o) || C("menu-bar-item-could-not-be-removed", {
        menuBarConfig: s,
        itemName: o
      });
    }
  } catch (err) {
    _iterator38.e(err);
  } finally {
    _iterator38.f();
  }
}
function Ke(s, e, t) {
  var i = [];
  if (t.length != 0) {
    var _iterator39 = _createForOfIteratorHelper(t),
      _step39;
    try {
      var _loop4 = function _loop4() {
        var o = _step39.value;
        var n = Bs(o.position),
          r = Ls(o.position);
        if (Os(o)) {
          if (!r) n === "start" ? (e.items.unshift(o.menu), i.push(o)) : n === "end" && (e.items.push(o.menu), i.push(o));else {
            var a = e.items.findIndex(function (l) {
              return l.menuId === r;
            });
            a != -1 ? n === "before" ? (e.items.splice(a, 0, o.menu), i.push(o)) : n === "after" && (e.items.splice(a + 1, 0, o.menu), i.push(o)) : je(e, o.menu, r, n) && i.push(o);
          }
        } else Ps(o) ? G(e.items, function (a) {
          if (a.menuId === r) n === "start" ? (a.groups.unshift(o.group), i.push(o)) : n === "end" && (a.groups.push(o.group), i.push(o));else {
            var l = a.groups.findIndex(function (c) {
              return c.groupId === r;
            });
            l !== -1 && (n === "before" ? (a.groups.splice(l, 0, o.group), i.push(o)) : n === "after" && (a.groups.splice(l + 1, 0, o.group), i.push(o)));
          }
        }) : je(e, o.item, r, n) && i.push(o);
      };
      for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
        _loop4();
      }
    } catch (err) {
      _iterator39.e(err);
    } finally {
      _iterator39.f();
    }
    var _iterator40 = _createForOfIteratorHelper(t),
      _step40;
    try {
      for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
        var o = _step40.value;
        i.includes(o) || C("menu-bar-item-could-not-be-added", {
          menuBarConfig: s,
          addedItemConfig: o
        });
      }
    } catch (err) {
      _iterator40.e(err);
    } finally {
      _iterator40.f();
    }
  }
}
function je(s, e, t, i) {
  var o = !1;
  return G(s.items, function (n) {
    var _iterator41 = _createForOfIteratorHelper(n.groups),
      _step41;
    try {
      for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
        var _ref23 = _step41.value;
        var r = _ref23.groupId;
        var a = _ref23.items;
        if (o) return;
        if (r === t) i === "start" ? (a.unshift(e), o = !0) : i === "end" && (a.push(e), o = !0);else {
          var l = a.findIndex(function (c) {
            return Ot(c) === t;
          });
          l !== -1 && (i === "before" ? (a.splice(l, 0, e), o = !0) : i === "after" && (a.splice(l + 1, 0, e), o = !0));
        }
      }
    } catch (err) {
      _iterator41.e(err);
    } finally {
      _iterator41.f();
    }
  }), o;
}
function Es(s, e, t) {
  G(e.items, function (i) {
    var _iterator42 = _createForOfIteratorHelper(i.groups),
      _step42;
    try {
      for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
        var o = _step42.value;
        o.items = o.items.filter(function (n) {
          var r = typeof n == "string" && !t.has(n);
          return r && !e.isUsingDefaultConfig && C("menu-bar-item-unavailable", {
            menuBarConfig: s,
            parentMenuConfig: ge(i),
            componentName: n
          }), !r;
        });
      }
    } catch (err) {
      _iterator42.e(err);
    } finally {
      _iterator42.f();
    }
  });
}
function It(s, e) {
  var t = e.isUsingDefaultConfig;
  var i = !1;
  if (e.items = e.items.filter(function (o) {
    return o.groups.length ? !0 : (de(s, o, t), !1);
  }), !e.items.length) {
    de(s, s, t);
    return;
  }
  G(e.items, function (o) {
    o.groups = o.groups.filter(function (n) {
      return n.items.length ? !0 : (i = !0, !1);
    });
    var _iterator43 = _createForOfIteratorHelper(o.groups),
      _step43;
    try {
      for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
        var n = _step43.value;
        n.items = n.items.filter(function (r) {
          return Pt(r) && !r.groups.length ? (de(s, r, t), i = !0, !1) : !0;
        });
      }
    } catch (err) {
      _iterator43.e(err);
    } finally {
      _iterator43.f();
    }
  }), i && It(s, e);
}
function de(s, e, t) {
  t || C("menu-bar-menu-empty", {
    menuBarConfig: s,
    emptyMenuConfig: e
  });
}
function Is(s, e) {
  var t = e.t,
    i = {
      File: t({
        string: "File",
        id: "MENU_BAR_MENU_FILE"
      }),
      Edit: t({
        string: "Edit",
        id: "MENU_BAR_MENU_EDIT"
      }),
      View: t({
        string: "View",
        id: "MENU_BAR_MENU_VIEW"
      }),
      Insert: t({
        string: "Insert",
        id: "MENU_BAR_MENU_INSERT"
      }),
      Format: t({
        string: "Format",
        id: "MENU_BAR_MENU_FORMAT"
      }),
      Tools: t({
        string: "Tools",
        id: "MENU_BAR_MENU_TOOLS"
      }),
      Help: t({
        string: "Help",
        id: "MENU_BAR_MENU_HELP"
      }),
      Text: t({
        string: "Text",
        id: "MENU_BAR_MENU_TEXT"
      }),
      Font: t({
        string: "Font",
        id: "MENU_BAR_MENU_FONT"
      })
    };
  G(s.items, function (o) {
    o.label in i && (o.label = i[o.label]);
  });
}
function G(s, e) {
  if (Array.isArray(s)) {
    var _iterator44 = _createForOfIteratorHelper(s),
      _step44;
    try {
      for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
        var i = _step44.value;
        t(i);
      }
    } catch (err) {
      _iterator44.e(err);
    } finally {
      _iterator44.f();
    }
  }
  function t(i) {
    e(i);
    var _iterator45 = _createForOfIteratorHelper(i.groups),
      _step45;
    try {
      for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
        var o = _step45.value;
        var _iterator46 = _createForOfIteratorHelper(o.items),
          _step46;
        try {
          for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
            var n = _step46.value;
            Pt(n) && t(n);
          }
        } catch (err) {
          _iterator46.e(err);
        } finally {
          _iterator46.f();
        }
      }
    } catch (err) {
      _iterator45.e(err);
    } finally {
      _iterator45.f();
    }
  }
}
function Os(s) {
  return _typeof(s) == "object" && "menu" in s;
}
function Ps(s) {
  return _typeof(s) == "object" && "group" in s;
}
function Bs(s) {
  return s.startsWith("start") ? "start" : s.startsWith("end") ? "end" : s.startsWith("after") ? "after" : "before";
}
function Ls(s) {
  var e = s.match(/^[^:]+:(.+)/);
  return e ? e[1] : null;
}
function Ot(s) {
  return typeof s == "string" ? s : s.menuId;
}
function Pt(s) {
  return _typeof(s) == "object" && "menuId" in s;
}
var uo = /*#__PURE__*/function (_se2) {
  function uo(e) {
    var _this117;
    _classCallCheck(this, uo);
    _this117 = _callSuper(this, uo);
    _defineProperty(_this117, "editor", void 0);
    _defineProperty(_this117, "componentFactory", void 0);
    _defineProperty(_this117, "focusTracker", void 0);
    _defineProperty(_this117, "tooltipManager", void 0);
    _defineProperty(_this117, "poweredBy", void 0);
    _defineProperty(_this117, "evaluationBadge", void 0);
    _defineProperty(_this117, "ariaLiveAnnouncer", void 0);
    _defineProperty(_this117, "isReady", !1);
    _defineProperty(_this117, "_editableElementsMap", new Map());
    _defineProperty(_this117, "_focusableToolbarDefinitions", []);
    _defineProperty(_this117, "_extraMenuBarElements", []);
    _defineProperty(_this117, "_lastFocusedForeignElement", null);
    _defineProperty(_this117, "_domEmitter", void 0);
    var t = e.editing.view;
    _this117.editor = e, _this117.componentFactory = new as(e), _this117.focusTracker = new b(), _this117.tooltipManager = new m(e), _this117.poweredBy = new ms(e), _this117.evaluationBadge = new bs(e), _this117.ariaLiveAnnouncer = new _s(e), _this117._initViewportOffset(_this117._readViewportOffsetFromConfig()), _this117.once("ready", function () {
      _this117._bindBodyCollectionWithFocusTracker(), _this117.isReady = !0;
    }), _this117.listenTo(t.document, "layoutChanged", _this117.update.bind(_this117)), _this117.listenTo(t, "scrollToTheSelection", _this117._handleScrollToTheSelection.bind(_this117)), _this117._initFocusTracking(), _this117._initVisualViewportSupport();
    return _this117;
  }
  _inherits(uo, _se2);
  return _createClass(uo, [{
    key: "element",
    get: function get() {
      return null;
    }
  }, {
    key: "update",
    value: function update() {
      this.fire("update");
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.stopListening(), this.focusTracker.destroy(), this.tooltipManager.destroy(this.editor), this.poweredBy.destroy(), this.evaluationBadge.destroy();
      var _iterator47 = _createForOfIteratorHelper(this._editableElementsMap.values()),
        _step47;
      try {
        for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
          var _e19 = _step47.value;
          _e19.ckeditorInstance = null, this.editor.keystrokes.stopListening(_e19);
        }
      } catch (err) {
        _iterator47.e(err);
      } finally {
        _iterator47.f();
      }
      this._editableElementsMap = new Map(), this._focusableToolbarDefinitions = [], this._domEmitter && this._domEmitter.stopListening();
    }
  }, {
    key: "setEditableElement",
    value: function setEditableElement(e, t) {
      var _this118 = this;
      this._editableElementsMap.set(e, t), t.ckeditorInstance || (t.ckeditorInstance = this.editor), this.focusTracker.add(t);
      var i = function i() {
        _this118.editor.editing.view.getDomRoot(e) || _this118.editor.keystrokes.listenTo(t);
      };
      this.isReady ? i() : this.once("ready", i);
    }
  }, {
    key: "removeEditableElement",
    value: function removeEditableElement(e) {
      var t = this._editableElementsMap.get(e);
      t && (this._editableElementsMap.delete(e), this.editor.keystrokes.stopListening(t), this.focusTracker.remove(t), t.ckeditorInstance = null);
    }
  }, {
    key: "getEditableElement",
    value: function getEditableElement() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
      return this._editableElementsMap.get(e);
    }
  }, {
    key: "getEditableElementsNames",
    value: function getEditableElementsNames() {
      return this._editableElementsMap.keys();
    }
  }, {
    key: "addToolbar",
    value: function addToolbar(e) {
      var _this119 = this;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      e.isRendered ? (this.focusTracker.add(e), this.editor.keystrokes.listenTo(e.element)) : e.once("render", function () {
        _this119.focusTracker.add(e), _this119.editor.keystrokes.listenTo(e.element);
      }), this._focusableToolbarDefinitions.push({
        toolbarView: e,
        options: t
      });
    }
  }, {
    key: "extendMenuBar",
    value: function extendMenuBar(e) {
      this._extraMenuBarElements.push(e);
    }
  }, {
    key: "_editableElements",
    get: function get() {
      return console.warn("editor-ui-deprecated-editable-elements: The EditorUI#_editableElements property has been deprecated and will be removed in the near future.", {
        editorUI: this
      }), this._editableElementsMap;
    }
  }, {
    key: "initMenuBar",
    value: function initMenuBar(e) {
      var _this120 = this;
      var t = e.element;
      this.focusTracker.add(t), this.editor.keystrokes.listenTo(t);
      var i = Cs(this.editor.config.get("menuBar") || {});
      e.fillFromConfig(i, this.componentFactory, this._extraMenuBarElements), this.editor.keystrokes.set("Esc", function (o, n) {
        t.contains(_this120.editor.ui.focusTracker.focusedElement) && (_this120._lastFocusedForeignElement ? (_this120._lastFocusedForeignElement.focus(), _this120._lastFocusedForeignElement = null) : _this120.editor.editing.view.focus(), n());
      }), this.editor.keystrokes.set("Alt+F9", function (o, n) {
        t.contains(_this120.editor.ui.focusTracker.focusedElement) || (_this120._saveLastFocusedForeignElement(), e.isFocusBorderEnabled = !0, e.focus(), n());
      });
    }
  }, {
    key: "_readViewportOffsetFromConfig",
    value: function _readViewportOffsetFromConfig() {
      var e = this.editor,
        t = e.config.get("ui.viewportOffset");
      if (t) return t;
      var i = e.config.get("toolbar.viewportTopOffset");
      return i ? (console.warn("editor-ui-deprecated-viewport-offset-config: The `toolbar.vieportTopOffset` configuration option is deprecated. It will be removed from future CKEditor versions. Use `ui.viewportOffset.top` instead."), {
        top: i
      }) : {
        top: 0
      };
    }
  }, {
    key: "_initFocusTracking",
    value: function _initFocusTracking() {
      var _this121 = this;
      var e = this.editor;
      var t;
      e.keystrokes.set("Alt+F10", function (i, o) {
        _this121._saveLastFocusedForeignElement();
        var n = _this121._getCurrentFocusedToolbarDefinition();
        (!n || !t) && (t = _this121._getFocusableCandidateToolbarDefinitions());
        for (var r = 0; r < t.length; r++) {
          var a = t.shift();
          if (t.push(a), a !== n && _this121._focusFocusableCandidateToolbar(a)) {
            n && n.options.afterBlur && n.options.afterBlur();
            break;
          }
        }
        o();
      }), e.keystrokes.set("Esc", function (i, o) {
        var n = _this121._getCurrentFocusedToolbarDefinition();
        n && (_this121._lastFocusedForeignElement ? (_this121._lastFocusedForeignElement.focus(), _this121._lastFocusedForeignElement = null) : e.editing.view.focus(), n.options.afterBlur && n.options.afterBlur(), o());
      });
    }
  }, {
    key: "_saveLastFocusedForeignElement",
    value: function _saveLastFocusedForeignElement() {
      var e = this.focusTracker.focusedElement;
      Array.from(this._editableElementsMap.values()).includes(e) && !Array.from(this.editor.editing.view.domRoots.values()).includes(e) && (this._lastFocusedForeignElement = e);
    }
  }, {
    key: "_getFocusableCandidateToolbarDefinitions",
    value: function _getFocusableCandidateToolbarDefinitions() {
      var e = [];
      var _iterator48 = _createForOfIteratorHelper(this._focusableToolbarDefinitions),
        _step48;
      try {
        for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
          var t = _step48.value;
          var i = t.toolbarView,
            o = t.options;
          (O(i.element) || o.beforeFocus) && e.push(t);
        }
      } catch (err) {
        _iterator48.e(err);
      } finally {
        _iterator48.f();
      }
      return e.sort(function (t, i) {
        return Xe(t) - Xe(i);
      }), e;
    }
  }, {
    key: "_getCurrentFocusedToolbarDefinition",
    value: function _getCurrentFocusedToolbarDefinition() {
      var _iterator49 = _createForOfIteratorHelper(this._focusableToolbarDefinitions),
        _step49;
      try {
        for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
          var _e20 = _step49.value;
          if (_e20.toolbarView.element && _e20.toolbarView.element.contains(this.focusTracker.focusedElement)) return _e20;
        }
      } catch (err) {
        _iterator49.e(err);
      } finally {
        _iterator49.f();
      }
      return null;
    }
  }, {
    key: "_focusFocusableCandidateToolbar",
    value: function _focusFocusableCandidateToolbar(e) {
      var t = e.toolbarView,
        i = e.options.beforeFocus;
      return i && i(), O(t.element) ? (t.focus(), !0) : !1;
    }
  }, {
    key: "_handleScrollToTheSelection",
    value: function _handleScrollToTheSelection(e, t) {
      var i = _objectSpread({
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
      }, this.viewportOffset);
      t.viewportOffset.top += i.top, t.viewportOffset.bottom += i.bottom, t.viewportOffset.left += i.left, t.viewportOffset.right += i.right;
    }
  }, {
    key: "_bindBodyCollectionWithFocusTracker",
    value: function _bindBodyCollectionWithFocusTracker() {
      var _this122 = this;
      var e = this.view.body;
      var _iterator50 = _createForOfIteratorHelper(e),
        _step50;
      try {
        for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
          var t = _step50.value;
          this.focusTracker.add(t.element);
        }
      } catch (err) {
        _iterator50.e(err);
      } finally {
        _iterator50.f();
      }
      e.on("add", function (t, i) {
        _this122.focusTracker.add(i.element);
      }), e.on("remove", function (t, i) {
        _this122.focusTracker.remove(i.element);
      });
    }
  }, {
    key: "_initViewportOffset",
    value: function _initViewportOffset(e) {
      var _this123 = this;
      this.on("set:viewportOffset", function (t, i, o) {
        var n = _this123._getVisualViewportTopOffset(o);
        o.visualTop !== n && (t.return = _objectSpread(_objectSpread({}, o), {}, {
          visualTop: n
        }));
      }), this.set("viewportOffset", e);
    }
  }, {
    key: "_initVisualViewportSupport",
    value: function _initVisualViewportSupport() {
      var _this124 = this;
      if (!d.window.visualViewport) return;
      var e = function e() {
        var t = _this124._getVisualViewportTopOffset(_this124.viewportOffset);
        _this124.viewportOffset.visualTop !== t && (_this124.viewportOffset = _objectSpread(_objectSpread({}, _this124.viewportOffset), {}, {
          visualTop: t
        }));
      };
      this._domEmitter = new (ie())(), this._domEmitter.listenTo(d.window.visualViewport, "scroll", e), this._domEmitter.listenTo(d.window.visualViewport, "resize", e);
    }
  }, {
    key: "_getVisualViewportTopOffset",
    value: function _getVisualViewportTopOffset(e) {
      var t = K().top,
        i = e.top || 0;
      return t > i ? 0 : i - t;
    }
  }]);
}(se());
function Xe(s) {
  var e = s.toolbarView,
    t = s.options;
  var i = 10;
  return O(e.element) && i--, t.isContextual && (i -= 2), i;
}
var Fs = /*#__PURE__*/function (_h37) {
  function Fs(e) {
    var _this125;
    _classCallCheck(this, Fs);
    _this125 = _callSuper(this, Fs, [e]), _defineProperty(_assertThisInitialized(_this125), "body", void 0), _defineProperty(_assertThisInitialized(_this125), "menuBarView", void 0), _defineProperty(_assertThisInitialized(_this125), "toolbar", void 0), _this125.body = new _(e);
    return _this125;
  }
  _inherits(Fs, _h37);
  return _createClass(Fs, [{
    key: "render",
    value: function render() {
      _superPropGet(Fs, "render", this, 3)([]), this.body.attachToDom();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      return this.body.detachFromDom(), _superPropGet(Fs, "destroy", this, 3)([]);
    }
  }]);
}(h);
var fo = /*#__PURE__*/function (_Fs2) {
  function fo(e) {
    var _this126;
    _classCallCheck(this, fo);
    _this126 = _callSuper(this, fo, [e]), _defineProperty(_assertThisInitialized(_this126), "top", void 0), _defineProperty(_assertThisInitialized(_this126), "main", void 0), _defineProperty(_assertThisInitialized(_this126), "_voiceLabelView", void 0), _this126.top = _this126.createCollection(), _this126.main = _this126.createCollection(), _this126._voiceLabelView = _this126._createVoiceLabel(), _this126.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-reset", "ck-editor", "ck-rounded-corners"],
        role: "application",
        dir: e.uiLanguageDirection,
        lang: e.uiLanguage,
        "aria-labelledby": _this126._voiceLabelView.id
      },
      children: [_this126._voiceLabelView, {
        tag: "div",
        attributes: {
          class: ["ck", "ck-editor__top", "ck-reset_all"],
          role: "presentation"
        },
        children: _this126.top
      }, {
        tag: "div",
        attributes: {
          class: ["ck", "ck-editor__main"],
          role: "presentation"
        },
        children: _this126.main
      }]
    });
    return _this126;
  }
  _inherits(fo, _Fs2);
  return _createClass(fo, [{
    key: "_createVoiceLabel",
    value: function _createVoiceLabel() {
      var e = this.t,
        t = new re();
      return t.text = e("Rich Text Editor"), t.extendTemplate({
        attributes: {
          class: "ck-voice-label"
        }
      }), t;
    }
  }]);
}(Fs);
var As = /*#__PURE__*/function (_h38) {
  function As(e, t, i) {
    var _this127;
    _classCallCheck(this, As);
    _this127 = _callSuper(this, As, [e]), _defineProperty(_assertThisInitialized(_this127), "name", null), _defineProperty(_assertThisInitialized(_this127), "_editingView", void 0), _defineProperty(_assertThisInitialized(_this127), "_editableElement", void 0), _defineProperty(_assertThisInitialized(_this127), "_hasExternalElement", void 0), _this127.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-content", "ck-editor__editable", "ck-rounded-corners"],
        lang: e.contentLanguage,
        dir: e.contentLanguageDirection
      }
    }), _this127.set("isFocused", !1), _this127._editableElement = i, _this127._hasExternalElement = !!_this127._editableElement, _this127._editingView = t;
    return _this127;
  }
  _inherits(As, _h38);
  return _createClass(As, [{
    key: "render",
    value: function render() {
      var _this128 = this;
      _superPropGet(As, "render", this, 3)([]), this._hasExternalElement ? this.template.apply(this.element = this._editableElement) : this._editableElement = this.element, this.on("change:isFocused", function () {
        return _this128._updateIsFocusedClasses();
      }), this._updateIsFocusedClasses();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._hasExternalElement && this.template.revert(this._editableElement), _superPropGet(As, "destroy", this, 3)([]);
    }
  }, {
    key: "hasExternalElement",
    get: function get() {
      return this._hasExternalElement;
    }
  }, {
    key: "_updateIsFocusedClasses",
    value: function _updateIsFocusedClasses() {
      var e = this._editingView;
      e.isRenderingInProgress ? i(this) : t(this);
      function t(o) {
        e.change(function (n) {
          var r = e.document.getRoot(o.name);
          n.addClass(o.isFocused ? "ck-focused" : "ck-blurred", r), n.removeClass(o.isFocused ? "ck-blurred" : "ck-focused", r);
        });
      }
      function i(o) {
        e.once("change:isRenderingInProgress", function (n, r, a) {
          a ? i(o) : t(o);
        });
      }
    }
  }]);
}(h);
var po = /*#__PURE__*/function (_As2) {
  function po(e, t, i) {
    var _this129;
    var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    _classCallCheck(this, po);
    _this129 = _callSuper(this, po, [e, t, i]), _defineProperty(_assertThisInitialized(_this129), "_options", void 0), _this129._options = o, _this129.extendTemplate({
      attributes: {
        role: "textbox",
        class: "ck-editor__editable_inline"
      }
    });
    return _this129;
  }
  _inherits(po, _As2);
  return _createClass(po, [{
    key: "render",
    value: function render() {
      var _this130 = this;
      _superPropGet(po, "render", this, 3)([]);
      var e = this._editingView;
      e.change(function (t) {
        var i = e.document.getRoot(_this130.name);
        t.setAttribute("aria-label", _this130.getEditableAriaLabel(), i);
      });
    }
  }, {
    key: "getEditableAriaLabel",
    value: function getEditableAriaLabel() {
      var e = this.locale.t,
        t = this._options.label,
        i = this._editableElement,
        o = this.name;
      if (typeof t == "string") return t;
      if (_typeof(t) == "object") return t[o];
      if (typeof t == "function") return t(this);
      if (i) {
        var n = i.getAttribute("aria-label");
        if (n) return n;
      }
      return e("Rich Text Editor. Editing area: %0", o);
    }
  }]);
}(As);
var mo = /*#__PURE__*/function (_h39) {
  function mo(e) {
    var _this131;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, mo);
    _this131 = _callSuper(this, mo, [e]);
    _defineProperty(_this131, "children", void 0);
    var i = _this131.bindTemplate;
    _this131.set("class", ["ck", "ck-form__row"].concat(_toConsumableArray(oe(t.class || [])))), _this131.children = _this131.createCollection(), t.children && t.children.forEach(function (o) {
      return _this131.children.add(o);
    }), _this131.set("_role", null), _this131.set("_ariaLabelledBy", null), t.labelView && _this131.set({
      _role: "group",
      _ariaLabelledBy: t.labelView.id
    }), _this131.setTemplate({
      tag: "div",
      attributes: {
        class: i.to("class", function (o) {
          return o.join(" ");
        }),
        role: i.to("_role"),
        "aria-labelledby": i.to("_ariaLabelledBy")
      },
      children: _this131.children
    });
    return _this131;
  }
  _inherits(mo, _h39);
  return _createClass(mo);
}(h);
var wo = /*#__PURE__*/function (_Mt) {
  function wo() {
    _classCallCheck(this, wo);
    return _callSuper(this, wo, arguments);
  }
  _inherits(wo, _Mt);
  return _createClass(wo, [{
    key: "init",
    value: function init() {
      this.on("show:warning", function (e, t) {
        window.alert(t.message);
      }, {
        priority: "lowest"
      });
    }
  }, {
    key: "showSuccess",
    value: function showSuccess(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this._showNotification({
        message: e,
        type: "success",
        namespace: t.namespace,
        title: t.title
      });
    }
  }, {
    key: "showInfo",
    value: function showInfo(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this._showNotification({
        message: e,
        type: "info",
        namespace: t.namespace,
        title: t.title
      });
    }
  }, {
    key: "showWarning",
    value: function showWarning(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this._showNotification({
        message: e,
        type: "warning",
        namespace: t.namespace,
        title: t.title
      });
    }
  }, {
    key: "_showNotification",
    value: function _showNotification(e) {
      var t = e.namespace ? "show:".concat(e.type, ":").concat(e.namespace) : "show:".concat(e.type);
      this.fire(t, {
        message: e.message,
        type: e.type,
        title: e.title || ""
      });
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "Notification";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(Mt);
var bo = /*#__PURE__*/function (_se3) {
  function bo(e, t) {
    var _this132;
    _classCallCheck(this, bo);
    _this132 = _callSuper(this, bo), t && Jt(_assertThisInitialized(_this132), t), e && _this132.set(e);
    return _this132;
  }
  _inherits(bo, _se3);
  return _createClass(bo);
}(se());
var $ = te("px");
var go = /*#__PURE__*/function (_we3) {
  function go(e) {
    var _this133;
    _classCallCheck(this, go);
    _this133 = _callSuper(this, go, [e]), _defineProperty(_assertThisInitialized(_this133), "positionLimiter", void 0), _defineProperty(_assertThisInitialized(_this133), "visibleStack", void 0), _defineProperty(_assertThisInitialized(_this133), "_viewToStack", new Map()), _defineProperty(_assertThisInitialized(_this133), "_idToStack", new Map()), _defineProperty(_assertThisInitialized(_this133), "_view", null), _defineProperty(_assertThisInitialized(_this133), "_rotatorView", null), _defineProperty(_assertThisInitialized(_this133), "_fakePanelsView", null), _this133.positionLimiter = function () {
      var t = _this133.editor.editing.view,
        o = t.document.selection.editableElement;
      return o ? t.domConverter.mapViewToDom(o.root) : null;
    }, _this133.decorate("getPositionOptions"), _this133.set("visibleView", null), _this133.set("_numberOfStacks", 0), _this133.set("_singleViewMode", !1);
    return _this133;
  }
  _inherits(go, _we3);
  return _createClass(go, [{
    key: "destroy",
    value: function destroy() {
      _superPropGet(go, "destroy", this, 3)([]), this._view && this._view.destroy(), this._rotatorView && this._rotatorView.destroy(), this._fakePanelsView && this._fakePanelsView.destroy();
    }
  }, {
    key: "view",
    get: function get() {
      return this._view || this._createPanelView(), this._view;
    }
  }, {
    key: "hasView",
    value: function hasView(e) {
      return Array.from(this._viewToStack.keys()).includes(e);
    }
  }, {
    key: "add",
    value: function add(e) {
      if (this._view || this._createPanelView(), this.hasView(e.view)) throw new v("contextualballoon-add-view-exist", [this, e]);
      var t = e.stackId || "main";
      if (!this._idToStack.has(t)) {
        this._idToStack.set(t, new Map([[e.view, e]])), this._viewToStack.set(e.view, this._idToStack.get(t)), this._numberOfStacks = this._idToStack.size, (!this._visibleStack || e.singleViewMode) && this.showStack(t);
        return;
      }
      var i = this._idToStack.get(t);
      e.singleViewMode && this.showStack(t), i.set(e.view, e), this._viewToStack.set(e.view, i), i === this._visibleStack && this._showView(e);
    }
  }, {
    key: "remove",
    value: function remove(e) {
      if (!this.hasView(e)) throw new v("contextualballoon-remove-view-not-exist", [this, e]);
      var t = this._viewToStack.get(e);
      this._singleViewMode && this.visibleView === e && (this._singleViewMode = !1), this.visibleView === e && (t.size === 1 ? this._idToStack.size > 1 ? this._showNextStack() : (this.view.hide(), this.visibleView = null, this._rotatorView.hideView()) : this._showView(Array.from(t.values())[t.size - 2])), t.size === 1 ? (this._idToStack.delete(this._getStackId(t)), this._numberOfStacks = this._idToStack.size) : t.delete(e), this._viewToStack.delete(e);
    }
  }, {
    key: "updatePosition",
    value: function updatePosition(e) {
      e && (this._visibleStack.get(this.visibleView).position = e), this.view.pin(this.getPositionOptions()), this._fakePanelsView.updatePosition();
    }
  }, {
    key: "getPositionOptions",
    value: function getPositionOptions() {
      var e = Array.from(this._visibleStack.values()).pop().position;
      return e && (e.limiter || (e = Object.assign({}, e, {
        limiter: this.positionLimiter
      })), e = Object.assign({}, e, {
        viewportOffsetConfig: _objectSpread(_objectSpread({}, this.editor.ui.viewportOffset), {}, {
          top: this.editor.ui.viewportOffset.visualTop
        })
      })), e;
    }
  }, {
    key: "showStack",
    value: function showStack(e) {
      this.visibleStack = e;
      var t = this._idToStack.get(e);
      if (!t) throw new v("contextualballoon-showstack-stack-not-exist", this);
      this._visibleStack !== t && this._showView(Array.from(t.values()).pop());
    }
  }, {
    key: "_createPanelView",
    value: function _createPanelView() {
      this._view = new k(this.editor.locale), this.editor.ui.view.body.add(this._view), this._rotatorView = this._createRotatorView(), this._fakePanelsView = this._createFakePanelsView();
    }
  }, {
    key: "_visibleStack",
    get: function get() {
      return this._viewToStack.get(this.visibleView);
    }
  }, {
    key: "_getStackId",
    value: function _getStackId(e) {
      return Array.from(this._idToStack.entries()).find(function (i) {
        return i[1] === e;
      })[0];
    }
  }, {
    key: "_showNextStack",
    value: function _showNextStack() {
      var e = Array.from(this._idToStack.values());
      var t = e.indexOf(this._visibleStack) + 1;
      e[t] || (t = 0), this.showStack(this._getStackId(e[t]));
    }
  }, {
    key: "_showPrevStack",
    value: function _showPrevStack() {
      var e = Array.from(this._idToStack.values());
      var t = e.indexOf(this._visibleStack) - 1;
      e[t] || (t = e.length - 1), this.showStack(this._getStackId(e[t]));
    }
  }, {
    key: "_createRotatorView",
    value: function _createRotatorView() {
      var _this134 = this;
      var e = new Ds(this.editor.locale),
        t = this.editor.locale.t;
      return this.view.content.add(e), e.bind("isNavigationVisible").to(this, "_numberOfStacks", this, "_singleViewMode", function (i, o) {
        return !o && i > 1;
      }), e.on("change:isNavigationVisible", function () {
        return _this134.updatePosition();
      }, {
        priority: "low"
      }), e.bind("counter").to(this, "visibleView", this, "_numberOfStacks", function (i, o) {
        if (o < 2) return "";
        var n = Array.from(_this134._idToStack.values()).indexOf(_this134._visibleStack) + 1;
        return t("%0 of %1", [n, o]);
      }), e.buttonNextView.on("execute", function () {
        e.focusTracker.isFocused && _this134.editor.editing.view.focus(), _this134._showNextStack();
      }), e.buttonPrevView.on("execute", function () {
        e.focusTracker.isFocused && _this134.editor.editing.view.focus(), _this134._showPrevStack();
      }), e;
    }
  }, {
    key: "_createFakePanelsView",
    value: function _createFakePanelsView() {
      var e = new Ss(this.editor.locale, this.view);
      return e.bind("numberOfPanels").to(this, "_numberOfStacks", this, "_singleViewMode", function (t, i) {
        return !i && t >= 2 ? Math.min(t - 1, 2) : 0;
      }), e.listenTo(this.view, "change:top", function () {
        return e.updatePosition();
      }), e.listenTo(this.view, "change:left", function () {
        return e.updatePosition();
      }), this.editor.ui.view.body.add(e), e;
    }
  }, {
    key: "_showView",
    value: function _showView(_ref24) {
      var e = _ref24.view,
        _ref24$balloonClassNa = _ref24.balloonClassName,
        t = _ref24$balloonClassNa === void 0 ? "" : _ref24$balloonClassNa,
        _ref24$withArrow = _ref24.withArrow,
        i = _ref24$withArrow === void 0 ? !0 : _ref24$withArrow,
        _ref24$singleViewMode = _ref24.singleViewMode,
        o = _ref24$singleViewMode === void 0 ? !1 : _ref24$singleViewMode;
      this.view.class = t, this.view.withArrow = i, this._rotatorView.showView(e), this.visibleView = e, this.view.pin(this.getPositionOptions()), this._fakePanelsView.updatePosition(), o && (this._singleViewMode = !0);
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "ContextualBalloon";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(we);
var Ds = /*#__PURE__*/function (_h40) {
  function Ds(e) {
    var _this135;
    _classCallCheck(this, Ds);
    _this135 = _callSuper(this, Ds, [e]);
    _defineProperty(_this135, "focusTracker", void 0);
    _defineProperty(_this135, "buttonPrevView", void 0);
    _defineProperty(_this135, "buttonNextView", void 0);
    _defineProperty(_this135, "content", void 0);
    var t = e.t,
      i = _this135.bindTemplate;
    _this135.set("isNavigationVisible", !0), _this135.focusTracker = new b(), _this135.buttonPrevView = _this135._createButtonView(t("Previous"), Kt), _this135.buttonNextView = _this135._createButtonView(t("Next"), jt), _this135.content = _this135.createCollection(), _this135.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-balloon-rotator"],
        "z-index": "-1"
      },
      children: [{
        tag: "div",
        attributes: {
          class: ["ck-balloon-rotator__navigation", i.to("isNavigationVisible", function (o) {
            return o ? "" : "ck-hidden";
          })]
        },
        children: [_this135.buttonPrevView, {
          tag: "span",
          attributes: {
            class: ["ck-balloon-rotator__counter"]
          },
          children: [{
            text: i.to("counter")
          }]
        }, _this135.buttonNextView]
      }, {
        tag: "div",
        attributes: {
          class: "ck-balloon-rotator__content"
        },
        children: _this135.content
      }]
    });
    return _this135;
  }
  _inherits(Ds, _h40);
  return _createClass(Ds, [{
    key: "render",
    value: function render() {
      _superPropGet(Ds, "render", this, 3)([]), this.focusTracker.add(this.element);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(Ds, "destroy", this, 3)([]), this.focusTracker.destroy();
    }
  }, {
    key: "showView",
    value: function showView(e) {
      this.hideView(), this.content.add(e);
    }
  }, {
    key: "hideView",
    value: function hideView() {
      this.content.clear();
    }
  }, {
    key: "_createButtonView",
    value: function _createButtonView(e, t) {
      var i = new p(this.locale);
      return i.set({
        label: e,
        icon: t,
        tooltip: !0
      }), i;
    }
  }]);
}(h);
var Ss = /*#__PURE__*/function (_h41) {
  function Ss(e, t) {
    var _this136;
    _classCallCheck(this, Ss);
    _this136 = _callSuper(this, Ss, [e]);
    _defineProperty(_this136, "content", void 0);
    _defineProperty(_this136, "_balloonPanelView", void 0);
    var i = _this136.bindTemplate;
    _this136.set("top", 0), _this136.set("left", 0), _this136.set("height", 0), _this136.set("width", 0), _this136.set("numberOfPanels", 0), _this136.content = _this136.createCollection(), _this136._balloonPanelView = t, _this136.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck-fake-panel", i.to("numberOfPanels", function (o) {
          return o ? "" : "ck-hidden";
        })],
        style: {
          top: i.to("top", $),
          left: i.to("left", $),
          width: i.to("width", $),
          height: i.to("height", $)
        }
      },
      children: _this136.content
    }), _this136.on("change:numberOfPanels", function (o, n, r, a) {
      r > a ? _this136._addPanels(r - a) : _this136._removePanels(a - r), _this136.updatePosition();
    });
    return _this136;
  }
  _inherits(Ss, _h41);
  return _createClass(Ss, [{
    key: "_addPanels",
    value: function _addPanels(e) {
      for (; e--;) {
        var t = new h();
        t.setTemplate({
          tag: "div"
        }), this.content.add(t), this.registerChild(t);
      }
    }
  }, {
    key: "_removePanels",
    value: function _removePanels(e) {
      for (; e--;) {
        var t = this.content.last;
        this.content.remove(t), this.deregisterChild(t), t.destroy();
      }
    }
  }, {
    key: "updatePosition",
    value: function updatePosition() {
      if (this.numberOfPanels) {
        var _this$_balloonPanelVi = this._balloonPanelView,
          _e21 = _this$_balloonPanelVi.top,
          t = _this$_balloonPanelVi.left,
          _T = new T(this._balloonPanelView.element),
          i = _T.width,
          o = _T.height;
        Object.assign(this, {
          top: _e21,
          left: t,
          width: i,
          height: o
        });
      }
    }
  }]);
}(h);
var S = te("px");
var _o = /*#__PURE__*/function (_h42) {
  function _o(e) {
    var _this137;
    _classCallCheck(this, _o);
    _this137 = _callSuper(this, _o, [e]);
    _defineProperty(_this137, "content", void 0);
    _defineProperty(_this137, "contentPanelElement", void 0);
    _defineProperty(_this137, "_contentPanelPlaceholder", void 0);
    var t = _this137.bindTemplate;
    _this137.set("isActive", !1), _this137.set("isSticky", !1), _this137.set("limiterElement", null), _this137.set("limiterBottomOffset", 50), _this137.set("viewportTopOffset", 0), _this137.set("_marginLeft", null), _this137.set("_isStickyToTheBottomOfLimiter", !1), _this137.set("_stickyTopOffset", null), _this137.set("_stickyBottomOffset", null), _this137.content = _this137.createCollection(), _this137._contentPanelPlaceholder = new V({
      tag: "div",
      attributes: {
        class: ["ck", "ck-sticky-panel__placeholder"],
        style: {
          display: t.to("isSticky", function (i) {
            return i ? "block" : "none";
          }),
          height: t.to("isSticky", function (i) {
            return i ? S(_this137._contentPanelRect.height) : null;
          })
        }
      }
    }).render(), _this137.contentPanelElement = new V({
      tag: "div",
      attributes: {
        class: ["ck", "ck-sticky-panel__content", t.if("isSticky", "ck-sticky-panel__content_sticky"), t.if("_isStickyToTheBottomOfLimiter", "ck-sticky-panel__content_sticky_bottom-limit")],
        style: {
          width: t.to("isSticky", function (i) {
            return i ? S(_this137._contentPanelPlaceholder.getBoundingClientRect().width) : null;
          }),
          top: t.to("_stickyTopOffset", function (i) {
            return i && S(i);
          }),
          bottom: t.to("_stickyBottomOffset", function (i) {
            return i && S(i);
          }),
          marginLeft: t.to("_marginLeft")
        }
      },
      children: _this137.content
    }).render(), _this137.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-sticky-panel"]
      },
      children: [_this137._contentPanelPlaceholder, _this137.contentPanelElement]
    });
    return _this137;
  }
  _inherits(_o, _h42);
  return _createClass(_o, [{
    key: "render",
    value: function render() {
      var _this138 = this;
      _superPropGet(_o, "render", this, 3)([]), this.checkIfShouldBeSticky(), this.listenTo(d.document, "scroll", function () {
        _this138.checkIfShouldBeSticky();
      }, {
        useCapture: !0
      }), this.listenTo(this, "change:isActive", function () {
        _this138.checkIfShouldBeSticky();
      }), d.window.visualViewport && (this.listenTo(d.window.visualViewport, "scroll", function () {
        _this138.checkIfShouldBeSticky();
      }), this.listenTo(d.window.visualViewport, "resize", function () {
        _this138.checkIfShouldBeSticky();
      }));
    }
  }, {
    key: "checkIfShouldBeSticky",
    value: function checkIfShouldBeSticky() {
      if (!this.limiterElement || !this.isActive) {
        this._unstick();
        return;
      }
      var e = new T(this.limiterElement);
      var t = e.getVisible();
      if (t) {
        var n = new T(d.window);
        n.top += this.viewportTopOffset, n.height -= this.viewportTopOffset, t = t.getIntersection(n);
      }
      var _K = K(),
        i = _K.left,
        o = _K.top;
      if (e.moveBy(i, o), t && t.moveBy(i, o), t && e.top < t.top) {
        if (this._contentPanelRect.height + this.limiterBottomOffset > t.height) {
          var _n3 = Math.max(e.bottom - t.bottom, 0) + this.limiterBottomOffset;
          this._contentPanelRect.height + _n3 + 1 < e.height ? this._stickToBottomOfLimiter(_n3) : this._unstick();
        } else this._contentPanelRect.height + this.limiterBottomOffset < e.height ? this._stickToTopOfAncestors(t.top) : this._unstick();
      } else this._unstick();
    }
  }, {
    key: "_stickToTopOfAncestors",
    value: function _stickToTopOfAncestors(e) {
      this.isSticky = !0, this._isStickyToTheBottomOfLimiter = !1, this._stickyTopOffset = e, this._stickyBottomOffset = null, this._marginLeft = S(-d.window.scrollX + K().left);
    }
  }, {
    key: "_stickToBottomOfLimiter",
    value: function _stickToBottomOfLimiter(e) {
      this.isSticky = !0, this._isStickyToTheBottomOfLimiter = !0, this._stickyTopOffset = null, this._stickyBottomOffset = e, this._marginLeft = S(-d.window.scrollX + K().left);
    }
  }, {
    key: "_unstick",
    value: function _unstick() {
      this.isSticky = !1, this._isStickyToTheBottomOfLimiter = !1, this._stickyTopOffset = null, this._stickyBottomOffset = null, this._marginLeft = null;
    }
  }, {
    key: "_contentPanelRect",
    get: function get() {
      return new T(this.contentPanelElement);
    }
  }]);
}(h);
var Ms = /*#__PURE__*/function (_W3) {
  function Ms(e) {
    var _this139;
    _classCallCheck(this, Ms);
    _this139 = _callSuper(this, Ms, [e]);
    _defineProperty(_this139, "arrowView", void 0);
    var t = _this139.bindTemplate;
    _this139.set({
      withText: !0,
      role: "menuitem"
    }), _this139.arrowView = _this139._createArrowView(), _this139.extendTemplate({
      attributes: {
        class: ["ck-menu-bar__menu__button"],
        "aria-haspopup": !0,
        "aria-expanded": _this139.bindTemplate.to("isOn", function (i) {
          return String(i);
        }),
        "data-cke-tooltip-disabled": t.to("isOn")
      },
      on: {
        mouseenter: t.to("mouseenter")
      }
    });
    return _this139;
  }
  _inherits(Ms, _W3);
  return _createClass(Ms, [{
    key: "render",
    value: function render() {
      _superPropGet(Ms, "render", this, 3)([]), this.children.add(this.arrowView);
    }
  }, {
    key: "_createArrowView",
    value: function _createArrowView() {
      var e = new L();
      return e.content = ne, e.extendTemplate({
        attributes: {
          class: "ck-menu-bar__menu__button__arrow"
        }
      }), e;
    }
  }]);
}(W);
var Ns = /*#__PURE__*/function (_h43) {
  function Ns(e) {
    var _this140;
    _classCallCheck(this, Ns);
    _this140 = _callSuper(this, Ns, [e]);
    _defineProperty(_this140, "children", void 0);
    var t = _this140.bindTemplate;
    _this140.set("isVisible", !1), _this140.set("position", "se"), _this140.children = _this140.createCollection(), _this140.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-reset", "ck-menu-bar__menu__panel", t.to("position", function (i) {
          return "ck-menu-bar__menu__panel_position_".concat(i);
        }), t.if("isVisible", "ck-hidden", function (i) {
          return !i;
        })],
        tabindex: "-1"
      },
      children: _this140.children,
      on: {
        selectstart: t.to(function (i) {
          i.target.tagName.toLocaleLowerCase() !== "input" && i.preventDefault();
        })
      }
    });
    return _this140;
  }
  _inherits(Ns, _h43);
  return _createClass(Ns, [{
    key: "focus",
    value: function focus() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.children.length && (e === 1 ? this.children.first.focus() : this.children.last.focus());
    }
  }]);
}(h);
var R = /*#__PURE__*/function (_h44) {
  function R(e) {
    var _this141;
    _classCallCheck(this, R);
    _this141 = _callSuper(this, R, [e]);
    _defineProperty(_this141, "buttonView", void 0);
    _defineProperty(_this141, "panelView", void 0);
    _defineProperty(_this141, "focusTracker", void 0);
    _defineProperty(_this141, "keystrokes", void 0);
    var t = _this141.bindTemplate;
    _this141.buttonView = new Ms(e), _this141.buttonView.delegate("mouseenter").to(_this141), _this141.buttonView.bind("isOn", "isEnabled").to(_this141, "isOpen", "isEnabled"), _this141.panelView = new Ns(e), _this141.panelView.bind("isVisible").to(_this141, "isOpen"), _this141.keystrokes = new E(), _this141.focusTracker = new b(), _this141.set("isOpen", !1), _this141.set("isEnabled", !0), _this141.set("panelPosition", "w"), _this141.set("class", void 0), _this141.set("parentMenuView", null), _this141.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-menu-bar__menu", t.to("class"), t.if("isEnabled", "ck-disabled", function (i) {
          return !i;
        }), t.if("parentMenuView", "ck-menu-bar__menu_top-level", function (i) {
          return !i;
        })]
      },
      children: [_this141.buttonView, _this141.panelView]
    });
    return _this141;
  }
  _inherits(R, _h44);
  return _createClass(R, [{
    key: "render",
    value: function render() {
      _superPropGet(R, "render", this, 3)([]), this.focusTracker.add(this.buttonView.element), this.focusTracker.add(this.panelView.element), this.keystrokes.listenTo(this.element), I.closeOnEscKey(this), this._repositionPanelOnOpen();
    }
  }, {
    key: "_attachBehaviors",
    value: function _attachBehaviors() {
      this.parentMenuView ? (I.openOnButtonClick(this), I.openOnArrowRightKey(this), I.closeOnArrowLeftKey(this), I.openAndFocusOnEnterKeyPress(this), I.closeOnParentClose(this)) : (this._propagateArrowKeystrokeEvents(), I.openAndFocusPanelOnArrowDownKey(this), I.toggleOnButtonClick(this));
    }
  }, {
    key: "_propagateArrowKeystrokeEvents",
    value: function _propagateArrowKeystrokeEvents() {
      var _this142 = this;
      this.keystrokes.set("arrowright", function (e, t) {
        _this142.fire("arrowright"), t();
      }), this.keystrokes.set("arrowleft", function (e, t) {
        _this142.fire("arrowleft"), t();
      });
    }
  }, {
    key: "_repositionPanelOnOpen",
    value: function _repositionPanelOnOpen() {
      var _this143 = this;
      this.on("change:isOpen", function (e, t, i) {
        if (!i) return;
        var o = R._getOptimalPosition({
          element: _this143.panelView.element,
          target: _this143.buttonView.element,
          fitInViewport: !0,
          positions: _this143._panelPositions
        });
        _this143.panelView.position = o ? o.name : _this143._defaultMenuPositionName;
      });
    }
  }, {
    key: "focus",
    value: function focus() {
      this.buttonView.focus();
    }
  }, {
    key: "_panelPositions",
    get: function get() {
      var e = vs.southEast,
        t = vs.southWest,
        i = vs.northEast,
        o = vs.northWest,
        n = vs.westSouth,
        r = vs.eastSouth,
        a = vs.westNorth,
        l = vs.eastNorth;
      return this.locale.uiLanguageDirection === "ltr" ? this.parentMenuView ? [r, l, n, a] : [e, t, i, o] : this.parentMenuView ? [n, a, r, l] : [t, e, o, i];
    }
  }, {
    key: "_defaultMenuPositionName",
    get: function get() {
      return this.locale.uiLanguageDirection === "ltr" ? this.parentMenuView ? "es" : "se" : this.parentMenuView ? "ws" : "sw";
    }
  }]);
}(h);
_defineProperty(R, "_getOptimalPosition", me);
var qe = /*#__PURE__*/function (_Ce2) {
  function qe(e) {
    var _this144;
    _classCallCheck(this, qe);
    _this144 = _callSuper(this, qe, [e]), _this144.role = "menu", _this144.items.on("change", _this144._setItemsCheckSpace.bind(_assertThisInitialized(_this144)));
    return _this144;
  }
  _inherits(qe, _Ce2);
  return _createClass(qe, [{
    key: "_setItemsCheckSpace",
    value: function _setItemsCheckSpace() {
      var e = Array.from(this.items).some(function (t) {
        var i = Ye(t);
        return i && i.isToggleable;
      });
      this.items.forEach(function (t) {
        var i = Ye(t);
        i && (i.hasCheckSpace = e);
      });
    }
  }]);
}(Ce);
function Ye(s) {
  return s instanceof P ? s.children.map(function (e) {
    return Ws(e) ? e.buttonView : e;
  }).find(function (e) {
    return e instanceof W;
  }) : null;
}
function Ws(s) {
  return _typeof(s) == "object" && "buttonView" in s && s.buttonView instanceof p;
}
var Gs = /*#__PURE__*/function (_yi) {
  function Gs(e) {
    var _this145;
    _classCallCheck(this, Gs);
    _this145 = _callSuper(this, Gs, [e]), _this145.set({
      withText: !0,
      withKeystroke: !0,
      tooltip: !1,
      role: "menuitem"
    }), _this145.extendTemplate({
      attributes: {
        class: ["ck-menu-bar__menu__item__button"]
      }
    });
    return _this145;
  }
  _inherits(Gs, _yi);
  return _createClass(Gs);
}(yi);
var Qe = ["mouseenter", "arrowleft", "arrowright", "change:isOpen"];
var ko = /*#__PURE__*/function (_h45) {
  function ko(e) {
    var _this146;
    _classCallCheck(this, ko);
    _this146 = _callSuper(this, ko, [e]);
    _defineProperty(_this146, "children", void 0);
    _defineProperty(_this146, "menus", []);
    var t = e.t,
      i = _this146.bindTemplate;
    _this146.set({
      isOpen: !1,
      isFocusBorderEnabled: !1
    }), _this146._setupIsOpenUpdater(), _this146.children = _this146.createCollection(), _this146.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-menu-bar", i.if("isFocusBorderEnabled", "ck-menu-bar_focus-border-enabled")],
        "aria-label": t("Editor menu bar"),
        role: "menubar"
      },
      children: _this146.children
    });
    return _this146;
  }
  _inherits(ko, _h45);
  return _createClass(ko, [{
    key: "fillFromConfig",
    value: function fillFromConfig(e, t) {
      var _this147 = this;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var o = this.locale,
        r = Vs({
          normalizedConfig: e,
          locale: o,
          componentFactory: t,
          extraItems: i
        }).items.map(function (a) {
          return _this147._createMenu({
            componentFactory: t,
            menuDefinition: a
          });
        });
      this.children.addMany(r);
    }
  }, {
    key: "render",
    value: function render() {
      _superPropGet(ko, "render", this, 3)([]), D.toggleMenusAndFocusItemsOnHover(this), D.closeMenusWhenTheBarCloses(this), D.closeMenuWhenAnotherOnTheSameLevelOpens(this), D.focusCycleMenusOnArrows(this), D.closeOnClickOutside(this), D.enableFocusHighlightOnInteraction(this);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.children.first && this.children.first.focus();
    }
  }, {
    key: "close",
    value: function close() {
      var _iterator51 = _createForOfIteratorHelper(this.children),
        _step51;
      try {
        for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
          var _e22 = _step51.value;
          _e22.isOpen = !1;
        }
      } catch (err) {
        _iterator51.e(err);
      } finally {
        _iterator51.f();
      }
    }
  }, {
    key: "disable",
    value: function disable() {
      var _iterator52 = _createForOfIteratorHelper(this.children),
        _step52;
      try {
        for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
          var _e23 = _step52.value;
          _e23.isEnabled = !1;
        }
      } catch (err) {
        _iterator52.e(err);
      } finally {
        _iterator52.f();
      }
    }
  }, {
    key: "enable",
    value: function enable() {
      var _iterator53 = _createForOfIteratorHelper(this.children),
        _step53;
      try {
        for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
          var _e24 = _step53.value;
          _e24.isEnabled = !0;
        }
      } catch (err) {
        _iterator53.e(err);
      } finally {
        _iterator53.f();
      }
    }
  }, {
    key: "registerMenu",
    value: function registerMenu(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      t ? (e.delegate.apply(e, Qe).to(t), e.parentMenuView = t) : e.delegate.apply(e, Qe).to(this, function (i) {
        return "menu:" + i;
      }), e._attachBehaviors(), this.menus.push(e);
    }
  }, {
    key: "_createMenu",
    value: function _createMenu(_ref25) {
      var _this148 = this;
      var e = _ref25.componentFactory,
        t = _ref25.menuDefinition,
        i = _ref25.parentMenuView;
      var o = this.locale,
        n = new R(o);
      return this.registerMenu(n, i), n.buttonView.set({
        label: t.label
      }), n.once("change:isOpen", function () {
        var r = new qe(o);
        r.ariaLabel = t.label, n.panelView.children.add(r), r.items.addMany(_this148._createMenuItems({
          menuDefinition: t,
          parentMenuView: n,
          componentFactory: e
        }));
      }), n;
    }
  }, {
    key: "_createMenuItems",
    value: function _createMenuItems(_ref26) {
      var e = _ref26.menuDefinition,
        t = _ref26.parentMenuView,
        i = _ref26.componentFactory;
      var o = this.locale,
        n = [];
      var _iterator54 = _createForOfIteratorHelper(e.groups),
        _step54;
      try {
        for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
          var r = _step54.value;
          var _iterator55 = _createForOfIteratorHelper(r.items),
            _step55;
          try {
            for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
              var a = _step55.value;
              var l = new Et(o, t);
              if (Z(a)) l.children.add(this._createMenu({
                componentFactory: i,
                menuDefinition: a,
                parentMenuView: t
              }));else {
                var c = this._createMenuItemContentFromFactory({
                  componentName: a,
                  componentFactory: i,
                  parentMenuView: t
                });
                if (!c) continue;
                l.children.add(c);
              }
              n.push(l);
            }
          } catch (err) {
            _iterator55.e(err);
          } finally {
            _iterator55.f();
          }
          r !== e.groups[e.groups.length - 1] && n.push(new ye(o));
        }
      } catch (err) {
        _iterator54.e(err);
      } finally {
        _iterator54.f();
      }
      return n;
    }
  }, {
    key: "_createMenuItemContentFromFactory",
    value: function _createMenuItemContentFromFactory(_ref27) {
      var _this149 = this;
      var e = _ref27.componentName,
        t = _ref27.parentMenuView,
        i = _ref27.componentFactory;
      var o = i.create(e);
      return o instanceof R || o instanceof dt || o instanceof Gs ? (this._registerMenuTree(o, t), o.on("execute", function () {
        _this149.close();
      }), o) : (C("menu-bar-component-unsupported", {
        componentName: e,
        componentView: o
      }), null);
    }
  }, {
    key: "_registerMenuTree",
    value: function _registerMenuTree(e, t) {
      if (!(e instanceof R)) {
        e.delegate("mouseenter").to(t);
        return;
      }
      this.registerMenu(e, t);
      var i = e.panelView.children.filter(function (n) {
        return n instanceof qe;
      })[0];
      if (!i) {
        e.delegate("mouseenter").to(t);
        return;
      }
      var o = i.items.filter(function (n) {
        return n instanceof P;
      });
      var _iterator56 = _createForOfIteratorHelper(o),
        _step56;
      try {
        for (_iterator56.s(); !(_step56 = _iterator56.n()).done;) {
          var n = _step56.value;
          this._registerMenuTree(n.children.get(0), e);
        }
      } catch (err) {
        _iterator56.e(err);
      } finally {
        _iterator56.f();
      }
    }
  }, {
    key: "_setupIsOpenUpdater",
    value: function _setupIsOpenUpdater() {
      var _this150 = this;
      var e;
      this.on("menu:change:isOpen", function (t, i, o) {
        clearTimeout(e), o ? _this150.isOpen = !0 : e = setTimeout(function () {
          _this150.isOpen = Array.from(_this150.children).some(function (n) {
            return n.isOpen;
          });
        }, 0);
      });
    }
  }]);
}(h);
export { io as AccessibilityHelp, k as BalloonPanelView, _ as BodyCollection, fo as BoxedEditorUIView, ut as ButtonLabelView, p as ButtonView, oo as CollapsibleView, Me as ColorGridView, ts as ColorPickerView, ho as ColorSelectorView, mt as ColorTileView, as as ComponentFactory, go as ContextualBalloon, eo as CssTransitionDisablerMixin, ys as DefaultMenuBarItems, y as Dialog, ve as DialogView, g as DialogViewPosition, ns as DocumentColorCollection, Si as DropdownButtonView, Di as DropdownPanelView, ee as DropdownView, uo as EditorUI, Fs as EditorUIView, so as FileDialogButtonView, yi as FileDialogListItemButtonView, N as FocusCycler, pi as FormHeaderView, mo as FormRowView, L as IconView, po as InlineEditableUIView, Ai as InputNumberView, Fi as InputTextView, gt as InputView, re as LabelView, Pi as LabeledFieldView, W as ListItemButtonView, X as ListItemGroupView, P as ListItemView, ye as ListSeparatorView, Ce as ListView, dt as MenuBarMenuListItemButtonView, Gs as MenuBarMenuListItemFileDialogButtonView, Et as MenuBarMenuListItemView, qe as MenuBarMenuListView, R as MenuBarMenuView, ko as MenuBarView, wo as Notification, Ui as SplitButtonView, _o as StickyPanelView, ft as SwitchButtonView, V as Template, Ni as ToolbarLineBreakView, _t as ToolbarSeparatorView, Hi as ToolbarView, m as TooltipManager, h as View, B as ViewCollection, bo as ViewModel, fi as addKeyboardHandlingForGrid, lo as addListToDropdown, kt as addToolbarToDropdown, ht as clickOutsideHandler, Ve as createDropdown, co as createLabeledDropdown, ao as createLabeledInputNumber, Ji as createLabeledInputText, Tt as focusChildOnDropdownOpen, no as getLocalizedColorOptions, z as isFocusable, mi as isViewWithFocusCycler, ro as normalizeColorOptions, Cs as normalizeMenuBarConfig, Vi as normalizeSingleColorDefinition, Gi as normalizeToolbarConfig, to as submitHandler };